import { Component, HostListener, OnInit, SecurityContext, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { SalesOrderService } from "./sales-order.service";
import { AppMainComponent } from "../../app.main.component";
import { MenuItem } from "primeng/api";
import { ConfirmationService, MessageService } from "primeng/api";
import { Status, EstimateNewStatus, SalesOrderStatus, InvoiceStatus, } from "../constants/constants";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { AccountUserService } from "src/app/service/account.service";
import { DatePipe } from "@angular/common";
import { ShippingmethodService } from "src/app/configurations/inventory/setup/shippingmethod/shippingmethod.service";
import { ProductsService } from "../products/products.service";
import { ConfigurationService } from "src/app/configurations/configurationService";
import { Severity } from "../constants/constants";
import { TitleCasePipe } from "@angular/common";
import { uploadFiles, validateFiles } from "src/app/shared/upload-files";
import data from "../staticJSON/settings-column.json";
import { OrdersService } from "src/app/configurations/inventory/orders/orders.service";
import * as _ from "lodash";
import { AppMainService } from "src/app/app-main.service";
import { ObjectTaskService } from "src/app/shared/api/api";
import { Task } from "src/app/shared/model/models";
import { Location } from "@angular/common";
import { SOChannel, DialogType, PrintType, SoStageId, TypeIds, SOEmailAttachmentType, RecentItems, SalesOrderFilterItems, InvoicingFilterItems, CreditMemoFilterItems, CreditByNameCols, ReturnsByNameCols, InvoicingTypes, InvoicingByNameCols, OrdersByNameCols, EstimatesByNameCols, AddrTypeDD, AddressTemp, CustomersByNameCols, CustomerTemp, SOObjectNames, SearchColumns, EstimateFilterColumns, SoFilterColumns, InvoiceFilterColumns, CrediMemoFilterColumns, accCreditMsg, CustomerReturnFilterItems, RmaStatus, CustomerReturnFilterColumns, SOEmailType, ACC_OBJ_ID, ApprovalStatus, accHoldMsg, TabHeaderConst } from "./constants/constants";
import { ActivatedRoute, Router } from "@angular/router";
import { debounceTime, distinctUntilChanged, takeUntil } from "rxjs/operators";
import { DomSanitizer } from "@angular/platform-browser";
import { ShippingService } from "src/app/configurations/integration/shipping/shipping.service";
import { UtilityService } from "./utils/utility.service";
import { InvoicePdfComponent } from "./shared/invoice-pdf/invoice-pdf.component";
import { SoStageChangeService } from "./services/so-stage-change.service";
import { SoShipmentService } from "./services/so-shipment.service";
import { ITermsConditions } from "src/app/configurations/inventory/orders/models/terms-conditions";
import { SharedChannelService } from "src/app/modules/shared/services/channel.service";
import { AccountModuleId } from "src/app/modules/shared/constants/modules.constant";
import { ChannelN } from "src/app/modules/shared/models/channel.model";
import { Subject, lastValueFrom } from "rxjs";
import { SettingService } from "src/app/configurations/inventory/setting/setting.service";
import { EmailModel } from "./models/email.model";
import { SoEmailContentBuilderService } from "./services/so-email-content-builder.service";
import { ReceivePaymentDialogType } from "src/app/modules/shared/components/receive-payments/constants/constants";
import { ImportserialService } from "src/app/modules/shared/services/importserial.service";
import { OrderSectionsService } from "src/app/modules/shared/services/order-section.service";
import { SoPdfComponent } from "src/app/modules/shared/components/so-pdf/so-pdf.component";
import { ReturnPrintEmailComponent } from "./shared/return-print-email/return-print-email.component";
import { CreditControlEnum } from "src/app/models/statusEnums";
import { AccountsTransactionType, TransactionNames } from "src/app/finance/constants/constants";
import { ClosingYearDisplayMessages } from "src/app/finance/constants/closing-year.constant";
import { MulticurrencyPipe } from "src/app/modules/shared/pipes/multicurrency.pipe";
import { PermissionService } from "src/app/service/permission.service";
import { ObjectNames } from "src/app/shared/constants";
import { TabView } from "primeng/tabview";
import { FilterInColumn } from "src/app/accounts-v2/models/account-request.model";
import { SalesReceiptPdfComponent } from "src/app/sales-receipt-pdf/sales-receipt-pdf.component";
import { SavedFilterData } from "src/app/modules/shared/models/filter.model";
import { TimeZoneService } from "src/app/modules/shared/services/timezone.service";
import { SalesReceiptFilterNS, SalesReceiptGroupRequestModel, SalesReceiptRequestModel } from "./models/sales-receipt.model";
import { OverlayPanel } from "primeng/overlaypanel";

@Component({
    selector: "app-sales-order",
    templateUrl: "./sales-order.component.html",
    styleUrls: ["./sales-order.component.scss"],
    providers: [ConfirmationService, DatePipe],
})
export class SalesOrderComponent implements OnInit {
    @ViewChild(InvoicePdfComponent) invoicePrint: InvoicePdfComponent;
    @ViewChild(SoPdfComponent) soPdf: SoPdfComponent;
    @ViewChild(ReturnPrintEmailComponent) returnPrint: ReturnPrintEmailComponent;
    @ViewChild(SalesReceiptPdfComponent) srPdf: SalesReceiptPdfComponent;
    @ViewChild('detailTab') tabView: TabView;
    @ViewChild('columnFilter') columnFilter: OverlayPanel;
    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    //floatheader
    showFloatHeader: boolean = false;
    navFixed: boolean = false;
    private scrollOffset: number = 60;

    // email
    emailAttachments;
    displayNewEmail = false;
    emailFrom = "";
    emailCC = "";
    emailBCC = "";
    emailDialogHeader = "";
    emailContent = "";
    emailSubject = "";
    emailTo = "";

    emailData: EmailModel = {
        emailDialogHeader: "",
        emailContent: "",
        emailSubject: "",
        emailTo: "",
        emailAttachments: [],
    };

    globalSearchData = [];
    fromGlobalSearch: boolean = false;
    soChannel = SOChannel;
    isShowSideBtn = true;

    // void
    isEstimateVoid = false;
    showEstimateVoidMsg: boolean = false;
    isOrderVoid = false;
    showOrderVoidMsg: boolean = false;
    isInvoicingVoid = false;
    showInvoicingVoidMsg: boolean = false;
    isCreditVoid = false;
    showCreditVoidMsg: boolean = false;
    accHoldMsg : string = '';
    menuItems;
    // orderTypes = [];
    selectedChannel = null;
    searchValue: string = "";
    globalFilterInput = "";
    selectedView;

    recentItems = RecentItems;
    selectedRecent = this.recentItems[0];
    salesOrderFilterItems = SalesOrderFilterItems;
    selectedRecentSOFilter = this.salesOrderFilterItems[0];
    invoicingFilterItems = InvoicingFilterItems;
    selectedRecentInvoiceFilter = this.invoicingFilterItems[0];
    customerReturnFilterItems = CustomerReturnFilterItems;
    selectedRecentCustomerReturnFilter = this.customerReturnFilterItems[0];
    creditMemoFilterItems = CreditMemoFilterItems;
    selectedRecentCreditMemoFilter = this.creditMemoFilterItems[0];

    //stages
    productsStepBar = false;
    allStages = [];
    returnStages = [];
    selectedStep;
    shippedStagePickColumn = false;

    // customers
    customersData = [];
    allCustomers = [];
    allCustomersData = [];
    customersCols = [];
    customersCols2 = [];
    customersColsAll = [];
    customersColsAllTemp = [];
    selectedCustomer;
    selectedCustomer2;
    filteredCustomers = [];
    customersByNameCols = CustomersByNameCols;
    configMenuItemsCustomer;
    customerHeader;
    displayCustomerAdd = false;
    showAccountInfoMore: boolean = false;
    customerTemp = CustomerTemp;
    addressTemp = AddressTemp;
    addrTypeDD = AddrTypeDD;
    selectedaddrType;
    displayAddressAdd = false;
    addressHeader;
    selectedAddress;
    categories = [];
    selectedCategory;
    timeZoneList: Array<any> = [];
    currencyList: Array<any> = [];
    selectedTimezone;
    selectedCurrency;
    employees = [];
    revenues = [];
    ownerships = [];
    classification = [];
    industries = [];
    allShippingMethods: any[] = [];
    allShippingMethodDropdown: any[] = [];

    //estimates
    allEstimates = [];
    estimatesData = [];
    soCols = [];
    estimatesCols = [];
    estimatesCols2 = [];
    estimatesColsAll = [];
    estimatesColsAllTemp = [];
    estimatesByNameCols = EstimatesByNameCols;
    selectedEstimate;
    selectedCustomerReturn;
    filteredEstimates = [];
    estimateHeader;
    estimateDialogType: string = DialogType.CREATE;
    displayEstimateAdd = false;
    estStatusDD = [];

    pageSize: number = 15;
    pageNumber: number = 1;
    filters: string;
    accountsList = [];
    rowGroupMetadata: any;

    subTotal = 0;
    tax = 0;
    discount = 0;
    orderTotal = 0;
    discounts = [];
    discountOption = 0;
    selectedExpirationDate;
    locationDD = [];
    selectedLocation;

    //Sales Orders
    allOrders = [];
    ordersData = [];
    ordersCols = [];
    ordersCols2 = [];
    ordersColsAll = [];
    ordersColsAllTemp = [];
    ordersByNameCols = OrdersByNameCols;
    selectedOrder;
    filteredOrders = [];
    orderHeader;
    displayOrderAdd = false;
    displayConvertToSalesOrder = false;
    ordersCustomer;
    orderStage;
    orderStatusDD = [];
    selectedOrderStatus;
    allStatus = [];
    isFullyReceived = false;
    displayReceivedPO = false;
    displayChangeStage = false;
    displayBackOrderOptions = false;
    newStage;
    newStageName;
    triangle = "fa fa-caret-down";
    minimumDate = new Date();
    colorSample = "#FF0000";
    displayStatus = false;
    statusTB = [];
    selectedStatus;
    displayBackOrderOption = false;
    selectedBackOrderOption = 0;

    // common data for all table
    soData = [];
    selectedRowData;

    //customer returns
    customerReturnDetails;

    // credit memo
    creditMemoDialogType = "";
    displayCreditMemoAdd = false;
    creditMemoDialogHeader = "";
    creditMemoDetails;
    creditMemoDetailsContactInfo;
    creditMemoDetailsPurchaseList = [];
    creditByNameCols = CreditByNameCols;
    creditHeader;
    displayCreditAdd = false;
    creditMemoTransactions = [];
    netAppliedAmount = 0;

    //invoicing
    invoicingData = [];
    invoicingData2 = [];
    invoicingCols = [];
    invoicingColsAll = [];
    invoicingColsAllTemp = [];
    invoicingByNameCols = InvoicingByNameCols;
    invoicingDetails;
    invoicingDetailsPurchaseList = [];
    selectedInvoicing;
    selectedInvoicing2;
    filteredInvoicing = [];
    invoicingHeader;
    invoicingDialogType = "";
    displayInvoicingAdd = false;
    displayInvoicingDetails = false;
    invoicingTypes = InvoicingTypes;
    selectedInvoicingType;
    displayInvoiceReceive = false;
    maxDate = new Date();

    //Customer returns
    allReturns = [];
    allReturnsData = [];
    returnsData = [];
    returnsCols = [];
    returnsCols2 = [];
    returnsColsAll = [];
    returnsColsAllTemp = [];
    selectedReturn;
    filteredReturns = [];
    returnsByNameCols = ReturnsByNameCols;
    returnTemp = {
        id: 0,
        name: "",
        itemNo: "",
        isActive: "yes",
        description: "",
    };
    returnDialogType = "";
    returnDialogHeader = "";
    displayReturnAdd = false;

    // configMenuItems;
    configMenuItemsCM;
    configMenuItemsOrders;
    configMenuItemsInvoicing;
    configMenuItemsPayments;
    configMenuItemsReturns;
    configMenuItemsSalesReceipt;
    configMenuItemsCredit;
    closingDateModuleName : string = "" ;
    statementMessage : string = "" ;
    closingDate : any ;
    tempCols;
    tempCols2;
    selectedId;
    displaySettings = false;
    showAddMore = false;
    maxNo = false;
    maxNo2 = false;
    maxNo3 = false;
    estimeatesTotalSelectedAmt = 0;
    totalAmt2 = 0;
    totalAmt3 = 0;
    tab;
    tab1: any;
    tab2: any;
    tab3: any;
    tab4: any;
    tab5: any;
    showDiv = {
        stepsbar: false,
        views: false,
        collists: false,
        config: false,
        details: false,
    };
    oganizationGroups = [];
    categoryGroups = [];
    purchaseListTB = [];
    noCaseFindOrLoadingText = "Loading....";
    searchColumns = "";
    sortBy = "";
    isAscending = "false";
    showPickColumn = false;
    orderChannels = [];
    configuration;
    settingConfig;
    settingColumns;
    historyCols = [];
    totalRecord: number = 0;

    templates = [];
    estimateTemplates = [];
    customerReturnTemplates = [];
    allSections = [];
    estimatesSections = [];
    customerReturnsSections = [];
    options: any = {};
    vendorMessage = "";
    memo = "";
    estimatesDetails;
    estimatesDetailsTemplates;
    estimatesDetailsCustomFields;
    estimatesDetailsPurchaseList = [];
    soDetailsTemplates;
    soDetailsCustomFields;
    invoiceDetailsTemplates;
    invoiceDetailsCustomFields;
    cmDetailsTemplates;
    cmDetailsCustomFields;
    salesReceiptsTemplate
    srDetailsCustomFields;

    returnDetailsTemplates;
    returnDetailsCustomFields;

    allModules = [];
    orderObjId;
    estimateObjectId;
    salesObjectId;
    invoiceObjectId;
    customerRmaObjectId;
    creditMemoObjectId;
    salesReceiptObjectId;
    salesReceiptModuleId;

    salesOrderDetails;
    salesOrderDetailsShippingAddress;
    salesOrderDetailsContactInfo;
    saleOrdersDetailsPurchaseList = [];

    configCustomFields = [];
    allowedExtensions = [".png", ".jpg", ".jpeg", ".gif"]; // For the attachment files
    settingsName = "Settings";
    isVisibleTax = true;
    stageComment = "";
    salesOrderActivityLogs = [];
    reloadSystemLogs = false;

    displayCommentAdd: boolean = false;
    tempComment;
    nextStageIdForUpdate;
    commentFormType;
    commentHeaderName;
    commentDefault = {
        id: "",
        createdSource: this.app.user.userIP,
        updatedSource: this.app.user.userIP,
        createdBy: this.app.user.userId,
        updatedBy: this.app.user.userId,
        createdDate: new Date(),
        updatedDate: new Date(),
        organizationId: this.app.user.organizationId,
        objectRecordId: "",
        objectId: this.app.preLoadedObjects.find((obj) => obj.name == SOObjectNames.SalesOrder)?.id,
        comment: "",
        isPublic: true,
        stageId: 0,
        statusId: Status.Active,
        isPublicOption: {
            label: "Public",
            value: true,
        },
    };
    items: MenuItem[] = [];
    currentComment;
    salesOrderDialogType = "";
    combinedCustomFields = {
        billing_address_item: [],
        shipping_address_item: [],
        misc_item: [],
        section_item: [],
        footer_item: [],
        message_item: [],
        other1_item: [],
        other2_item: [],
        other3_item: [],
    };

    invoiceDetails;
    invoiceRecievedPayments = [];
    salesOrderRecievedPayments = [];
    isEnabledBackOrder: boolean = false;
    isEnabledBackOrderKit: boolean = false;
    isEnabledBackOrderBundle: boolean = false;
    allShipStagesInvoice = [];
    selectedRPO;
    selectedBundle;

    // test common product
    displayProductSelectionModal = false;
    moduleName: string = SOChannel.ESTIMATES;
    isVisibleLocation = false;
    selectedLocationId = 0;
    headerText = "Products List";

    // activity logs
    displayActivityTaskAdd = false;
    displayActivityEventAdd = false;
    displayActivityEmailAdd = false;
    displayActivityLogAdd = false;
    displayActivityNoteAdd = false;
    autoResize = true;

    // common custom attributes
    allCustomAttributes = [];
    customAtributes = {
        billing_address_item: [],
        shipping_address_item: [],
        misc_item: [],
        section_item: [],
        footer_item: [],
        message_item: [],
        other1_item: [],
        other2_item: [],
        other3_item: [],
    };
    overviewCustomAttributes;
    billingAddressContact;
    shippingAddressContact;
    footerDiscountEnabled;
    allDiscounts = [];
    footerTaxEnabled;
    // allTax = [];
    vendorFedexInfo;
    fedexAccountInfo;
    allVendors = [];
    allFedexAccounts = [];
    allUpsAccounts = [];
    vendorUpsInfo;

    tableShowMore: number[] = [15, 30, 50, 100];
    first: number = 0;
    billingAddressType;
    shippingAddressType;
    freeShippingObj;

    //Pricebook
    // aggregateDiscount: boolean = false;
    pricebookConfig: boolean = false;
    isActive: boolean = true;
    searchControl = new FormControl();
    accountChannels = [];
    selectedOrdersStageId;
    receivePaymentDialogType = "";

    estimateTerm: ITermsConditions;
    soTerm: ITermsConditions;
    invoiceTerm: ITermsConditions;
    creditMemoTerm: ITermsConditions;

    soObjectNames = SOObjectNames;
    selectedAccChannel;
    filterInColumns = []
    selectableColumns = []
    sortFlag: boolean = true;
    sortCol: string = '';
    //Filters and Group By
    appliedFilterColName: string[] = [];
    disabledLabelNames: string[] = [];
    selectedGroupByValue: any = null;
    selectedGroupBy: any = null;
    filteredColumns: string[] = [];
    saveFilterData: SavedFilterData;
    displaySRDetails : boolean = false;
    salesReceiptsData = [];
    salesReceiptsByIdList = [];
    salesReceiptsCols = [];
    invoiceCols = [];
    groupAllExpanded: boolean = false;
    isSRpdf :boolean = false
    orgHeadOfficeAddress;
    companyInfo;
    soStage = SoStageId;
    isAvailableEnoughAccCredit = true;

    //tracking
    bulkImportAvailble: boolean = false;
    disabledSave: boolean = false;
    displayImport: boolean = false;
    importCount: number = 0;
    warehouseId: number = 0;
    productList = [];
    trackingOptions = [];
    systemTrackingData = [];
    serialConfig;
    accObjectId = ACC_OBJ_ID;
    curCol: any;
    returnFilterInput = new FormControl();
    columnFilterInput$: Subject<any> = new Subject<any>();

    isAutoPick: boolean = false;
    isAutoPack: boolean = false;
    isOrderToBeShipped: boolean = false;
    displayAccountViewEdit: boolean = false;
    selectedAccountId: number;
    selectedAccountChannelId: number;

    detailsViewSettingsFor = [SOChannel.INVOICING, SOChannel.SALES_ORDER, SOChannel.CREDIT_MEMO,SOChannel.SALES_RECEIPT];
    receivedPaymentId;

    /** Write check */
    checkId = 0;
    checkDialogType = "VIEW";
    displayWriteCheck = false;

    // fraction digits
    fractionDigits: number = 0;

    // currency
    baseCurrency: any;
    orgCurrency=[];

    //Permission
    glTabPermission: boolean = false;
    activeIndex: number = 0;
    TabHeaderConst = TabHeaderConst;

    transactionTypeIds = AccountsTransactionType;
    glApiCall: boolean = false;
    selectedRowAccountId: number = 0;
    isAllowPostingPeriod: boolean = false;
    constructor(
        public app: AppMainComponent,
        private confirmationService: ConfirmationService,
        private messageService: MessageService,
        private salesOrderService: SalesOrderService,
        public datepipe: DatePipe,
        private shippingMethodService: ShippingmethodService,
        private productsService: ProductsService,
        private service: ConfigurationService,
        private titlecasePipe: TitleCasePipe,
        private ordersService: OrdersService,
        private appMainService: AppMainService,
        private objectTaskService: ObjectTaskService,
        private route: ActivatedRoute,
        private router: Router,
        private sanitizer: DomSanitizer,
        private accountUserService: AccountUserService,
        private shippingService: ShippingService,
        private utilityService: UtilityService,
        private soStageChangeService: SoStageChangeService,
        private soShipmentService: SoShipmentService,
        private sharedChannelService: SharedChannelService,
        private configurationService: ConfigurationService,
        private settingService: SettingService,
        private _location: Location,
        private soEmailContentBuilderService: SoEmailContentBuilderService,
        private datePipe: DatePipe,
        private importService: ImportserialService,
        private orderSectionsService: OrderSectionsService,
        private multiCurrency: MulticurrencyPipe,
        private permissionService: PermissionService ,
        private timeZoneService: TimeZoneService,
    ) { }

    ngOnInit() {
        this.getFractionDigits();
        this.getBaseCurrency();
        switch (this.router.url) {
            case "/estimates":
                this.filterSelectedChannel("Estimates", this.router.url);
                break;
            case "/sales-order":
                this.filterSelectedChannel("Sales Order", this.router.url);
                break;
            case "/invoicing":
                this.filterSelectedChannel("Invoicing", this.router.url);
                break;
            case "/credit-memo":
                this.filterSelectedChannel("Credit Memo", this.router.url);
                break;
            case "/sales-receipt":
                this.filterSelectedChannel("Sales Receipt", this.router.url);
                break;
            default:
                this.filterSelectedChannel("Customer Returns", this.router.url);
        }
        this.salesOrderService.loadTrackingOptions().pipe().subscribe((options) => {
            this.trackingOptions = options;
          });
        this.allModules = this.app.preLoadedObjects.filter((obj) => obj.name == "Orders");
        this.orderObjId = this.allModules.find((el) => el.name == "Orders")?.id;
        this.estimateObjectId = this.app.preLoadedObjects.find((obj) => obj.name == SOObjectNames.Estimate)?.id;
        this.salesObjectId = this.app.preLoadedObjects.find((obj) => obj.name == SOObjectNames.SalesOrder)?.id;
        this.invoiceObjectId = this.app.preLoadedObjects.find((obj) => obj.name == SOObjectNames.Invoice)?.id;
        this.customerRmaObjectId = this.app.preLoadedObjects.find((obj) => obj.name == SOObjectNames.CustomerReturns)?.id;
        this.creditMemoObjectId = this.app.preLoadedObjects.find((obj) => obj.name == SOObjectNames.CreditMemo)?.id;
        this.salesReceiptObjectId = this.app.preLoadedObjects.find((obj) => obj.name == SOObjectNames.RECEIVE_PAYMENT)?.id;
        this.salesReceiptModuleId = JSON.parse(localStorage.getItem('userPermissions')).find((p) => p.objectName == SOObjectNames.RECEIVE_PAYMENT)?.objectId;
        this.search();
        this.setupColumnFilterSubscription();
        this.getAllDiscounts();
        this.getAllITermsConditions();
        this.getAllAddressTypes();
        this.getOrganizationBranchesByOrgId();
        this.loadISettings();

        this.appMainService.isShowSpinner("loadAllTemplates");
        this.salesOrderService.getAllOrdersChannel("Orders Template").subscribe((configs) => {
            this.templates = JSON.parse(configs.configurationDetails[0].configJSONValue);
            this.appMainService.isHideSpinner("loadAllTemplates");
            this.getModules();
            this.getAccountChannels(AccountModuleId);
            this.loadSections("Order Section");
            this.getAllCustomAttributes();
            this.buildMenu();
            this.getAllGroup();
            this.loadShippingMethod();
            this.getOrderChannels("Orders Type");
        });

        //todo remove after impl
        this.buildStaticCols();
        this.loadPermissionForGLTab();
    }

    getFractionDigits() {
        this.importService
            .getDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (value) => {
                    if(value){
                        this.fractionDigits = value;
                    }
                },
                error: (error) => {},
            });
    }
    getBaseCurrency() {
        this.importService.getOrgCurrency()
        .pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe(value => {
            if(value){
              this.baseCurrency = value.find(cr=> cr.isBaseCurrency);
              this.orgCurrency = value;
            }
          });
    }

    getSubMenuPermissions(menu: string): boolean{
        const userPermissions = JSON.parse(localStorage.getItem('userPermissions'));
        const menuPermission = userPermissions?.find((p) => p.objectName == menu && p.permissions.some(permission => permission.statusId === 1));
        return !!menuPermission
    }

    @HostListener('window:scroll')
    onWindowScroll() {
        this.navFixed = (window.pageYOffset
            || document.documentElement.scrollTop
            || document.body.scrollTop || 0
        ) > this.scrollOffset;
    }

    loadISettings() {
        this.appMainService.isShowSpinner("loadISettings");
        this.settingService.getAllInventorySettings().subscribe((settings) => {
            this.utilityService.setISettings(settings);
            const iSettings = this.utilityService.getISettings();
            this.isAllowPostingPeriod = iSettings?.find((obj) => obj.code === "posting")?.enabled ?? false;
            this.appMainService.isHideSpinner("loadISettings");
        });
    }

    getAllITermsConditions(): void {
        this.appMainService.isShowSpinner("loadTerms");
        this.ordersService.getAllITermsConditions().subscribe(
            (res: ITermsConditions[]) => {
                this.estimateTerm = res?.filter((t) => t?.objectId == this.estimateObjectId)[0];
                this.soTerm = res?.filter((t) => t?.objectId == this.salesObjectId)[0];
                this.invoiceTerm = res?.filter((t) => t?.objectId == this.invoiceObjectId)[0];
                this.creditMemoTerm = res?.filter((t) => t?.objectId == this.creditMemoObjectId)[0];
                this.appMainService.isHideSpinner("loadTerms");
            },
            (error) => {
                this.appMainService.isHideSpinner("loadTerms");
                this.messageService.add({
                    severity: Severity.Error,
                    summary: this.titlecasePipe.transform(Severity.Error),
                    detail: "Error occurred...",
                });
            },
        );
    }

    async getOrganizationBranchesByOrgId() {
        const org = await lastValueFrom(this.configurationService.getOrganizationBranchesByOrgId(this.app.user.organizationId));
        if (org && org.length) {
            this.orgHeadOfficeAddress = org.find((o) => o?.type?.name?.toLowerCase() == "head office");
            this.prepareCompanyInfoToPrint(org);
        }
    }
    prepareCompanyInfoToPrint(branches) {
        let newBranches = [];
        for (let b of branches) {
            let branch = {
                id: b.id,
                name: b.address.name == "" ? "" : b.address.name,
                phone: b.organizationAddressPhone && b.organizationAddressPhone.length ? b.organizationAddressPhone[0].phone.number : "",
                emailId: b.organizationAddressEmail && b.organizationAddressEmail.length ? b.organizationAddressEmail[0].email.emailAddress : "",
                addressId: b.addressId,
                address: b.address.streetAddress1 + (b.address.streetAddress2 ? " " + b.address.streetAddress2 : ""),
                city: b.address.city == null ? "" : b.address.city.name,
                cityId: b.address.cityId,
                cityObj: null,
                stateId: b.address.stateId,
                state: b?.address?.state?.name ?? "",
                stateObj: null,
                countryId: b.address?.countryId,
                country: b.address?.country?.name,
                countryObj: null,
                zip: b.address.zipCode,
                locationTypeId: b.locationTypeId,
                locationType: b.locationType ? b.locationType.name : 0,
                headOffice: b.typeId == this.orgHeadOfficeAddress?.id ? true : false,
                latitude: b.address.latitude,
                longitude: b.address.longitude,
            };
            newBranches.push(branch);
        }
        if (newBranches && newBranches.length) {
            this.companyInfo = newBranches[0];
        }
    }

    getAccountChannels(id: number) {
        this.sharedChannelService.getChannels(id).subscribe({
            next: (res) => {
                this.accountChannels = res;
                this.setDefaultAccountChannel();
            },
            error: (error) => {
                this.messageService.add({
                    severity: Severity.Error,
                    summary: this.titlecasePipe.transform(Severity.Error),
                    detail: "Error occurred...",
                });
            },
        });
    }
    setDefaultAccountChannel(){
        this.selectedAccChannel = this.accountChannels?.find((channel) => channel?.isDefault == true);
    }

    getAllCustomAttributes() {
        this.appMainService.isShowSpinner("loadCustomAttributes");
        this.productsService
            .getAllCustomFields(this.orderObjId)
            .then((fields) => {
                this.allCustomAttributes = _.cloneDeep(fields);
                this.appMainService.isHideSpinner("loadCustomAttributes");
            })
            .catch((error) => {
                this.appMainService.isHideSpinner("loadCustomAttributes");
            });
    }

    getOrderChannels(name) {
        this.appMainService.isShowSpinner("loadChannels");
        this.salesOrderService.getAllOrdersChannel(name).subscribe((channels) => {
            const config = JSON.parse(channels.configurationDetails[0].configJSONValue);
            this.orderChannels = config;
            this.selectedChannel = this.orderChannels.filter((channel: any) => channel.name == this.app.selectedOrder)[0];
            this.appMainService.isHideSpinner("loadChannels");
            this.getOrderSettings("order");
        });
    }

    getOrderSettings(name) {
        this.appMainService.isShowSpinner("loadsettings");
        this.productsService.getProductConfigurations(name).subscribe((configs) => {
            this.appMainService.isHideSpinner("loadsettings");
            this.configuration = _.cloneDeep(configs);
            this.settingConfig = configs.filter((config) => config.name == "Order Column Settings")[0];
            if (this.settingConfig?.configurationDetails.length > 0) {
                this.settingColumns = JSON.parse(this.settingConfig?.configurationDetails[0].configJSONValue);
            }
            const x = this.settingColumns?.filter((setting) => setting.typeId == this.selectedChannel?.id)[0];
            
            this.estimatesCols = x ? x.ListCols : data.estimate.list_Columns;
            this.estimatesCols2 = x ? x.ListDetailCols : data.estimate.details_Columns;

            this.estimatesColsAll = this.estimatesCols;
          if(this.selectedChannel?.name == this.soChannel.SALES_RECEIPT){
            this.salesReceiptsCols = this.estimatesCols.map(col => ({
                ...col,
                name: col.header,
                dataType: col.datatype,
                operators: SalesReceiptFilterNS.SalesReceiptFilterDataTypeWithOperator.filter(x => x.DataType === col.datatype).map(x => x.Operator),
                formControlType: 'InputBox',
                fieldDataType: col.datatype,
                columnName: col.field
            }));
            this.filteredColumns = (this.salesReceiptsCols ?? []).map((sf => sf.columnName));
        }
            this.historyCols = x ? x.HistoryCols : data.estimate.history_columns;
            this.selectedView = x ? x.DefaultView : "list";
            this.buildMenuBar(this.selectedView, 0);
            this.estimatesCols.forEach((element, index) => {
                this.estimatesByNameCols.push(element);
            });
            this.changeChannel();
        });
    }

    getModules() {
        this.allModules = this.app.preLoadedObjects.filter((obj) => obj.name == "Orders");
        this.orderObjId = this.allModules.find((el) => el.name == "Orders")?.id;
    }

    checkRequired(name, cf_list) {
        return cf_list.find((el) => el.name === name)?.isRequired || false;
    }

    checkRequired1(name, cf_list) {
        return cf_list.find((el) => el.name === name)?.isRequired || false;
    }

    getPickListValues(values) {
        return values;
    }

    refreshList(e) {
        if (this.fromGlobalSearch) {
            this.pageNumber = 1;
            this.pageSize = 15;
            //this.router.navigate(["orders"]);
        }
        this.fromGlobalSearch = false;
        this.isActive = true;
        if (this.selectedChannel?.name == "Customers") {
            this.selectedCustomer = null;
            // this.selectedView = "list";
            this.customersColsAll = this.customersColsAllTemp;
            this.customersCols = this.customersColsAll;
        } else if (this.selectedChannel?.name == this.soChannel.ESTIMATES) {
            this.soCols = this.estimatesByNameCols;
            this.selectedView = "split";
            this.getAllEstimatesByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecent.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        } else if (this.selectedChannel?.name == this.soChannel.SALES_ORDER) {
            this.soCols = this.estimatesByNameCols;
            this.selectedView = "split";
            this.getAllSalesOrderByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentSOFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        } else if (this.selectedChannel?.name == this.soChannel.INVOICING) {
            this.soCols = this.estimatesByNameCols;
            this.selectedView = "split";
            this.getAllInvoiceByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentInvoiceFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        } else if (this.selectedChannel?.name == this.soChannel.CUSTOMER_RETURNS) {
            this.soCols = this.estimatesByNameCols;
            this.selectedView = "split";
            this.returnsColsAll = this.returnsColsAllTemp;
            this.returnsCols = this.returnsColsAll;
            this.searchValue = null;
            this.searchColumns = null;
            this.getAllCustomerReturnsByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentCustomerReturnFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        } else if (this.selectedChannel?.name == this.soChannel.CREDIT_MEMO) {
            this.soCols = this.estimatesByNameCols;
            this.selectedView = "split";
            this.getAllCreditMemoByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentCreditMemoFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        } else if (this.selectedChannel?.name == this.soChannel.SALES_RECEIPT) {
            this.soCols = this.salesReceiptsCols;
            this.selectedView = "split";
            this.getAllSalesReceiptsPagination(this.pageNumber, this.pageSize,'');
        }
    }

    onRefresh() {
        if (this.selectedChannel?.name == this.soChannel.ESTIMATES) {
            this.getAllEstimatesByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecent.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        } else if (this.selectedChannel?.name == this.soChannel.SALES_ORDER) {
            this.getAllSalesOrderByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentSOFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        } else if (this.selectedChannel?.name == this.soChannel.INVOICING) {
            this.getAllInvoiceByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentInvoiceFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        } else if (this.selectedChannel?.name == this.soChannel.CUSTOMER_RETURNS) {
            this.getAllCustomerReturnsByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentCustomerReturnFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        } else if (this.selectedChannel?.name == this.soChannel.CREDIT_MEMO) {
            this.getAllCreditMemoByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentCreditMemoFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        } else if (this.selectedChannel?.name == this.soChannel.SALES_RECEIPT) {
            this.sortFlag = true;
            this.sortCol = '';
            this.pageNumber = 1;
            this.pageSize = 15;
            this.getAllSalesReceiptsPagination(this.pageNumber, this.pageSize,'');
        }
    }
    onRefreshDetails(e?) {
        if (this.selectedChannel?.name == this.soChannel.ESTIMATES) {
            this.getEstimatesDetailsById(this.selectedEstimate.id);
            this.refreshActivityLog(this.selectedEstimate.id);
        } else if (this.selectedChannel?.name == this.soChannel.SALES_ORDER) {
            this.getSalesOrderDetailsById(this.selectedOrder.id);
            this.refreshActivityLog(this.selectedOrder.id);
        } else if (this.selectedChannel?.name == this.soChannel.INVOICING) {
            this.getInvoicingDetailsById(this.selectedInvoicing.id);
            this.getInvoiceRecievedPaymentsById(this.selectedInvoicing.id);
            this.refreshActivityLog(this.selectedInvoicing.id);
        } else if (this.selectedChannel?.name == this.soChannel.CUSTOMER_RETURNS) {
            this.getCustomerReturnDetailsById(this.selectedId);
        } else if (this.selectedChannel?.name == this.soChannel.CREDIT_MEMO) {
            this.getCreditMemoDetailsById(this.selectedRowData.id);
            this.refreshActivityLog(this.selectedRowData.id);
        } else if (this.selectedChannel?.name == this.soChannel.SALES_RECEIPT) {
           this.getAllSalesReceiptsPagination(this.pageNumber, this.pageSize , this.selectedRowData?.id);
            this.refreshActivityLog(this.selectedRowData.id);
        }
    }
    refreshActivityLog(id){
        this.selectedId = null;
        setTimeout(() => {
            this.selectedId = id;
          }, 0);
    }

    reloadResultAfterSave() {
        if (this.selectedChannel?.name == this.soChannel.ESTIMATES) {
            this.getEstimatesDetailsById(this.selectedEstimate.id);
        } else if (this.selectedChannel?.name == this.soChannel.SALES_ORDER) {
            this.getSalesOrderDetailsById(this.selectedOrder.id);
        } else if (this.selectedChannel?.name == this.soChannel.INVOICING) {
            this.getInvoicingDetailsById(this.selectedInvoicing.id);
        } else if (this.selectedChannel?.name == this.soChannel.CUSTOMER_RETURNS) {
            this.getCustomerReturnDetailsById(this.selectedId);
        } else if (this.selectedChannel?.name == this.soChannel.CREDIT_MEMO) {
            this.getCreditMemoDetailsById(this.selectedRowData.id);
        }
    }
    openAccountViewEdit(data) {
        this.displayAccountViewEdit = true;
        this.selectedAccountId = data.id;
        this.selectedAccountChannelId = data.channelId;
    }
    closeAccountViewEditModal() {
        this.displayAccountViewEdit = false;
        this.selectedAccountId = 0;
        this.selectedAccountChannelId = 0;
    }

    onStatusChanged() {
        if (this.selectedChannel?.name == "Customers") {
            this.selectedCustomer = null;
            this.customersColsAll = this.customersColsAllTemp;
            this.customersCols = this.customersColsAll;
        } else if (this.selectedChannel?.name == this.soChannel.ESTIMATES) {
            this.getAllEstimatesByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecent.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        } else if (this.selectedChannel?.name == this.soChannel.SALES_ORDER) {
            this.getAllSalesOrderByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentSOFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        } else if (this.selectedChannel?.name == this.soChannel.INVOICING) {
            this.getAllInvoiceByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentInvoiceFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        } else if (this.selectedChannel?.name == this.soChannel.CUSTOMER_RETURNS) {
            this.selectedReturn = null;
            this.returnsColsAll = this.returnsColsAllTemp;
            this.returnsCols = this.returnsColsAll;
            this.getAllCustomerReturnsByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentCustomerReturnFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        } else if (this.selectedChannel?.name == this.soChannel.CREDIT_MEMO) {
            this.getAllCreditMemoByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentCreditMemoFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        } else if (this.selectedChannel?.name == this.soChannel.SALES_RECEIPT) {
            this.getAllSalesReceiptsPagination(this.pageNumber, this.pageSize,'');
        }
    }

    backListView() {
        this.isShowSideBtn = true;
        if (this.fromGlobalSearch) {
            this.pageNumber = 1;
            this.pageSize = 15;
            //this.router.navigate(["orders"]);
        }
        this.fromGlobalSearch = false;
        if (this.selectedChannel?.name == "Customers") {
            this.selectedCustomer = null;
            this.selectedView = "list";
            this.customersColsAll = this.customersColsAllTemp;
            this.customersCols = this.customersColsAll;
        } else if (this.selectedChannel?.name == this.soChannel.ESTIMATES) {
            this.selectedEstimate = null;
            this.selectedView = "list";
            this.estimatesColsAll = this.estimatesColsAllTemp;
            this.estimatesCols = this.estimatesColsAll;
            this.soCols = this.estimatesColsAllTemp;
            this.getAllEstimatesByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecent.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        } else if (this.selectedChannel?.name == this.soChannel.SALES_ORDER) {
            this.selectedOrder = null;
            this.selectedView = "list";
            this.estimatesColsAll = this.estimatesColsAllTemp;
            this.estimatesCols = this.estimatesColsAll;
            this.soCols = this.estimatesColsAllTemp;
            this.getAllSalesOrderByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentSOFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        } else if (this.selectedChannel?.name == this.soChannel.INVOICING) {
            this.selectedInvoicing = null;
            this.selectedView = "list";
            this.invoicingColsAll = this.invoicingColsAllTemp;
            this.invoicingCols = this.invoicingColsAll;
            this.estimatesColsAll = this.estimatesColsAllTemp;
            this.estimatesCols = this.estimatesColsAll;
            this.soCols = this.estimatesColsAllTemp;
            this.getAllInvoiceByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentInvoiceFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        } else if (this.selectedChannel?.name == this.soChannel.CUSTOMER_RETURNS) {
            this.selectedReturn = null;
            this.selectedView = "list";
            this.returnsColsAll = this.returnsColsAllTemp;
            this.returnsCols = this.returnsColsAll;
            this.estimatesColsAll = this.estimatesColsAllTemp;
            this.estimatesCols = this.estimatesColsAll;
            this.soCols = this.estimatesColsAllTemp;
            //this.soCols = this.estimatesCols;
            this.getAllCustomerReturnsByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentCustomerReturnFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        } else if (this.selectedChannel?.name == this.soChannel.CREDIT_MEMO) {
            this.selectedRowData = null;
            this.selectedView = "list";
            this.soCols = this.estimatesCols;
            this.getAllCreditMemoByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentCreditMemoFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        }else if (this.selectedChannel?.name == this.soChannel.SALES_RECEIPT) {
            this.selectedRowData = null;
            this.glApiCall = false;
            this.salesReceiptsCols = this.salesReceiptsCols;
            this.filteredColumns = (this.salesReceiptsCols ?? []).map((sf => sf.columnName));
            this.selectableColumns = this.getcolumns(this.salesReceiptsCols);
            this.selectedView = "list";
            this.getAllSalesReceiptsPagination(this.pageNumber, this.pageSize,'');
        }
    }

    onRowSelect() {
        this.isShowSideBtn = false;
        const iSettings = this.utilityService.getISettings();
        this.serialConfig = iSettings?.find((value) => value.code == "enableserial");
        if (this.selectedChannel?.name == "Customers") {
            this.selectedEstimate = null;
            this.selectedOrder = null;
            this.selectedInvoicing = null;
            this.selectedReturn = null;
            this.selectedRowData = null;
            this.filteredCustomers = [...this.customersData.filter((p) => p.id == this.selectedCustomer.id)];
            this.selectedCustomer2 = [...this.allCustomers.filter((p) => p.id == this.selectedCustomer.id)][0];
            this.app.objectId = this.selectedCustomer.id;
            this.selectedId = this.selectedCustomer.id;
            this.app.objectType = "Customers";
            this.customersColsAllTemp = this.customersColsAll;
        } else if (this.selectedChannel?.name == this.soChannel.ESTIMATES) {
            this.selectedId = null;
            this.selectedCustomer = null;
            this.selectedOrder = null;
            this.selectedInvoicing = null;
            this.selectedReturn = null;
            this.selectedRowData = null;
            this.filteredEstimates = [];
            this.app.objectId = this.selectedEstimate.id;
            this.selectedId = this.selectedEstimate.id;
            this.app.objectType = "Estimate";
            this.estimatesColsAllTemp = this.estimatesColsAll;
            this.buildEstimatesContextMenu();
            this.getEstimatesDetailsById(this.selectedEstimate.id);
        } else if (this.selectedChannel?.name == this.soChannel.SALES_ORDER) {
            this.selectedId = null;
            this.selectedCustomer = null;
            this.selectedEstimate = null;
            this.selectedInvoicing = null;
            this.selectedReturn = null;
            this.selectedRowData = null;
            this.filteredOrders = [];
            this.selectedOrdersStageId = this.selectedOrder.stageId;
            this.showPickColumn = this.selectedOrdersStageId == SoStageId.Entered ? false : true;
            this.app.objectId = this.selectedOrder.id;
            this.selectedId = this.selectedOrder.id;
            this.app.objectType = SOObjectNames.SalesOrder;
            this.estimatesColsAllTemp = this.estimatesColsAll;
            this.isAutoPick = iSettings?.find((i) => i?.code?.toLowerCase() == "autopick")?.enabled ?? false;
            this.isAutoPack = iSettings?.find((i) => i?.code?.toLowerCase() == "autopack")?.enabled ?? false;
            if (this.selectedOrdersStageId == SoStageId.Shipped) {
                this.getSalesOrderDetailsById(this.selectedOrder.id);
                // this.getInvoicingDetailsById(this.selectedOrder.invoiceId);
                this.buildSOContextMenu(SoStageId.Shipped, this.selectedOrder.salesOrderStatusId, this.selectedOrder.approvalStatusId);
            } else {
                this.getSalesOrderDetailsById(this.selectedOrder.id);
            }
        } else if (this.selectedChannel?.name == this.soChannel.INVOICING) {
            this.selectedId = null;
            this.selectedCustomer = null;
            this.selectedEstimate = null;
            this.selectedOrder = null;
            this.selectedReturn = null;
            this.selectedRowData = null;
            this.filteredInvoicing = [];
            this.app.objectId = this.selectedInvoicing.id;
            this.selectedId = this.selectedInvoicing.id;
            this.app.objectType = "Invoice";
            this.invoicingColsAllTemp = this.invoicingColsAll;
            this.estimatesColsAllTemp = this.estimatesColsAll;
            this.getAllVendors();
            this.buildInvoiceContextMenu();
            this.getInvoicingDetailsById(this.selectedInvoicing.id);
            this.getInvoiceRecievedPaymentsById(this.selectedInvoicing.id);
        } else if (this.selectedChannel?.name == this.soChannel.CUSTOMER_RETURNS) {
            this.selectedCustomer = null;
            this.selectedEstimate = null;
            this.selectedOrder = null;
            this.selectedInvoicing = null;
            this.selectedRowData = null;
            this.selectedCustomerReturn = this.selectedReturn;
            this.app.objectId = this.selectedReturn?.id;
            this.selectedId = this.selectedReturn?.id;
            this.app.objectType = SOObjectNames.CustomerReturns;
            this.returnsColsAllTemp = this.returnsColsAll;
            this.estimatesColsAllTemp = this.estimatesColsAll;
            this.getAllVendors();
            this.buildCustomerReturnContextMenu();
            this.getCustomerReturnDetailsById(this.selectedId);
        } else if (this.selectedChannel?.name == this.soChannel.CREDIT_MEMO) {
            this.selectedCustomer = null;
            this.selectedEstimate = null;
            this.selectedOrder = null;
            this.selectedInvoicing = null;
            this.selectedReturn = null;
            this.app.objectId = this.selectedRowData.id;
            this.selectedId = this.selectedRowData.id;
            this.app.objectType = "Credit Memo";
            // this.creditColsAllTemp = this.creditColsAll;
            this.getCreditMemoDetailsById(this.selectedRowData.id);
        }
    }

    onRowSelect2() {
        this.selectedInvoicing2;
        this.selectedRPO = this.selectedInvoicing2;
        this.productsService.getAllCustomFields(this.orderObjId).then((fields) => {
            // custom fields
            this.configCustomFields = fields;
            // this.parseCombinedCustomAttributes();

            this.invoicingHeader = this.soChannel.INVOICING;
            this.displayInvoicingAdd = true;
            this.invoicingDialogType = "VIEW";
        });
    }

    async organizationTypes(name) {
        await this.productsService.getOrganizationTypes(name).subscribe((types) => {
            this.oganizationGroups = types;
        });
    }

    async getCategoryGroups(name) {
        await this.productsService.getCategoryGroups(name).subscribe((groups) => {
            this.categoryGroups = groups;
        });
    }

    settings() {
        this.estimeatesTotalSelectedAmt = 0;
        this.tempCols = JSON.parse(JSON.stringify(this.estimatesCols));
        if (this.estimatesCols2) {
            this.tempCols2 = JSON.parse(JSON.stringify(this.estimatesCols2));
        }

        if (this.selectedView == "list") {
            this.tab = "tab3";
            this.showDiv = {
                stepsbar: false,
                views: false,
                collists: true,
                config: false,
                details: false,
            };
        } else if (this.selectedView == "split") {
            if (this.selectedChannel?.name == this.soChannel.CUSTOMER_RETURNS || this.selectedChannel?.name == this.soChannel.ESTIMATES) {
                this.tab = "tab3";
            } else {
                this.tab = "tab4";
            }
            this.showDiv = {
                stepsbar: false,
                views: false,
                collists: ((this.selectedChannel?.name == this.soChannel.CUSTOMER_RETURNS || this.selectedChannel?.name == this.soChannel.ESTIMATES) ? true : false),
                config: false,
                details: true,
            };
        }

        for (let col of this.tempCols) {
            if (col.checked) {
                this.estimeatesTotalSelectedAmt++;
            }
        }
        this.estimeatesTotalSelectedAmt >= 8 ? (this.maxNo = true) : (this.maxNo = false);

        if (this.tempCols2) {
            for (let col of this.tempCols2) {
                if (col.checked) {
                    this.totalAmt2++;
                }
            }
        }
        this.totalAmt2 === 6 ? (this.maxNo2 = true) : (this.maxNo2 = false);
        this.organizationTypes("Column Setting");
        this.getCategoryGroups("Configuration Type Group");
        this.displaySettings = true;
    }

    saveSettings() {
        for (let col of this.estimatesCols) {
            col.value = "";
            if (col.checked) {
                col.show = true;
            } else {
                col.show = false;
            }
        }
        if (this.estimatesCols2) {
            for (let col of this.estimatesCols2) {
                if (col.checked == true) {
                    col.show = true;
                } else {
                    col.show = false;
                }
            }
        }

        if (this.settingConfig) {
            const columnData = this.settingColumns.filter((sc) => sc.typeId == this.selectedChannel?.id)[0];
            if (columnData) {
                columnData.DefaultView = "list";
                columnData.ListCols = this.estimatesCols;
                columnData.ListDetailCols = this.estimatesCols2;
                columnData.HistoryCols = [];
                const index = this.settingColumns.indexOf(columnData);
                this.settingColumns[index] = columnData;
            } else {
                this.settingColumns.push({
                    DefaultView: "list",
                    ListCols: this.estimatesCols,
                    ListDetailCols: this.estimatesCols2,
                    HistoryCols: [],
                    typeId: this.selectedChannel?.id,
                    typeName: this.selectedChannel?.name,
                });
            }
        } else {
            this.settingColumns = [];
            this.settingColumns.push({
                DefaultView: "list",
                ListCols: this.estimatesCols,
                ListDetailCols: this.estimatesCols2,
                HistoryCols: [],
                typeId: this.selectedChannel?.id,
                typeName: this.selectedChannel?.name,
            });
        }

        const data = {
            id: this.settingConfig ? this.settingConfig.id : 0,
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            createdBy: this.app.user.userId,
            updatedBy: this.app.user.userId,
            createdDate: this.app._saveDateTimeWithZone(new Date()),
            updatedDate: this.app._saveDateTimeWithZone(new Date()),
            organizationId: this.app.user.organizationId,
            name: "Order Column Settings",
            description: "Order Column Settings",
            configJSONSchema: "",
            configJSONValue: JSON.stringify(this.settingColumns),
            objectId: this.app.preLoadedObjects.find((obj) => obj.name == SOObjectNames.Estimate).id,
            levelId: 4, // user level permission
            levelRecordId: this.app.user.userId, // user permissions, here we pass user id
            categoryId: this.categoryGroups?.filter((gp) => gp.name == "General").map((type) => type.id)[0],
            statusId: Status.Active,
            typeId: this.oganizationGroups?.filter((gp) => gp.name == "ColumnSettings").map((type) => type.id)[0], // this is constant for column settings
        };

        if (this.settingConfig) {
            this.service
                .updateConfiguration(data)
                .then(() => {
                    this.messageService.add({
                        severity: Severity.Success,
                        summary: this.titlecasePipe.transform(Severity.Success),
                        detail: "Settings updated successfully...",
                    });
                    this.getOrderSettings("order");
                })
                .catch(() => {
                    this.messageService.add({
                        severity: Severity.Error,
                        summary: this.titlecasePipe.transform(Severity.Error),
                        detail: "Error occurred while saving data...",
                    });
                });
        } else {
            this.service
                .updateConfiguration(data)
                .then(() => {
                    this.messageService.add({
                        severity: Severity.Success,
                        summary: this.titlecasePipe.transform(Severity.Success),
                        detail: "Settings added successfully...",
                    });
                    this.getOrderSettings("order");
                })
                .catch(() => {
                    this.messageService.add({
                        severity: Severity.Error,
                        summary: this.titlecasePipe.transform(Severity.Error),
                        detail: "Error occurred while saving data...",
                    });
                });
        }
        this.estimeatesTotalSelectedAmt = 0;
        this.totalAmt2 = 0;
        this.displaySettings = false;
    }

    onClick(check) {
        if (check == 1) {
            this.tab = "tab1";
        } else if (check == 2) {
            this.tab = "tab2";
        } else if (check == 3) {
            this.tab = "tab3";
        } else if (check == 4) {
            this.tab = "tab4";
        } else if (check == 5) {
            this.tab = "tab5";
        } else if (check == 6) {
            this.tab = "tab6";
        }
    }

    drop(event: CdkDragDrop<string[]>) {
        let item = <any>event.previousContainer.data[event.previousIndex];
        item.caseStageId = event.container.id;
        //this.updateStage(event, item);
    }

    dropCol(event: CdkDragDrop<string[]>) {
        if (event.currentIndex > 1) moveItemInArray(this.estimatesCols, event.previousIndex, event.currentIndex);
        moveItemInArray(this.estimatesCols2, event.previousIndex, event.currentIndex);
    }

    onChange(isChecked: boolean) {
        if (isChecked) this.estimeatesTotalSelectedAmt++;
        else this.estimeatesTotalSelectedAmt--;
        this.estimeatesTotalSelectedAmt >= 8 ? (this.maxNo = true) : (this.maxNo = false);
    }

    onChange2(isChecked: boolean) {
        if (isChecked) this.totalAmt2++;
        else this.totalAmt2--;
        this.totalAmt2 >= 8 ? (this.maxNo2 = true) : (this.maxNo2 = false);
    }

    onChange3(isChecked: boolean) {
        if (isChecked) this.totalAmt3++;
        else this.totalAmt3--;
        this.totalAmt3 === 6 ? (this.maxNo3 = true) : (this.maxNo3 = false);
    }

    loadSections(name) {
        this.appMainService.isShowSpinner("loadAllSections");
        this.salesOrderService.getAllOrdersChannel(name).subscribe((configs) => {
            this.appMainService.isHideSpinner("loadAllSections");
            this.allSections = JSON.parse(configs.configurationDetails[0].configJSONValue);
            this.orderSectionsService.setSections(this.allSections);
        });
    }

    loadTemplates(name) {
        this.appMainService.isShowSpinner("loadAllTemplates");
        this.salesOrderService.getAllOrdersChannel(name).subscribe((configs) => {
            this.appMainService.isHideSpinner("loadAllTemplates");
            this.templates = JSON.parse(configs.configurationDetails[0].configJSONValue);
            this.loadSections("Order Section");
        });
    }

    async loadTemplates1(name) {
        this.appMainService.isShowSpinner("loadAllTemplates");
        const configs: any = await this.salesOrderService.getAllOrdersChannel1(name);
        this.templates = JSON.parse(configs.configurationDetails[0].configJSONValue);
        this.appMainService.isHideSpinner("loadAllTemplates");
        this.loadSections("Order Section");
    }

    filterSelectedChannel(str, url) {
       this.selectedAccChannel = null;
        this.selectedChannel = this.orderChannels.filter((channel: any) => channel.name == str)[0];
        this.changeChannel(0, "CHANNEL_CHANGE");
        this.app.selectedOrder = str;
        this._location.go(url);
    }
    changeChannel(paramId = 0, requestMode = "") {
        this.processChannelChange(paramId, requestMode);
        // from global search or from activity logs
        if (!this.fromGlobalSearch && requestMode == "") {
            this.route.queryParams.subscribe((params) => {
                if (params && params.id && params.module && params.channelId && params.statusId) {
                    this.fromGlobalSearch = true;
                    this.globalSearchData = [];
                    this.globalSearchData.push({
                        id: params.id,
                        name: params.data,
                    });
                    this.selectedChannel = this.orderChannels.filter((a) => a.id == params.channelId)[0];
                    this.processChannelChange(params.id);
                } else {
                    this.fromGlobalSearch = false;
                }
            });
        }
    }

    processChannelChange(paramId = 0, requestMode = "") {
        this.selectedView = "list";
        this.first = 0;
        this.pageNumber = 1;
        this.pageSize = 15;
        this.searchValue = "";
        this.searchColumns = "";
        this.estimatesByNameCols = [];
        this.estimatesCols = [];
        this.estimatesCols2 = [];
        this.estimatesColsAll = [];
        this.historyCols = [];
        this.isActive = true;
        this.noCaseFindOrLoadingText = "Loading...";

        if (this.fromGlobalSearch && requestMode == "CHANNEL_CHANGE") {
            this.pageNumber = 1;
            this.pageSize = 15;
            // this.router.navigate(["orders"]);
            this.fromGlobalSearch = false;
        }
        this.searchControl.setValue("", { emitEvent: false });
        const x = this.settingColumns && this.settingColumns.length > 0 ? this.settingColumns.filter((setting) => setting.typeId == this.selectedChannel?.id)[0] : [];
        this.soCols = x && x.ListCols && x.ListCols.length > 0 ? x.ListCols : this.selectedChannel?.name == this.soChannel.ESTIMATES ? data.estimate.list_Columns : this.selectedChannel?.name == this.soChannel.SALES_ORDER ? data.sales_order.list_Columns : this.selectedChannel?.name == this.soChannel.INVOICING ? data.invoice.list_Columns : this.selectedChannel?.name == this.soChannel.CUSTOMER_RETURNS ? data.customer_return.list_Columns : this.selectedChannel?.name == this.soChannel.CREDIT_MEMO ? data.credit_memo.list_Columns : [];
        this.estimatesCols = x && x.ListCols && x.ListCols.length > 0 ? x.ListCols : this.selectedChannel?.name == this.soChannel.ESTIMATES ? data.estimate.list_Columns : this.selectedChannel?.name == this.soChannel.SALES_ORDER ? data.sales_order.list_Columns : this.selectedChannel?.name == this.soChannel.INVOICING ? data.invoice.list_Columns : this.selectedChannel?.name == this.soChannel.CUSTOMER_RETURNS ? data.customer_return.list_Columns : this.selectedChannel?.name == this.soChannel.CREDIT_MEMO ? data.credit_memo.list_Columns : [];
        this.estimatesCols2 = x && x.ListDetailCols && x.ListDetailCols.length > 0 ? x.ListDetailCols : this.selectedChannel?.name == this.soChannel.INVOICING ? data.invoice.details_Columns : this.selectedChannel?.name == this.soChannel.CREDIT_MEMO ? data.credit_memo.details_Columns : data.invoice.details_Columns;
        this.historyCols = x && x.HistoryCols && x.HistoryCols.length > 0 ? x.HistoryCols : [];
        this.estimatesColsAll = this.estimatesCols;
        this.estimatesCols?.forEach((element, index) => {
            if (index == 0 || index == 1) {
                this.estimatesByNameCols.push(element);
            }
        });
        this.buildMenuBar(this.selectedView, 0);
        if(!this.selectedAccChannel){  
            this.setDefaultAccountChannel();
        }

        if (this.selectedChannel?.name == this.soChannel.ESTIMATES) {
            this.settingsName = "Estimate Settings";
            const filteredChannel = this.orderChannels.filter((c) => c.id == this.selectedChannel?.id)[0];
            this.estStatusDD = filteredChannel.status[0].status;
            this.estimateTemplates = this.templates.filter((t) => t.typeId == this.selectedChannel?.id)[0];
            // this.estimatesDetailsTemplates = this.estimateTemplates;
            this.estimatesSections = this.allSections.filter((s) => s.typeId == this.selectedChannel?.id && s.isActive == true);

            // from global search
            if (this.fromGlobalSearch) {
                this.pageNumber = 1;
                this.pageSize = 15;
                this.selectedEstimate = {
                    id: paramId,
                    number: this.globalSearchData?.[0]?.name ?? "",
                };
            }
            this.getAllEstimatesByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecent.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        } else if (this.selectedChannel?.name == this.soChannel.SALES_ORDER) {
            this.getBackOrderConfig();
            this.settingsName = "Sales Order Settings";
            this.estimateTemplates = this.templates.filter((t) => t.typeId == this.selectedChannel?.id)[0];
            this.soDetailsTemplates = this.estimateTemplates;
            this.estimatesSections = this.allSections.filter((s) => s.typeId == this.selectedChannel?.id && s.isActive == true);
            const salesChannel = this.orderChannels?.filter((s) => s.name == this.soChannel.SALES_ORDER)[0];
            this.allStages = salesChannel.stages;

            // from global search
            if (this.fromGlobalSearch) {
                this.pageNumber = 1;
                this.pageSize = 15;
                this.selectedOrder = {
                    id: paramId,
                    number: this.globalSearchData?.[0]?.name ?? "",
                    SONo: this.globalSearchData?.[0]?.name ?? "",
                };
            }
            this.getAllSalesOrderByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentSOFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        } else if (this.selectedChannel?.name == this.soChannel.INVOICING) {
            this.settingsName = "Invoicing Settings";
            this.selectedInvoicing = null;
            this.estimateTemplates = this.templates.filter((t) => t.typeId == this.selectedChannel?.id)[0];
            // this.invoiceDetailsTemplates = this.estimateTemplates;
            this.estimatesSections = this.allSections.filter((s) => s.typeId == this.selectedChannel?.id && s.isActive == true);

            // from global search
            if (this.fromGlobalSearch) {
                this.pageNumber = 1;
                this.pageSize = 15;
                this.selectedInvoicing = {
                    id: paramId,
                    number: this.globalSearchData?.[0]?.name ?? "",
                };
            }
            this.getAllInvoiceByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentInvoiceFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        } else if (this.selectedChannel?.name == this.soChannel.CUSTOMER_RETURNS) {
            this.settingsName = "Customer Returns Settings";
            this.estimateTemplates = this.templates.filter((t) => t.typeId == this.selectedChannel?.id)[0];
            this.estimatesSections = this.allSections.filter((s) => s.typeId == this.selectedChannel?.id && s.isActive == true);

            // from global search
            if (this.fromGlobalSearch) {
                this.pageNumber = 1;
                this.pageSize = 15;
                this.selectedReturn = {
                    id: paramId,
                    number: this.globalSearchData?.[0]?.name ?? "",
                };
                this.searchValue = this.selectedReturn.number;
                this.searchColumns = "rmaNumber";
            }
            this.getAllCustomerReturnsByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentCustomerReturnFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        } else if (this.selectedChannel?.name == this.soChannel.CREDIT_MEMO) {
            this.settingsName = "Credit Memo Settings";
            this.estimateTemplates = this.templates.filter((t) => t.typeId == this.selectedChannel?.id)[0];
            this.cmDetailsTemplates = this.estimateTemplates;
            this.estimatesSections = this.allSections.filter((s) => s.typeId == this.selectedChannel?.id && s.isActive == true);

            // from global search
            if (this.fromGlobalSearch) {
                this.pageNumber = 1;
                this.pageSize = 15;
                this.selectedRowData = {
                    id: paramId,
                    number: this.globalSearchData?.[0]?.name ?? "",
                };
            }
            this.getAllCreditMemoByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentCreditMemoFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        }  else if (this.selectedChannel?.name == this.soChannel.SALES_RECEIPT) {
            this.settingsName = "Sales Receipt Settings";
            this.estimateTemplates = this.templates.filter((t) => t.typeId == this.selectedChannel?.id)[0];
            this.salesReceiptsTemplate = this.estimateTemplates;
            this.salesReceiptsCols = this.estimatesCols
                .filter(col => col.show) 
                .map(col => ({
                    ...col,
                    name: col.header,
                    dataType: col.datatype,
                    operators: SalesReceiptFilterNS.SalesReceiptFilterDataTypeWithOperator
                        .filter(x => x.DataType === col.datatype)
                        .map(x => x.Operator),
                    formControlType: 'InputBox',
                    fieldDataType: col.datatype,
                    columnName: col.field
                }));

            this.filteredColumns = (this.salesReceiptsCols ?? []).map((sf => sf.columnName));

            this.selectableColumns = this.getcolumns(this.salesReceiptsCols);
            this.estimatesSections = this.allSections.filter((s) => s.typeId == this.selectedChannel?.id && s.isActive == true);
            if (this.fromGlobalSearch) {
                this.pageNumber = 1;
                this.pageSize = 15;
                this.selectedRowData = {
                    id: paramId,
                    number: this.globalSearchData?.[0]?.name ?? "",
                };
            }
            if(this.displaySRDetails){
                this.selectedView = 'split'
                this.salesReceiptsCols = this.estimatesCols[0];
               this.getAllSalesReceiptsPagination(this.pageNumber, this.pageSize , this.selectedRowData?.id);
            }else{
                this.getAllSalesReceiptsPagination(this.pageNumber, this.pageSize,'');
            }
        }else {
            this.productsStepBar = true;
            this.returnStages = [
                { id: 1, name: "New", count: 4, stageColor: "#b48ead", stageId: 0 },
                { id: 2, name: "Authorized", count: 4, stageColor: "#bdb76b", stageId: 1 },
                { id: 3, name: "Received", count: 4, stageColor: "#00ccff", stageId: 2 },
                { id: 4, name: "Declined", count: 0, stageColor: "#bdb76b", stageId: 3 },
                { id: 5, name: "Approved", count: 2, stageColor: "#fff68f", stageId: 4 },
            ];
            this.returnsData = [];
        }
    }

    getEstimatesDetailsById(id: Number, menuType = "") {
        this.appMainService.isShowSpinner("loadEstimate");
        this.salesOrderService.getEstimatesDetailsById(id).subscribe(
            (res) => {
                this.appMainService.isHideSpinner("loadEstimate");
                this.estimatesDetails = res;
                if (this.estimatesDetails && this.estimatesDetails.configJSON) {
                    this.estimatesDetailsTemplates = JSON.parse(this.estimatesDetails.configJSON);
                } else {
                    this.estimatesDetailsTemplates = this.estimateTemplates;
                }
                this.estimatesDetailsCustomFields = this.utilityService.getCustomAttributesForCommon(this.estimatesDetailsTemplates, this.allCustomAttributes);
                this.estimatesDetailsPurchaseList = this.utilityService.prepareEstimateOverviewProductsList(this.estimatesDetails, this.discounts);
                this.onUpdateEstimateBuildContextMenu(this.estimatesDetails.estimateStatusId, this.estimatesDetails.isEstimateApproved, this.estimatesDetails.statusId, this.estimatesDetails.approvalStatusId);

                Object.keys(this.estimatesDetailsCustomFields).forEach((key) => {
                    const dataArr = this.estimatesDetailsCustomFields[key];
                    if (dataArr && dataArr.length > 0) {
                        dataArr.forEach((element) => {
                            const filteredCustom = this.estimatesDetails.customAttributeValues.filter((c) => c.customAttributeId == element.id)[0];
                            if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "InputBox") {
                                element.value = filteredCustom.value;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DatePicker") {
                                element.value = this.datePipe.transform(filteredCustom.value, "MM/dd/yyyy");
                            } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == "FileUpload" || filteredCustom.customAttribute?.formControl?.name == "Picture")) {
                                element.customUploadedFiles = [];
                                filteredCustom.customeAttachement.forEach((el) => {
                                    element.customUploadedFiles.push(el);
                                });
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Rating") {
                                element.value = filteredCustom.ratingId;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "ToggleButton") {
                                element.value = filteredCustom.toggle;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DropDownList") {
                                element.value = filteredCustom.values;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "RadioButton") {
                                element.value = filteredCustom.values.name;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "CheckBox") {
                                element.value = [];
                                filteredCustom.multipleValues.forEach((el) => {
                                    element.value.push(el.name);
                                });
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "MultipleDropDownList") {
                                element.value = [];
                                filteredCustom.multipleValues.forEach((el) => {
                                    element.value.push(el);
                                });
                            }
                        });
                    }
                });

                if (menuType == "PRINT") {
                    setTimeout(() => {
                        this.soPdf.print();
                    }, 1000);
                } else if (menuType == "EMAIL") {
                    setTimeout(() => {
                        this.openEmailDialog();
                    }, 1000);
                }
            },
            (err) => {
                this.appMainService.isHideSpinner("loadEstimate");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred...",
                });
            },
        );
    }

    onChangeAccountChannel() {
        switch (this.selectedChannel?.name) {
            case this.soChannel.ESTIMATES:
                this.getAllEstimatesByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecent.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
                break;
            case this.soChannel.SALES_ORDER:
                this.getAllSalesOrderByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentSOFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
                break;
            case this.soChannel.INVOICING:
                this.getAllInvoiceByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentInvoiceFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
                break;
            case this.soChannel.CUSTOMER_RETURNS:
                this.getAllCustomerReturnsByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentCustomerReturnFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
                break;
            case this.soChannel.CREDIT_MEMO:
                this.getAllCreditMemoByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentCreditMemoFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
                break;
            case this.soChannel.SALES_RECEIPT:
                this.getAllSalesReceiptsPagination(this.pageNumber, this.pageSize , '');
                break;
        }
    }

    getAllEstimatesByPagination(typeId, pageNumber, pageSize, filters, searchValue, searchColumn, sortBy, isAscending, isActive) {
        this.appMainService.isShowSpinner("loadEstimate");
        const accChannelId = this.selectedAccChannel?.id ? this.selectedAccChannel?.id : 0;
        this.salesOrderService
            .getAllEstimatesByPagination(typeId, pageNumber, pageSize, filters, searchValue, searchColumn, sortBy, isAscending, isActive, accChannelId)
            .then((res) => {
                let { data, headers } = res;
                data = data == null ? [] : data;
                headers = headers == null ? [] : headers;
                this.totalRecord = headers["TotalCount"];
                if (data.length > 0) {
                    const estimates = data.map(c => ({
                        ...c,
                        estimateno: c?.number ?? "",
                        name: c?.account?.businessName ?? "",
                        createdate: this.app._showDateTimeWithZone(c?.createdDate),
                        estimatedate: this.app._showDateTimeWithZone(c?.estimateDate),
                        createdby: c?.createdByUser ?? "",
                        refno: c?.referenceNumber ?? "",
                        isactive: c?.statusId === Status.Active ? "Yes" : "No",
                        amount: this.multiCurrency.transform(c.netAmount ?? 0, (c?.exchangeRate ? c?.exchangeRate : this.baseCurrency?.exchangeRate), (c.currencyUnit?.symbol ?? this.baseCurrency?.symbol), this.fractionDigits),
                        status: c?.estimateStatus ?? "",
                    }));
                    this.estimatesData = JSON.parse(JSON.stringify(estimates));
                    this.showFloatHeader = true;
                    if (this.fromGlobalSearch) {
                        this.selectedView = "split";
                        this.onRowSelect();
                    }
                } else {
                    this.estimatesData = [];
                    this.noCaseFindOrLoadingText = "No Estimate found";
                }
                this.appMainService.isHideSpinner("loadEstimate");
            })
            .catch((error) => {
                this.appMainService.isHideSpinner("loadEstimate");
            });
    }

    getAllSalesOrderByPagination(typeId, pageNumber, pageSize, filters, searchValue, searchColumn, sortBy, isAscending, isActive) {
        this.appMainService.isShowSpinner("loadSalesOrder");
        const accChannelId = this.selectedAccChannel?.id ? this.selectedAccChannel?.id : 0;
        this.salesOrderService
            .getAllSalesOrderByPagination(typeId, pageNumber, pageSize, filters, searchValue, searchColumn, sortBy, isAscending, isActive, accChannelId)
            .then((products) => {
                let { inventory, headers } = products;
                inventory = inventory == null ? [] : inventory;
                headers = headers == null ? [] : headers;
                this.totalRecord = headers["TotalCount"];
                let temp = [];
                this.ordersData = [];
                if (inventory.length > 0) {
                    temp = inventory?.map((c) => { 
                        return { 
                            ...c, 
                            SONo: c.number,
                            name: c.account?.businessName,
                            stage: c.salesOrderStage,
                            status: c.salesOrderStatus,
                            createdate: this.app._showDateTimeWithZone(c.createdDate),
                            sodate: this.app._showDateTimeWithZone(c.salesOrderDate),
                            createdby: c.createdByUser,
                            amount: this.multiCurrency.transform(c.netAmount ?? 0, (c.exchangeRate ? c.exchangeRate : this.baseCurrency?.exchangeRate), (c.currencyUnit?.symbol ?? this.baseCurrency?.symbol), this.fractionDigits),
                            balance: this.multiCurrency.transform(c.balanceDue ?? 0, (c.exchangeRate ? c.exchangeRate : this.baseCurrency?.exchangeRate), (c.currencyUnit?.symbol ?? this.baseCurrency?.symbol), this.fractionDigits),
                            stageId: c.salesOrderStageId,
                            location: c?.warehouse?.locationId,
                            payterm: c?.paymentTerm?.name,
                            paymethod: c?.paymentMethod?.name,
                            shipterm: c?.shippingTerm?.name,
                            shipmethod: c?.shippingMethod?.name,
                            salesrep: c?.user?.name,
                            invoiceId: c.invoiceId ? c.invoiceId : 0,
                            refno: c?.reference ?? "",
                        } 
                    });
                    this.ordersData = JSON.parse(JSON.stringify(temp));
                    this.showFloatHeader = true;
                    if (this.fromGlobalSearch) {
                        this.selectedView = "split";
                        this.onRowSelect();
                    }
                } else {
                    this.ordersData = [];
                    this.totalRecord = 0;
                    this.noCaseFindOrLoadingText = "No Sales Order found";
                }
                this.allStages = this.selectedChannel?.stages;
                this.appMainService.isHideSpinner("loadSalesOrder");
            })
            .catch((error) => {
                this.appMainService.isHideSpinner("loadSalesOrder");
            });
    }

    getAllCustomerReturnsByPagination(typeId, pageNumber, pageSize, filters, searchValue, searchColumn, sortBy, isAscending, isActive, isGlobalSearch = false) {
        const accChannelId = this.selectedAccChannel?.id ? this.selectedAccChannel?.id : 0;
        this.salesOrderService.getAllCustomerReturnsByPagination(typeId, pageNumber, pageSize, filters, searchValue, searchColumn, sortBy, isAscending, isActive, accChannelId, isGlobalSearch).then((rmas) => {
            let { inventory, headers } = rmas;
            inventory = inventory == null ? [] : inventory;
            headers = headers == null ? [] : headers;
            this.totalRecord = headers["TotalCount"];
            const temp = [];
            this.returnsData = [];

            if (inventory.length > 0) {
                for (let c of inventory) {
                    let rma = {
                        id: c.id,
                        number: c.number,
                        accountName: c.account?.businessName,
                        statusName: c.customerReturnStatus,
                        createdDate: this.app._showDateTimeWithZone(c.createdDate),
                        createdBy: c.createdByUser,
                        amount: c.netAmount,
                        repname: c.createdByUser,
                        statusId: c.invoiceStatusId,
                    };
                    let rmaData = {
                        id: c.id,
                        rmaNumber: c.number,
                        requestType: c.requestType,
                        rmaReason: c.rmaReason,
                        name: c.name,
                        description: c.description,
                        invoiceNo: c.invoiceNo,
                        rmaValues: this.multiCurrency.transform(c.totalAmount ?? 0, (c.exchangeRate ? c.exchangeRate : this.baseCurrency?.exchangeRate), (c?.account?.currencyUnit?.symbol ?? this.baseCurrency?.symbol), this.fractionDigits),
                        createdDate: c.createdDate,
                        createdBy: c.createdByUser,
                        location: c.location,
                        stage: c.stage,
                        status: c.status,
                        statusId: c.rmaStatusId,
                        isConverted: c.isConverted,
                        selectedStageId: c.rmaStageId,
                        stages: c.rmaStages, //setting rma stages to stages
                    };
                    temp.push(rmaData);
                }
                this.returnsData = JSON.parse(JSON.stringify(temp));
                if (this.fromGlobalSearch) {
                    this.selectedView = "split";
                    this.selectedReturn = this.returnsData[0];
                    this.onRowSelect();
                }
            } else {
                this.returnsData = [];
                this.noCaseFindOrLoadingText = "No Customer Returns found";
            }
        });
    }

    getAllCreditMemoByPagination(typeId, pageNumber, pageSize, filters, searchValue, searchColumn, sortBy, isAscending, isActive) {
        this.appMainService.isShowSpinner("loadCrediMemo");
        const accChannelId = this.selectedAccChannel?.id ? this.selectedAccChannel?.id : 0;
        this.salesOrderService
            .getAllCreditMemoByPagination(typeId, pageNumber, pageSize, filters, searchValue, searchColumn, sortBy, isAscending, isActive, accChannelId)
            .then((products) => {
                let { inventory, headers } = products;
                inventory = inventory == null ? [] : inventory;
                headers = headers == null ? [] : headers;
                this.totalRecord = headers["TotalCount"];
                this.soData = [];
                if (inventory.length > 0) {
                    const creditMemos = inventory?.map(c => ({
                        ...c,
                        accountName: c?.account?.businessName,
                        statusName: c?.creditMemoStatus,
                        createdDate: this.app._showDateTimeWithZone(c.createdDate),
                        memodate: this.app._showDateTimeWithZone(c.creditMemoDate),
                        createdBy: c?.createdByUser,
                        amount: this.multiCurrency.transform(c.netAmount ?? 0, (c.exchangeRate ? c.exchangeRate : this.baseCurrency?.exchangeRate), (c.currencyUnit?.symbol ?? this.baseCurrency?.symbol), this.fractionDigits),
                        repname: c?.createdByUser,
                        statusId: c?.invoiceStatusId,
                    }));
                    this.soData = JSON.parse(JSON.stringify(creditMemos));
                    if (this.fromGlobalSearch) {
                        this.selectedView = "split";
                        this.onRowSelect();
                    }
                } else {
                    this.soData = [];
                    this.noCaseFindOrLoadingText = "No Credit Memo found";
                }
                this.appMainService.isHideSpinner("loadCrediMemo");
            })
            .catch((error) => {
                this.appMainService.isHideSpinner("loadCrediMemo");
            });
    }
    onAccountIdSelect(event){
        this.selectedRowAccountId = event;
    }
    getAllSalesReceiptsPagination(pageNumber: number, pageSize: number, id: any, type?) {
        const ids = id == "" ? [] : [id];
        const requestModel: SalesReceiptRequestModel = {
            ids: ids,
            channelId: this.selectedAccChannel?.id || 0,
            isActive: this.isActive,
            globalSearchValue: this.searchValue.trim() || "",
            selectableColumns: this.selectableColumns,
            filter: "",
            pageSize: pageSize,
            pageNumber:id !== "" ? 1 : pageNumber,
            sortByColumn: this.sortCol,
            sortByColumnDataType: this.sortCol ? this.salesReceiptsCols?.find((ele) => ele.columnName == this.sortCol)?.dataType : null,
            isSortByDescending: this.sortFlag ?? null,
            filterInColumns: this.filterInColumns,
            excludeDefaultColumns: false,
            IncludeAllCustomAttributes: id !== "",
        };

        const groupRequest: SalesReceiptGroupRequestModel = {
            ...requestModel,
            groupByColumnDataType: this.salesReceiptsCols?.find((ele) => ele.columnName == this.selectedGroupByValue?.columnName)?.dataType ?? "",
            groupByColumnName: this.selectedGroupByValue?.columnName,
            isGroupByColumnCSV: this.selectedGroupByValue?.isGroupByColumnCSV ?? false,
            pageSize: pageSize,
            pageNumber: pageNumber,
            rootPageSize: pageSize,
            rootPageNumber: pageNumber,
            rootSortByColumnName: this.selectedGroupByValue?.columnName,
            isRootSortByDescending: (this.selectedGroupByValue?.fieldDataType == "DateTime") as boolean,
            timezone: this.selectedGroupByValue?.isDateWithTime ? this.timeZoneService.getUserTimezoneName() : null,
        };
        this.appMainService.isShowSpinner("loadsalesReceipts");

        const apiCall = this.selectedGroupByValue && this.selectedView !== "split" ? this.salesOrderService.getAllSalesReceiptsPagination1(groupRequest) : this.salesOrderService.getAllSalesReceiptsPagination(requestModel);
        apiCall.pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (products) => {
                const list = this.selectedGroupByValue && this.selectedView !== "split" ? products["groupedList"] || [] : products["list"] || [];

                if (this.selectedGroupByValue && this.selectedView !== "split") {
                    this.salesReceiptsData = list;
                    this.totalRecord = products["totalNumberOfRows"];

                } else if (id && id != "") {
                    this.salesReceiptsByIdList = list;
                } else {
                    this.salesReceiptsData = list;
                    this.totalRecord = products["totalNumberOfRows"]
                }
               if(!this.salesReceiptsData.length){
                this.noCaseFindOrLoadingText = "No Sales Receipt found";
               }    
                if (this.isSRpdf && type == "Print") {
                    setTimeout(() => {
                        this.srPdf.generatePrint();
                        this.isSRpdf = false;
                    }, 1000);
                } else if (this.isSRpdf && type == "Email") {
                    setTimeout(() => {
                        const attachment = this.srPdf.getPDF();
                        this.setSalesReceiptEmailContent(attachment);
                        this.isSRpdf = false;
                    }, 1000);
                }
                if (this.selectedView !== "split") {
                    this.selectableColumns = this.getcolumns(this.salesReceiptsCols);
                }
                this.showFloatHeader = true;
            },
            error: (err) => {
                console.error("Error loading sales receipts", err);
                this.appMainService.isHideSpinner("loadsalesReceipts");
            },
            complete: () => {
                this.appMainService.isHideSpinner("loadsalesReceipts");
            },
        });
    }
    setSalesReceiptEmailContent(attachment) {
        this.displayNewEmail = true;
        let fullName = this.getFullName(this.salesReceiptsByIdList[0]?.contact);
        let data = {
            attachment: attachment,
            number: this.salesReceiptsByIdList[0]?.number,
            emailTo: this.salesReceiptsByIdList[0]?.contact?.contactEmails?.length && this.salesReceiptsByIdList[0]?.contact?.contactEmails[0]?.email?.emailAddress ? this.salesReceiptsByIdList[0]?.contact?.contactEmails[0]?.email?.emailAddress : "",
            type: SOEmailType?.SalesReceipt,
            organizationName: this.app?.user?.organizationName,
            customerName: fullName,
        };
        this.emailData = this.soEmailContentBuilderService?.getEmailContent(data);
    }
    onRowSelectSalesReceipts(e) {
        this.selectedCustomer = null;
        this.selectedEstimate = null;
        this.selectedOrder = null;
        this.selectedInvoicing = null;
        this.selectedReturn = null;
        this.app.objectId = this.selectedRowData.id;
        this.app.objectType = SOObjectNames.RECEIVE_PAYMENT;
        this.selectableColumns = this.getcolumns(this.estimatesCols2);
        this.selectedView = "split";
        this.receivedPaymentId = this.selectedRowData?.id;
        this.glApiCall = true
        this.selectedId = this.selectedRowData.id;
        this.getAllSalesReceiptsPagination(this.pageNumber, this.pageSize, this.selectedRowData?.id);
    }
    SRDetail() {
        this.displaySRDetails = true;
    }
    cancelSRDetails() {
        this.displaySRDetails = false;
    }
    applyGroup() {
        this.selectedView = 'list';
        this.selectableColumns = this.getcolumns(this.salesReceiptsCols);
        if (this.selectedGroupBy) {
            this.disabledLabelNames = [...new Set([...this.appliedFilterColName, this.selectedGroupBy.columnName])];
        }
        this.selectedGroupByValue = this.selectedGroupBy;
        this.getAllSalesReceiptsPagination(this.pageNumber, this.pageSize, "");
    }
    onAllGroupExpand() {
        this.groupAllExpanded = !this.groupAllExpanded;
        this.salesReceiptsData.map((rowData) => {
            rowData["expanded"] = this.groupAllExpanded;
        });
    }

    onGroupExpand(rowData: any) {
        rowData["expanded"] = !rowData?.expanded as boolean;
    }
    //#region group by
    onListPageChange($event, rowData: any) {
        const requestModel: SalesReceiptRequestModel = {
            ids: null,
            channelId: this.selectedAccChannel?.id || 0,
            isActive: this.isActive,
            globalSearchValue: this.searchValue.trim() || "",
            selectableColumns: this.selectableColumns,
            filter: "",
            pageSize: 15,
            pageNumber: ($event?.page + 1),
            sortByColumn: this.sortCol,
            sortByColumnDataType: this.sortCol ? this.salesReceiptsCols?.find((ele) => ele.columnName == this.sortCol)?.dataType : null,
            isSortByDescending: this.sortFlag ?? null,
            filterInColumns: this.filterInColumns,
            excludeDefaultColumns: false,
            IncludeAllCustomAttributes: false,
        };
        let groupValue = rowData.groupByValue === null ? [""] : [rowData.groupByValue];
        let operator = "IsEqualTo";
        if (!rowData.groupByValue) {
            operator = "NoValue";
        } else if (this.selectedGroupByValue?.fieldDataType == "DateTime") {
            operator = "Between";
            groupValue = [];
            let dateRangeFrom = new Date(rowData.groupByValue);
            let dateRangeTo = new Date(rowData.groupByValue);

            dateRangeFrom = this.timeZoneService._getUTCDateTimeWithZone(dateRangeFrom, (this.selectedGroupByValue?.isDateWithTime || false), true, false);
            dateRangeTo = this.timeZoneService._getUTCDateTimeWithZone(dateRangeTo, (this.selectedGroupByValue?.isDateWithTime || false), true, false);
            dateRangeTo.setDate(dateRangeTo.getDate() + 1);
            dateRangeTo = new Date(dateRangeTo.getTime() - 1000);
            groupValue.push(this.timeZoneService._getUTCDateTimeString(dateRangeFrom), this.timeZoneService._getUTCDateTimeString(dateRangeTo));
        }
        const groupFilterData: FilterInColumn = {
            name: this.selectedGroupByValue?.columnName,
            value: null,
            operator: operator,
            operationType: "AND",
            values: groupValue
        }

        const groupFilterIndex = requestModel.filterInColumns?.findIndex(filter => filter.name == this.selectedGroupByValue?.columnName);

        if (groupFilterIndex >= 0) {
            requestModel.filterInColumns[groupFilterIndex] = groupFilterData;
        } else {
            requestModel.filterInColumns.push(groupFilterData);
        }

        this.appMainService.isShowSpinner('getOpportunitiesByGroupId');
        this.salesOrderService.getAllSalesReceiptsPagination(requestModel).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response) => {
                if (response) {
                    rowData.list = response['list'];
                }
                this.showFloatHeader = true;
                this.appMainService.isHideSpinner('getOpportunitiesByGroupId');
            },
            error: (error) => {
                this.appMainService.isHideSpinner('getOpportunitiesByGroupId');
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error!',
                    detail: 'Error occurring when loading leads. Please try after sometime.'
                });
            },
            complete: () => {

            }
        });
    }
    editSalereceipt(e) {
        this.selectedId = null;
        this.displayInvoiceReceive = true;
        this.receivePaymentDialogType = ReceivePaymentDialogType.Edit;
    }
    getcolumns(columns: any[]): any[] {
        const selectableColumns = columns
            .filter((col) => col.checked)
            .map((col) => ({
                columnName: col.field,
                isCustom: false,
            }));
        return selectableColumns;
    }
    showGroupBy() {
        this.selectedGroupBy = this.selectedGroupByValue || null;
    }
    resetGroup(reloadList: boolean = false) {
        this.selectedGroupByValue = null;
        this.getAllSalesReceiptsPagination(this.pageNumber, this.pageSize, "");
    }
    onSortColumn(event) {
        this.sortFlag = !(event.order === 1);
        this.sortCol = event.field;
        this.getAllSalesReceiptsPagination(this.pageNumber, this.pageSize, '');
    }
    voidReceivedPayment(isVoid) {
        const isVoidStatus = isVoid ? "Void" : "Delete";
        this.confirmationService.confirm({
            message: `Do you want to ${isVoidStatus} this Receive Payment?`,
            header: `${isVoidStatus} Confirmation`,
            icon: "pi pi-info-circle",
            accept: () => {
                this.appMainService.isShowSpinner("voidreceivedPayment");
                this.salesOrderService
                    .voidReceivedPayment(this.receivedPaymentId, isVoid)
                    .pipe(takeUntil(this.ngUnsubscribe$))
                    .subscribe({
                        next: (res) => {
                            this.appMainService.isHideSpinner("voidreceivedPayment");
                            this.getAllSalesReceiptsPagination(this.pageNumber, this.pageSize, "");
                            this.messageService.add({
                                severity: "success",
                                summary: "Success",
                                detail: `${isVoidStatus}${isVoid ? "ed" : "d"} Successfully...`,
                            });
                        },
                        error: () => {
                            this.appMainService.isHideSpinner("voidreceivedPayment");
                            this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
                        },
                    });
            },
            reject: () => { },
        });
    }
    buildSalesReceiptContextMenu() {
        this.selectedInvoicing = this.selectedRowData;
        this.receivedPaymentId = this.selectedRowData?.referenceid;
        this.configMenuItemsSalesReceipt = [
            {
                label: "View",
                icon: "pi pi-list",
                command: () => {
                    this.selectedId = null;
                    this.displayInvoiceReceive = true;
                    this.receivePaymentDialogType = ReceivePaymentDialogType.ViewPaymentDetails;
                },
            },
            {
                label: "Edit",
                icon: "pi pi-pencil",
                command: () => {
                    this.selectedId = null;
                    this.displayInvoiceReceive = true;
                    this.receivePaymentDialogType = ReceivePaymentDialogType.Edit;
                },
            },
            {
                label: "Delete",
                icon: "pi pi-trash",
                visible: true,
                command: () => {
                    this.voidReceivedPayment(false);
                },
            },
            {
                label: "Void",
                icon: "pi pi-ban",
                command: () => {
                    this.voidReceivedPayment(true);
                },
            },
            {
                label: "Print",
                icon: "pi pi-print",
                items: [
                    {
                        label: "Print",
                        icon: "pi pi-print",
                        command: () => {
                            this.isSRpdf = true;
                            this.selectableColumns = this.getcolumns(this.estimatesCols2);
                            this.getAllSalesReceiptsPagination(this.pageNumber, this.pageSize, this.selectedRowData?.id, 'Print');
                        },
                    },
                ],
            },
            {
                label: "Email",
                icon: "pi pi-envelope",
                command: () => {
                    this.isSRpdf = true;
                    this.selectableColumns = this.getcolumns(this.estimatesCols2);
                    this.getAllSalesReceiptsPagination(this.pageNumber, this.pageSize, this.selectedRowData?.id, 'Email');
                },
            },
        ];
    }
    applyFilters(event: { selectedFilter: FilterInColumn[], selectedColumnsForSaveFilterFieldsChannelWise: FilterInColumn[] }) {
        if (event?.selectedFilter) {
            this.filterInColumns = event?.selectedFilter.map(ele => ({
                ...ele,
                formControlType: this.salesReceiptsCols?.find(obj => obj.columnName === ele.name)?.dataType
            }));
        } else {
            this.filterInColumns = null;
        }
        this.pageNumber = 1;
        this.pageSize = 15;
        this.getAllSalesReceiptsPagination(this.pageNumber, this.pageSize, '');
    }
    getAllInvoiceByPagination(typeId, pageNumber, pageSize, filters, searchValue, searchColumn, sortBy, isAscending, isActive) {
        this.appMainService.isShowSpinner("loadInvoice");
        const accChannelId = this.selectedAccChannel?.id ? this.selectedAccChannel?.id : 0;
        this.salesOrderService
            .getAllInvoiceByPagination(typeId, pageNumber, pageSize, filters, searchValue, searchColumn, sortBy, isAscending, isActive, accChannelId)
            .then((products) => {
                let { inventory, headers } = products;
                inventory = inventory == null ? [] : inventory;
                headers = headers == null ? [] : headers;
                this.totalRecord = headers["TotalCount"];
                this.invoicingData = [];
                if (inventory.length > 0) {
                    const invoices = inventory.map(c => ({
                        ...c,
                        contactName: c.contact ? c.contact.firstName : "",
                        statusName: c.invoiceStatus,
                        createdDate: this.app._showDateTimeWithZone(c.createdDate),
                        invoicedate: this.app._showDateTimeWithZone(c.invoiceDate),
                        duedate: c.invoiceDueDate ? this.app._showDateTimeWithZone(c.invoiceDueDate) : "",
                        createdBy: c.createdByUser,
                        totalAmt: this.multiCurrency.transform(c.netAmount ?? 0, (c.exchangeRate ? c.exchangeRate : this.baseCurrency?.exchangeRate), (c.currencyUnit?.symbol ?? this.baseCurrency?.symbol), this.fractionDigits),
                        dueAmt: this.multiCurrency.transform(c.dueAmount ?? 0, (c.exchangeRate ? c.exchangeRate : this.baseCurrency?.exchangeRate), (c.currencyUnit?.symbol ?? this.baseCurrency?.symbol), this.fractionDigits),
                        statusId: c.invoiceStatusId,
                        accountName: c.account?.businessName,
                        payterm: c.paymentTerm?.name || "",
                        paymethod: c.paymentMethod?.name || "",
                        shipterm: c.shippingTerm?.name || "",
                        shipmethod: c.shippingMethod?.name || "",
                        salesrep: c.user?.name || "",
                        paymentstatus: c.invoicePaymentStatus || "",
                        isActive: c.statusId,
                        refno: c?.referenceNumber ?? "",
                    }));
                    this.invoicingData = JSON.parse(JSON.stringify(invoices));
                    if (this.fromGlobalSearch) {
                        this.selectedView = "split";
                        this.onRowSelect();
                    }
                    this.showFloatHeader = true;
                } else {
                    this.invoicingData = [];
                    this.noCaseFindOrLoadingText = "No Invoice found";
                }
                this.appMainService.isHideSpinner("loadInvoice");
            })
            .catch((error) => {
                this.appMainService.isHideSpinner("loadInvoice");
            });
    }

    getInvoiceRecievedPaymentsById(id) {
        this.invoiceRecievedPayments = [];
        this.appMainService.isShowSpinner("loadInvoice");
        this.salesOrderService.getInvoiceReceivedPaymentById(id, true).subscribe((res) => {
            const d = [];
            if (res && res.length > 0) {
                res.forEach((r) => {
                    const obj = {
                        ...r,
                        id: r.receivedPaymentId,
                        invoiceId: r.invoiceId,
                        statusName: r.status,
                        createdDate: this.app._showDateTimeWithZone(r.createdDate),
                        totalAmt: r.totalAmount,
                        dueAmt: r.dueAmount,
                        paidAmt: r.paidAmount,
                        repname: r.repName,
                    };
                    d.push(obj);
                });
            }
            this.invoiceRecievedPayments = d;
            this.appMainService.isHideSpinner("loadInvoice");
        });
    }
    getSalesOrderRecievedPaymentsById(id) {
        this.salesOrderRecievedPayments = [];
        this.appMainService.isShowSpinner("loadInvoice");
        this.salesOrderService.getSalesOrderReceivedPaymentById(id, true).subscribe((res) => {
            const d = [];
            if (res && res.length > 0) {
                res.forEach((r) => {
                    const obj = {
                        ...r,
                        id: r.receivedPaymentId,
                        invoiceId: r.invoiceId,
                        statusName: r.status,
                        createdDate: this.app._showDateTimeWithZone(r.createdDate),
                        totalAmt: r.totalAmount,
                        dueAmt: r.dueAmount,
                        paidAmt: r.paidAmount,
                        repname: r.repName,
                    };
                    d.push(obj);
                });
            }
            this.salesOrderRecievedPayments = d;
            this.appMainService.isHideSpinner("loadInvoice");
        });
    }

    showTransactionDetails(e) {
        if (this.selectedChannel?.name == SOChannel.CREDIT_MEMO) {
            if (e?.data?.transactionTypeName?.toLowerCase() == 'check') {
                this.showWriteCheckDialog(e);
            } else {
                this.getReceivedPaymentsById(e);
            }
        } else {
            this.getReceivedPaymentsById(e);
        }
    }
    getReceivedPaymentsById(e) {
        this.receivedPaymentId = e?.data?.id;
        this.displayInvoiceReceive = true;
        this.receivePaymentDialogType = ReceivePaymentDialogType.ViewPaymentDetails;
    }

    /** Write Check */
    showWriteCheckDialog(e) {
        this.checkId = e?.data?.rowId;
        this.checkDialogType = "VIEW";
        this.displayWriteCheck = true;
    }
    onCloseWriteCheckDialog() {
        this.checkDialogType = "";
        this.displayWriteCheck = false;
    }
    /** End Write Check */

    handleChange(action?) {
        const tabHeader = this.tabView?.tabs[this.activeIndex]?.header;
        if (tabHeader == TabHeaderConst.Transactions) {
            this.getSalesOrderRecievedPaymentsById(this.selectedOrder.id ?? 0);
            this.glApiCall = false;
        }
        if (tabHeader == TabHeaderConst.ImpactsOnGL) {
            this.glApiCall = true;
        }
        else{
            this.glApiCall = false;
        }
      }

    getInvoicingDetailsById(id, menuType = "") {
        this.appMainService.isShowSpinner("loadInvoiceDetails");
        this.salesOrderService.getInvoiceDetailsById(id).subscribe(
            (res) => {
                this.appMainService.isHideSpinner("loadInvoiceDetails");
                this.invoicingDetails = res;
                if (this.invoicingDetails && this.invoicingDetails.configJSON) {
                    this.invoiceDetailsTemplates = JSON.parse(this.invoicingDetails.configJSON);
                } else {
                    this.invoiceDetailsTemplates = this.templates.filter((t) => t.typeId == 4)[0];
                }
                this.invoiceDetailsCustomFields = this.utilityService.getCustomAttributesForCommon(this.invoiceDetailsTemplates, this.allCustomAttributes);
                this.invoicingDetailsPurchaseList = this.utilityService.parseInvoiceProductsListForOverview(this.invoicingDetails, this.discounts);
                //check whether bulk import option available or not
                this.bulkImportAvailble = this.utilityService.checkforBulkImportInvoice(this.invoicingDetailsPurchaseList);
                this.onUpdateInvoiceBuildContextMenu(this.invoicingDetails.invoiceStatusId, this.invoicingDetails.dueAmount, this.invoicingDetails.statusId, this.invoicingDetails.approvalStatusId);

                // populate saved custom field data
                if (this.invoicingDetails.customAttributeValues && this.invoicingDetails.customAttributeValues.length) {
                    Object.keys(this.invoiceDetailsCustomFields).forEach((key) => {
                        const dataArr = this.invoiceDetailsCustomFields[key];
                        for (let element of dataArr) {
                            const filteredCustom = this.invoicingDetails.customAttributeValues.filter((c) => c.customAttributeId == element.id)[0];

                            if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "InputBox") {
                                element.value = filteredCustom.value;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DatePicker") {
                                element.value = this.datepipe.transform(filteredCustom.value, "MM/dd/yyyy");
                            } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == "FileUpload" || filteredCustom.customAttribute?.formControl?.name == "Picture")) {
                                element.customUploadedFiles = [];
                                filteredCustom.customeAttachement.forEach((el) => {
                                    element.customUploadedFiles.push(el);
                                });
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Rating") {
                                element.value = filteredCustom.ratingId;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "ToggleButton") {
                                element.value = filteredCustom.toggle;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DropDownList") {
                                element.value = filteredCustom.values;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "RadioButton") {
                                element.value = filteredCustom.values.name;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "CheckBox") {
                                element.value = [];
                                filteredCustom.multipleValues.forEach((el) => {
                                    element.value.push(el.name);
                                });
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "MultipleDropDownList") {
                                element.value = [];
                                filteredCustom.multipleValues.forEach((el) => {
                                    element.value.push(el);
                                });
                            }
                        }
                    });
                }

                if (menuType == "PRINT") {
                    setTimeout(() => {
                        this.invoicePrint.print();
                    }, 1000);
                } else if (menuType == "EMAIL") {
                    setTimeout(() => {
                        this.openEmailDialog();
                    }, 1000);
                } else if (menuType == SOEmailAttachmentType.EMAILINVOICE) {
                    setTimeout(() => {
                        this.openEmailDialog(menuType);
                    }, 1000);
                } else if (menuType == "SHOW_LABEL") {
                    const url = this.invoicingDetails.invoiceShipment && this.invoicingDetails.invoiceShipment.length ? this.invoicingDetails.invoiceShipment[this.invoicingDetails.invoiceShipment.length - 1].labelLink : "";
                    if (url) {
                        this.showLabel(url);
                    }
                }
            },
            (err) => {
                this.appMainService.isHideSpinner("loadInvoiceDetails");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred...",
                });
            },
        );
    }

    getInvoicesBySalesOrderId(id) {
        this.allShipStagesInvoice = [];
        this.appMainService.isShowSpinner("loadSO");
        this.salesOrderService.getInvoicesBySalesOrderId(id).subscribe(
            (res) => {
                this.appMainService.isHideSpinner("loadSO");
                this.allShipStagesInvoice = res;
                // if(this.allShipStagesInvoice && this.allShipStagesInvoice.length){
                //     console.log(this.allShipStagesInvoice[0]);
                //     this.parseInvoiceDetailsData(this.allShipStagesInvoice[0]);
                // }
            },
            (err) => {
                this.appMainService.isHideSpinner("loadSO");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred...",
                });
            },
        );
    }

    getCustomerReturnDetailsById(id, menuType = "") {
        this.appMainService.isShowSpinner("loadCustomerReturnDetails");
        this.salesOrderService.getCustomerReturnById(id).subscribe(
            (res) => {
                this.appMainService.isHideSpinner("loadCustomerReturnDetails");
                this.customerReturnDetails = _.cloneDeep(res);
                if (this.customerReturnDetails && this.customerReturnDetails.configJSON) {
                    this.returnDetailsTemplates = JSON.parse(this.customerReturnDetails.configJSON);
                } else {
                    this.returnDetailsTemplates = this.customerReturnTemplates;
                }
                this.updateCustomerReturnContextMenu(this.customerReturnDetails.isConverted, this.customerReturnDetails.rmaStatusId, this.customerReturnDetails.requestType);
                if(menuType) {
                    this.returnPrint?.getCustomerReturnsInfo(this.customerReturnDetails,menuType);
                }
            },
            (err) => {
                this.appMainService.isHideSpinner("loadCustomerReturnDetails");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while loading data",
                });
            },
        );
    }
    updateCustomerReturnContextMenu(isConverted, statusId, requestType) {
        this.configMenuItemsReturns = [
            {
                label: "Edit",
                icon: "pi pi-pencil",
                visible: statusId != RmaStatus.Approved,
                command: () => {
                    this.showEditCustomerReturn({ id: this.selectedReturn?.id });
                },
            },
            {
                label: "Delete",
                icon: "pi pi-trash",
                visible: true,
                command: () => {
                    this.deleteCustomerReturn(this.selectedReturn?.id, "delete");
                },
            },
            {
                label: "Void",
                icon: "pi pi-ban",
                visible: statusId == RmaStatus.Approved,
                command: () => {
                    this.deleteCustomerReturn(this.selectedReturn?.id, "void");
                },
            },
            {
                label: "Convert to Sales Order",
                icon: "pi pi-pencil",
                visible: !isConverted && statusId == RmaStatus.Approved && requestType == "Exchange",
                command: () => {
                    this.convertRMAToSalesOrder({
                        id: this.selectedReturn?.id,
                    });
                },
            },
            {
                label: "Convert to Invoice",
                icon: "pi pi-pencil",
                visible: !isConverted && statusId == RmaStatus.Approved && requestType == "Exchange",
                command: () => {
                    this.convertRMAToInvoice({
                        id: this.selectedReturn?.id,
                    });
                },
            },
            {
                label: "Convert to Credit Memo",
                icon: "pi pi-pencil",
                visible: !isConverted && statusId == RmaStatus.Approved && requestType == "Credit",
                command: () => {
                    this.convertRMAToCreditMemo({
                        id: this.selectedReturn?.id,
                    });
                },
            },
            {
                label: "Print",
                icon: "pi pi-print",
                items: [
                    {
                        label: "Print",
                        icon: "pi pi-print",
                        command: () => {
                            this.returnPrint?.getCustomerReturnsInfo(this.customerReturnDetails,'PRINT');
                        },
                    },
                ],
            },
            {
                label: "Email",
                icon: "pi pi-envelope",
                command: () => {
                    this.returnPrint?.getCustomerReturnsInfo(this.customerReturnDetails,'EMAIL');
                },
            },
        ];
    }

    getCreditMemoDetailsById(id, menuType = "") {
        this.appMainService.isShowSpinner("loadCreditMemoDetails");
        this.overviewCustomAttributes = _.cloneDeep(this.customAtributes);
        this.salesOrderService.getCreditMemoById(id).subscribe(
            (res) => {
                this.appMainService.isHideSpinner("loadCreditMemoDetails");
                this.creditMemoDetails = _.cloneDeep(res);
                if (this.creditMemoDetails && this.creditMemoDetails.configJSON) {
                    this.cmDetailsTemplates = JSON.parse(this.creditMemoDetails.configJSON);
                } else {
                    this.cmDetailsTemplates = this.estimateTemplates;
                }
                this.cmDetailsCustomFields = this.utilityService.getCreditMemoCustomAttributes(this.cmDetailsTemplates, this.allCustomAttributes);
                this.creditMemoDetailsPurchaseList = this.utilityService.parseCreditMemoProductsListForOverview(this.creditMemoDetails, this.discounts);
                //check whether bulk import option available or not
                this.bulkImportAvailble = this.utilityService.checkforBulkImportCM(this.creditMemoDetailsPurchaseList);

                // populate saved custom field data
                Object.keys(this.cmDetailsCustomFields).forEach((key) => {
                    const dataArr = this.cmDetailsCustomFields[key];
                    if (dataArr && dataArr.length > 0) {
                        dataArr.forEach((element) => {
                            const filteredCustom = this.creditMemoDetails.customAttributeValues.filter((c) => c.customAttributeId == element.id)[0];
                            if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "InputBox") {
                                element.value = filteredCustom.value;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DatePicker") {
                                element.value = this.datePipe.transform(filteredCustom.value, "MM/dd/yyyy");
                            } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == "FileUpload" || filteredCustom.customAttribute?.formControl?.name == "Picture")) {
                                element.customUploadedFiles = [];
                                filteredCustom.customeAttachement.forEach((el) => {
                                    element.customUploadedFiles.push(el);
                                });
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Rating") {
                                element.value = filteredCustom.ratingId;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "ToggleButton") {
                                element.value = filteredCustom.toggle;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DropDownList") {
                                element.value = filteredCustom.values;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "RadioButton") {
                                element.value = filteredCustom.values.name;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "CheckBox") {
                                element.value = [];
                                filteredCustom.multipleValues.forEach((el) => {
                                    element.value.push(el.name);
                                });
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "MultipleDropDownList") {
                                element.value = [];
                                filteredCustom.multipleValues.forEach((el) => {
                                    element.value.push(el);
                                });
                            }
                        });
                    }
                });

                if (menuType == "PRINT") {
                    setTimeout(() => {
                        this.soPdf.print();
                    }, 1000);
                } else if (menuType == "EMAIL") {
                    setTimeout(() => {
                        this.openEmailDialog();
                    }, 1000);
                }
            },
            (err) => {
                this.appMainService.isHideSpinner("loadCreditMemoDetails");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred...",
                });
            },
        );
    }

    sodetailsDeepCopy;
    prepareSalesOrderDetailsData(res, menuType = "") {
        this.sodetailsDeepCopy = _.cloneDeep(res);
        this.salesOrderDetails = res;
        this.selectedOrdersStageId = this.salesOrderDetails?.salesOrderStageId;
        this.showPickColumn = this.selectedOrdersStageId == SoStageId.Entered ? false : true;
        this.selectedBackOrderOption = this.salesOrderDetails?.backOrderTypeId;
        if (this.selectedOrdersStageId > SoStageId.Pack && this.selectedView == "split") {
            this.getAllVendors();
        }
        if (this.selectedOrdersStageId == SoStageId.Shipped && this.selectedView == "split") {
            this.getInvoicesBySalesOrderId(this.selectedOrder.id); // for tab
            this.getInvoicingDetailsById(this.salesOrderDetails.invoiceId); // for print
        }
        if (this.salesOrderDetails && this.salesOrderDetails.configJSON) {
            this.soDetailsTemplates = JSON.parse(this.salesOrderDetails.configJSON);
        } else {
            this.soDetailsTemplates = this.estimateTemplates;
        }
        this.soDetailsCustomFields = this.utilityService.getCustomAttributesForCommon(this.soDetailsTemplates, this.allCustomAttributes);
        this.saleOrdersDetailsPurchaseList = this.utilityService.parseSoProductsListForOverview(res, this.discounts);
        //check whether bulk import option available or not
        this.bulkImportAvailble = this.utilityService.checkforBulkImportSO(this.saleOrdersDetailsPurchaseList);

        this.saleOrdersDetailsPurchaseList.forEach((element) => {
            if (element.typeId == TypeIds.BundleTypeId) {
                let total = 0;
                if (element?.salesOrderBundleDetail && element?.salesOrderBundleDetail?.length > 0) {
                    element?.salesOrderBundleDetail?.forEach((e) => {
                        total += e.amount;
                    });
                }
                element.amount = total;
            }
        });
        this.buildSOContextMenu(this.salesOrderDetails?.salesOrderStageId, this.salesOrderDetails?.salesOrderStatusId, this.salesOrderDetails?.approvalStatusId);
        this.onClickSoMenu(menuType);

        // populate saved custom field data
        if (this.salesOrderDetails?.customAttributeValues && this.salesOrderDetails?.customAttributeValues?.length) {
            Object.keys(this.soDetailsCustomFields).forEach((key) => {
                const dataArr = this.soDetailsCustomFields[key];
                if (dataArr && dataArr.length > 0) {
                    dataArr.forEach((element) => {
                        const filteredCustom = this.salesOrderDetails.customAttributeValues.filter((c) => c.customAttributeId == element.id)[0];
                        if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "InputBox") {
                            element.value = filteredCustom.value;
                        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DatePicker") {
                            element.value = this.datePipe.transform(filteredCustom.value, "MM/dd/yyyy");
                        } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == "FileUpload" || filteredCustom.customAttribute?.formControl?.name == "Picture")) {
                            element.customUploadedFiles = [];
                            filteredCustom.customeAttachement.forEach((el) => {
                                element.customUploadedFiles.push(el);
                            });
                        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Rating") {
                            element.value = filteredCustom.ratingId;
                        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "ToggleButton") {
                            element.value = filteredCustom.toggle;
                        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DropDownList") {
                            element.value = filteredCustom.values;
                        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "RadioButton") {
                            element.value = filteredCustom.values.name;
                        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "CheckBox") {
                            element.value = [];
                            filteredCustom.multipleValues.forEach((el) => {
                                element.value.push(el.name);
                            });
                        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "MultipleDropDownList") {
                            element.value = [];
                            filteredCustom.multipleValues.forEach((el) => {
                                element.value.push(el);
                            });
                        }
                    });
                }
            });
        }
    }

    getSalesOrderDetailsById(id, menuType = "") {
        this.selectedBackOrderOption = 0;
        this.appMainService.isShowSpinner("loadSO");
        this.salesOrderService.getSalesOrderDetailsById(id).subscribe(
            (res) => {
                this.appMainService.isHideSpinner("loadSO");
                this.prepareSalesOrderDetailsData(res, menuType);
            },
            (err) => {
                this.appMainService.isHideSpinner("loadSO");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred...",
                });
            },
        );
    }

    onClickSoMenu(menuType) {
        if (menuType == PrintType.PRINT) {
            setTimeout(() => {
                this.soPdf.print(PrintType.PRINT);
            }, 1000);
        } else if (menuType == PrintType.PACKSLIPPRINT) {
            setTimeout(() => {
                this.soPdf.print(PrintType.PACKSLIPPRINT);
            }, 1000);
        } else if (menuType == PrintType.PICKSLIPPRINT) {
            setTimeout(() => {
                this.soPdf.print(PrintType.PICKSLIPPRINT);
            }, 1000);
        } else if (menuType == SOEmailAttachmentType.EMAILSO || menuType == SOEmailAttachmentType.EMAILPICKSLIP || menuType == SOEmailAttachmentType.EMAILPACKSLIP) {
            setTimeout(() => {
                this.openEmailDialog(menuType);
            }, 1000);
        } else if (menuType == "SHOW_LABEL") {
            const url = this.salesOrderDetails.shipment && this.salesOrderDetails.shipment.length ? this.salesOrderDetails.shipment[this.salesOrderDetails.shipment.length - 1].labelLink : "";
            if (url) {
                this.showLabel(url);
            }
        }

        // else if (menuType == "SHOW_UPS_LABEL") {
        //     const obj = {
        //         trackingNo: this.salesOrderDetails.shipment && this.salesOrderDetails.shipment.length
        //             ? this.salesOrderDetails.shipment[this.salesOrderDetails.shipment.length - 1].trackingNo
        //             : "",
        //     }
        //     this.onUpsViewLabel(obj);
        // }
    }

    showStatus() {
        this.selectedId = null;
        this.displayStatus = true;
        this.allStatus = this.allStages.filter((s) => s.id == this.salesOrderDetails.salesOrderStageId)[0].status;
        this.selectedStatus = this.allStatus.filter((s) => s.id == this.salesOrderDetails.salesOrderStatusId)[0];
        this.statusTB = this.allStatus;
    }

    onRowSelectStatus(e) {
        this.appMainService.isShowSpinner("loadSO");
        const req = _.cloneDeep(this.salesOrderDetails);
        req.salesOrderStatusId = this.selectedStatus.id;
        req.salesObjectId = this.salesObjectId;
        req.businessName = this.salesOrderDetails?.account?.businessName;

        req.account = null;
        req.warehouse = null;
        req.user = null;
        req.shippingAddress = null;
        req.discountType = null;
        req.paymentMethod = null;
        req.paymentTerm = null;
        req.shippingMethod = null;
        req.shippingTerm = null;
        if (req.salesOrderProducts && req.salesOrderProducts.length) {
            req.salesOrderProducts.forEach((e) => {
                e.product = null;
                if (e?.salesOrderBundleDetail && e?.salesOrderBundleDetail?.length > 0) {
                    e?.salesOrderBundleDetail?.forEach((b) => {
                        b.product = null;
                    });
                }
            });
        }

        this.salesOrderService
            .updateSalesOrder(req, this.isBaseCurrency(this.salesOrderDetails?.account?.currencyId))
            .then(() => {
                this.appMainService.isHideSpinner("loadSO");
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Sales Order updated successfully...",
                });
                this.displayStatus = false;
                this.selectedId = this.selectedOrder.id;
                this.getSalesOrderDetailsById(this.selectedOrder.id);
            })
            .catch(() => {
                this.appMainService.isHideSpinner("loadSO");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while updating data...",
                });
            });
    }

    onChangeRecentFilter() {
        switch (this.selectedChannel?.name) {
            case this.soChannel.ESTIMATES:
                this.getAllEstimatesByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecent.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
                break;
            case this.soChannel.SALES_ORDER:
                this.getAllSalesOrderByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentSOFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
                break;
            case this.soChannel.INVOICING:
                this.getAllInvoiceByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentInvoiceFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
                break;
            case this.soChannel.CUSTOMER_RETURNS:
                this.getAllCustomerReturnsByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentCustomerReturnFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
                break;
            case this.soChannel.CREDIT_MEMO:
                this.getAllCreditMemoByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentCreditMemoFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
                break;
        }
    }

    search() {
        this.searchControl.valueChanges.pipe(debounceTime(700), distinctUntilChanged()).subscribe((value) => {
            this.searchValue = value.trim() ? value.trim() : "";
            this.onGlobalSearch();
        });
    }

    onGlobalSearch() {
        this.pageNumber = 1;
        switch (this.selectedChannel?.name) {
            case this.soChannel.ESTIMATES:
                this.searchColumns = SearchColumns.Estimate;
                this.getAllEstimatesByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecent.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
                break;
            case this.soChannel.SALES_ORDER:
                this.searchColumns = SearchColumns.SalesOrder;
                this.getAllSalesOrderByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentSOFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
                break;
            case this.soChannel.INVOICING:
                this.searchColumns = SearchColumns.Invoice;
                this.getAllInvoiceByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentInvoiceFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
                break;
            case this.soChannel.CUSTOMER_RETURNS:
                this.searchColumns = SearchColumns.CustomerReturn;
                this.getAllCustomerReturnsByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentCustomerReturnFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive, true);
                break;
            case this.soChannel.CREDIT_MEMO:
                this.searchColumns = SearchColumns.CreditMemo;
                this.getAllCreditMemoByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentCreditMemoFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
                break;
            case this.soChannel.SALES_RECEIPT:
                this.searchColumns = SearchColumns.SalesReceipts;
                this.getAllSalesReceiptsPagination(this.pageNumber, this.pageSize,'');
                break;
        }
    }

    onColumnFilterChange(value, field) {
        let inputValue = {
            value: value,
            field: field,
        };
        this.columnFilterInput$.next(inputValue);
    }
    setupColumnFilterSubscription() {
        this.columnFilterInput$.pipe(debounceTime(700)).subscribe((inputValue) => {
            this.loadDataOnColumnFilterChange(inputValue.value, inputValue.field);
        });
    }
    loadDataOnColumnFilterChange(value, field) {
        this.searchValue = value;
        this.pageNumber = 1;
        if(value && value?.length > 0) {
            switch (this.selectedChannel?.name) {
                case this.soChannel.ESTIMATES:
                    this.searchColumns = EstimateFilterColumns.hasOwnProperty(field) ? EstimateFilterColumns[field] : field;
                    this.getAllEstimatesByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecent.code, value, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
                    break;
                case this.soChannel.SALES_ORDER:
                    this.searchColumns = SoFilterColumns.hasOwnProperty(field) ? SoFilterColumns[field] : field;
                    this.getAllSalesOrderByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentSOFilter.code, value, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
                    break;
                case this.soChannel.INVOICING:
                    this.searchColumns = InvoiceFilterColumns.hasOwnProperty(field) ? InvoiceFilterColumns[field] : field;
                    this.getAllInvoiceByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentInvoiceFilter.code, value, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
                    break;
                case this.soChannel.CUSTOMER_RETURNS:
                    this.searchColumns = CustomerReturnFilterColumns.hasOwnProperty(field) ? CustomerReturnFilterColumns[field] : field;
                    this.getAllCustomerReturnsByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentCustomerReturnFilter.code, value, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
                    break;
                case this.soChannel.CREDIT_MEMO:
                    this.searchColumns = CrediMemoFilterColumns.hasOwnProperty(field) ? CrediMemoFilterColumns[field] : field;
                    this.getAllCreditMemoByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentCreditMemoFilter.code, value, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
                    break;
                case this.soChannel.SALES_RECEIPT:
                    if(value){
                    const filterObject = {
                        name: field,
                        displayName: this.salesReceiptsCols?.find(obj => obj.columnName === field)?.name,
                        operator: field == 'amount' ? 'IsEqualTo' : 'Contains',
                        operationType: 'AND',
                        values: [value],
                        filterValues: [],
                        formControlType: this.salesReceiptsCols?.find(obj => obj.columnName === field)?.dataType
                      };
                      this.filterInColumns = [filterObject];
                    }
                    this.pageNumber = 1;
                    this.pageSize = 15;
                    this.getAllSalesReceiptsPagination(this.pageNumber, this.pageSize,'');
                    break;
            }
        } else {
            this.filterInColumns = [];
            this.onGlobalSearch();
        }
    }

    onFilterIconClick(col: any, event: MouseEvent) {
      if (this.curCol && this.curCol !== col) {
        this.curCol.value = ''; 
        this.onColumnFilterChange('', this.curCol.field); 
      }
      this.curCol = col;
      this.columnFilter?.toggle(event); 
    }
    
    onChangePageFetchData(event) {
        this.pageNumber = event.first / event.rows + 1;
        this.isAscending = "false";
        this.pageSize = event.rows;
        this.first = event.first;
        this.sortBy = "";

        switch (this.selectedChannel?.name) {
            case this.soChannel.ESTIMATES:
                this.getAllEstimatesByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecent.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
                break;
            case this.soChannel.SALES_ORDER:
                this.getAllSalesOrderByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentSOFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
                break;
            case this.soChannel.INVOICING:
                this.getAllInvoiceByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentInvoiceFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
                break;
            case this.soChannel.CUSTOMER_RETURNS:
                this.getAllCustomerReturnsByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentCustomerReturnFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
                break;
            case this.soChannel.CREDIT_MEMO:
                this.getAllCreditMemoByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentCreditMemoFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
                break;
            case this.soChannel.SALES_RECEIPT:
                this.getAllSalesReceiptsPagination(this.pageNumber, this.pageSize,'');
                break;
        }
    }

    /** Estimate add/edit/void dialog show and hide */
    newEstimate() {
        this.estimateTemplates = this.templates.filter((t) => t.typeId == 2)[0];
        this.estimatesSections = this.allSections.filter((s) => s.typeId == 2 && s.isActive == true);
        this.estimateHeader = "New Estimates";
        this.displayEstimateAdd = true;
        this.estimateDialogType = DialogType.CREATE;
    }
    showEditEstimate({ id }) {
        this.estimateTemplates = this.templates.filter((t) => t.typeId == 2)[0];
        this.estimatesSections = this.allSections.filter((s) => s.typeId == 2 && s.isActive == true);
        this.selectedId = null;
        this.estimateHeader = "Edit Estimates";
        this.displayEstimateAdd = true;
        this.estimateDialogType = DialogType.EDIT;
    }
    showCopyEstimate({ id }) {
        this.estimateTemplates = this.templates.filter((t) => t.typeId == 2)[0];
        this.estimatesSections = this.allSections.filter((s) => s.typeId == 2 && s.isActive == true);
        this.selectedId = null;
        this.estimateHeader = "Copy Estimates";
        this.displayEstimateAdd = true;
        this.estimateDialogType = DialogType.COPY;
    }
    showViewEstimate({ id }) {
        this.estimateTemplates = this.templates.filter((t) => t.typeId == 2)[0];
        this.estimatesSections = this.allSections.filter((s) => s.typeId == 2 && s.isActive == true);
        this.selectedId = null;
        this.estimateHeader = "View Estimates";
        this.displayEstimateAdd = true;
        this.estimateDialogType = DialogType.VIEW;
    }
    closeEstimateAddModal() {
        this.displayEstimateAdd = false;
    }
    voidEstimate({ id }) {
        this.closingDateModuleName = TransactionNames.Estimate ;
        this.closingDate = this.app._showDateTimeWithZone(new Date(this.selectedEstimate?.estimateDate))

        this.confirmationService.confirm({
            message: "Do you want to void this Estimate?",
            header: "Void Confirmation",
            icon: "pi pi-info-circle",
            accept: () => {
                if (this.statementMessage) {
                    this.messageService.add({ severity: Severity.Warn, summary: this.titlecasePipe.transform(Severity.Warn), detail: ClosingYearDisplayMessages.voidDeleteMessage });
                  }else{
                this.submitEstimateVoidRequest(id);
            }
         } ,
            reject: () => { },
        });
    }
    copyEstimateList(){
        this.getAllEstimatesByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecent.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive)
    }
    submitEstimateVoidRequest(id) {
        this.salesOrderService.voidEstimate(id).subscribe(
            (res) => {
                this.displayEstimateAdd = false;
                this.messageService.add({
                    severity: Severity.Success,
                    summary: this.titlecasePipe.transform(Severity.Success),
                    detail: "Estimate voided Successfully",
                });
                if (this.selectedView == "list") {
                    this.getAllEstimatesByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecent.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
                } else {
                    this.getEstimatesDetailsById(id);
                }
            },
            (error) => {
                this.messageService.add({
                    severity: Severity.Error,
                    summary: this.titlecasePipe.transform(Severity.Error),
                    detail: "Error occurred...",
                });
            },
        );
    }
    deleteEstimate({ id }) {
        this.closingDateModuleName = TransactionNames.Estimate ;
        this.closingDate = this.app._showDateTimeWithZone(new Date(this.selectedEstimate?.estimateDate))
        this.confirmationService.confirm({
            message: "Do you want to delete this Estimate?",
            header: "Delete Confirmation",
            icon: "pi pi-info-circle",
            accept: () => {
                if (this.statementMessage) {
                    this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: ClosingYearDisplayMessages.voidDeleteMessage });
                  }else{
                this.salesOrderService
                    .deleteEstimate(id)
                    .then(() => {
                        this.messageService.add({
                            severity: "success",
                            summary: "Success",
                            detail: "Deleted Successfully...",
                        });

                        this.getAllEstimatesByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecent.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
                        if (this.selectedView == "split") {
                            this.selectedView = "list";
                            this.selectedEstimate = null;
                            this.estimatesColsAll = this.estimatesColsAllTemp;
                            this.estimatesCols = this.estimatesColsAll;
                            this.soCols = this.estimatesColsAllTemp;
                        }
                    })
                    .catch(() => {
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: "Error occurred while deleting data...",
                        });
                    });
            }
        },
            reject: () => { },
        });
    }
    onEstimateDialogCancel(event) {
        if (event.type === 'cancel') {
            event.stopPropagation(); 
            return;
          }
        this.displayEstimateAdd = false;
        this.estimateDialogType = "";
        this.isEstimateVoid = false;
    }
    onEstimateConfirmVoid(event) {
        this.confirmationService.confirm({
            message: "Are you sure that you want to proceed?",
            header: "Confirmation",
            icon: "pi pi-exclamation-triangle",
            accept: () => {
                this.showEstimateVoidMsg = !this.showEstimateVoidMsg;
                if (this.showEstimateVoidMsg) {
                    this.messageService.add({
                        severity: "info",
                        summary: "Confirmed",
                        detail: "You have voided",
                    });
                } else if (!this.showEstimateVoidMsg) {
                    this.messageService.add({
                        severity: "info",
                        summary: "Confirmed",
                        detail: "You have unvoided",
                    });
                }
                this.onEstimateDialogCancel(false);
            },
            reject: () => { },
        });
    }
    /** End Estimate add/edit/void dialog show hide */

    getAccountObj(accounts) {
        return accounts.map((account) => {
            const data = {
                ...account,
                contactName: account.accountContacts && account.accountContacts.length > 0 && account.accountContacts[0] && account.accountContacts[0].contactName ? account.accountContacts[0].contactName : null,
                accountStatus: account.accountStatus ? account.accountStatus.name : "",
                statusName: account.status ? account.status.name : null,
                childAccount: account.childAccount && account.childAccount.length > 0 ? this.getAccountObj(account.childAccount) : [],
            };
            return data;
        });
    }

    updateRowGroupMetaData() {
        this.rowGroupMetadata = {};
        //this.getExoandedRows(this.accountsList, 'main');
        this.rowGroupMetadata = this.accountsList;
    }

    /** Sales Order add/edit/convert/void dialog show/hide */
    newOrder() {
        this.shippedStagePickColumn = false;
        this.orderHeader = "New SalesOrder";
        this.minimumDate = new Date();
        this.orderStage = [...this.allStages.filter((p) => p.id == 1)][0];
        this.orderStatusDD = this.orderStage.children;
        this.displayConvertToSalesOrder = true;
        this.salesOrderDialogType = "CREATE";
        this.showPickColumn = false;
    }
    showEditOrder(c) {
        this.orderHeader = "Edit SalesOrder";
        this.selectedId = null;
        this.minimumDate = new Date();
        this.orderStage = [...this.allStages.filter((p) => p.id == 1)][0];
        this.orderStatusDD = this.orderStage.children;
        this.displayConvertToSalesOrder = true;
        this.salesOrderDialogType = "EDIT";
    }
    showCopyOrder(c) {
        this.orderHeader = "Copy SalesOrder";
        this.selectedId = null;
        this.minimumDate = new Date();
        this.orderStage = [...this.allStages.filter((p) => p.id == 1)][0];
        this.orderStatusDD = this.orderStage.children;
        this.displayConvertToSalesOrder = true;
        this.salesOrderDialogType = "COPY";
    }

    showShipOrder(c) {
        this.orderHeader = "Edit SalesOrder";
        this.isOrderToBeShipped = true;
        this.selectedId = null;
        this.minimumDate = new Date();
        this.orderStage = [...this.allStages.filter((p) => p.id == 1)][0];
        this.orderStatusDD = this.orderStage.children;
        this.displayConvertToSalesOrder = true;
        this.salesOrderDialogType = "EDIT";
    }
    showViewOrder(c) {
        this.orderHeader = "SalesOrder";
        this.selectedId = null;
        this.minimumDate = new Date();
        this.orderStage = [...this.allStages.filter((p) => p.id == 1)][0];
        this.orderStatusDD = this.orderStage.children;
        this.displayConvertToSalesOrder = true;
        this.salesOrderDialogType = "VIEW";
    }
    convertToSalesOrder({ id }) {
        this.orderHeader = "Convert To SalesOrder";
        this.selectedId = null;
        this.estimateTemplates = this.templates.filter((t) => t.typeId == 3)[0];
        this.estimatesSections = this.allSections.filter((s) => s.typeId == 3 && s.isActive == true);
        this.displayConvertToSalesOrder = true;
        this.salesOrderDialogType = "CONVERT";
    }
    voidSalesOrder({ id }) {
        this.closingDateModuleName = TransactionNames.SalesOrder ;
        this.closingDate = this.app._showDateTimeWithZone(this.selectedOrder?.salesOrderDate)
        this.confirmationService.confirm({
            message: "Do you want to void this Sales Order?",
            header: "Void Confirmation",
            icon: "pi pi-info-circle",
            accept: () => {
                if (this.statementMessage) {
                    this.messageService.add({ severity: Severity.Warn, summary: this.titlecasePipe.transform(Severity.Warn), detail: ClosingYearDisplayMessages.voidDeleteMessage });
                }else{
                this.submitSalesOrderVoidRequest(id);
            }
        },
            reject: () => { },
        });
    }
    submitSalesOrderVoidRequest(id) {
        this.salesOrderService.voidSalesOrder(id).subscribe(
            (res) => {
                this.displayConvertToSalesOrder = false;
                this.messageService.add({
                    severity: Severity.Success,
                    summary: this.titlecasePipe.transform(Severity.Success),
                    detail: "Sales Order voided Successfully",
                });
                if (this.selectedView == "list") {
                    this.getAllSalesOrderByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentSOFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
                } else {
                    this.getSalesOrderDetailsById(id);
                }
            },
            (error) => {
                this.messageService.add({
                    severity: Severity.Error,
                    summary: this.titlecasePipe.transform(Severity.Error),
                    detail: "Error occurred...",
                });
            },
        );
    }
    deleteOrder({ id }) {
        this.closingDateModuleName = TransactionNames.SalesOrder ;
        this.closingDate = this.app._showDateTimeWithZone(this.selectedOrder?.salesOrderDate)

        this.confirmationService.confirm({
            message: "Do you want to delete this SalesOrder?",
            header: "Delete Confirmation",
            icon: "pi pi-info-circle",
            accept: () => {
                if (this.statementMessage) {
                    this.messageService.add({ severity: Severity.Warn, summary: this.titlecasePipe.transform(Severity.Warn), detail: ClosingYearDisplayMessages.voidDeleteMessage });
                }else{
                this.salesOrderService
                    .deleteSalesOrder(id)
                    .then(() => {
                        this.messageService.add({
                            severity: "success",
                            summary: "Success",
                            detail: "Deleted Successfully...",
                        });

                        this.getAllSalesOrderByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentSOFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
                        if (this.selectedView == "split") {
                            this.selectedView = "list";
                            this.estimatesColsAll = this.estimatesColsAllTemp;
                            this.estimatesCols = this.estimatesColsAll;
                            this.soCols = this.estimatesColsAllTemp;
                        }
                    })
                    .catch(() => {
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: "Error occurred while deleting data...",
                        });
                    });
            }
        },
            reject: () => { },
        });
    }
    /** End Sales Order add/edit/void dialog show hide */

    /** Invoice add/edit/convert/void dialog show and hide */
    newInvoicing() {
        this.invoicingHeader = "New Invoicing";
        this.displayInvoicingAdd = true;
        this.invoicingDialogType = "CREATE";
    }
    showEditInvoicing({ id }) {
        this.invoicingHeader = "Edit Invoicing";
        this.displayInvoicingAdd = true;
        this.invoicingDialogType = "EDIT";
        this.selectedId = null;
    }
    showCopyInvoicing({ id }) {
        this.invoicingHeader = "Copy Invoicing";
        this.displayInvoicingAdd = true;
        this.invoicingDialogType = "COPY";
        this.selectedId = null;
    }
    showViewInvoicing({ id }) {
        this.invoicingHeader = this.soChannel.INVOICING;
        this.displayInvoicingAdd = true;
        this.invoicingDialogType = "VIEW";
        this.selectedId = null;
    }
    convertToInvoice({ id }) {
        this.invoicingHeader = "Convert To Invoice";
        this.selectedId = null;
        this.estimateTemplates = this.templates.filter((t) => t.typeId == 4)[0];
        this.estimatesSections = this.allSections.filter((s) => s.typeId == 4 && s.isActive == true);
        this.displayInvoicingAdd = true;
        this.invoicingDialogType = "CONVERT";
    }
    voidInvoice({ id }) {
        this.deleteInvoicing({ id }, true);
    }
    deleteInvoicing({ id }, isVoid = false) {
        this.closingDateModuleName = TransactionNames.Invoice ;
        this.closingDate = this.isAllowPostingPeriod ? (this.app._showDateTimeWithZone(this.selectedInvoicing?.postingDate) ?? null) : this.app._showDateTimeWithZone(this.selectedInvoicing?.invoiceDate);

        this.confirmationService.confirm({
            message: isVoid ? "Do you want to void this Invoice?" : "Do you want to delete this Invoice?",
            header: isVoid ? "Void Confirmation" : "Delete Confirmation",
            icon: "pi pi-info-circle",
            accept: () => {
                if (this.statementMessage) {
                    this.messageService.add({ severity: Severity.Warn, summary: this.titlecasePipe.transform(Severity.Warn), detail: ClosingYearDisplayMessages.voidDeleteMessage });
                  }else{
                if (this.displayInvoicingAdd) {
                    this.displayInvoicingAdd = false;
                }
                this.salesOrderService
                    .deleteInvoicing(id, isVoid)
                    .then(() => {
                        this.messageService.add({
                            severity: "success",
                            summary: "Success",
                            detail: isVoid ? "Voided Successfully..." : "Deleted Successfully...",
                        });

                        this.getAllInvoiceByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentInvoiceFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
                        if (this.selectedView == "split") {
                            this.selectedView = "list";
                            this.selectedInvoicing = null;
                            this.invoicingColsAll = this.invoicingColsAllTemp;
                            this.invoicingCols = this.invoicingColsAll;
                            this.estimatesColsAll = this.estimatesColsAllTemp;
                            this.estimatesCols = this.estimatesColsAll;
                            this.soCols = this.estimatesColsAllTemp;
                        }
                    })
                    .catch(() => {
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: "Error occurred while deleting data...",
                        });
                    });
            }
        },
            reject: () => { },
        });
    }
    onInvoiceDialogCancel(event) {
        if (event.type === 'cancel') {
            event.stopPropagation(); 
            return;
          }
        this.displayInvoicingAdd = false;
        this.invoicingDialogType = "";
        this.isInvoicingVoid = false;
    }
    onInvoiceConfirmVoid(event) {
        this.confirmationService.confirm({
            message: "Are you sure that you want to proceed?",
            header: "Confirmation",
            icon: "pi pi-exclamation-triangle",
            accept: () => {
                this.showInvoicingVoidMsg = !this.showInvoicingVoidMsg;
                if (this.showInvoicingVoidMsg) {
                    this.messageService.add({
                        severity: "info",
                        summary: "Confirmed",
                        detail: "You have voided",
                    });
                } else if (!this.showInvoicingVoidMsg) {
                    this.messageService.add({
                        severity: "info",
                        summary: "Confirmed",
                        detail: "You have unvoided",
                    });
                }
                this.onInvoiceDialogCancel(false);
            },
            reject: () => { },
        });
    }
    onInvoiceCreateDialogClose(event) {
        this.selectedId = null;
        if(Object.prototype.isPrototypeOf(event)){
            this.displayInvoicingAdd = false;
        } else {
            this.displayInvoicingAdd = event;
        }
        this.invoicingDialogType = "";
        if (this.selectedView == "list" && this.selectedChannel?.name == this.soChannel.INVOICING) {
            this.getAllInvoiceByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentInvoiceFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
            if(Object.prototype.isPrototypeOf(event)){
                setTimeout(()=>{                        
                    this.newInvoicing();
                }, 2000);
            }
        } else if (this.selectedView == "split" && this.selectedChannel?.name == this.soChannel.INVOICING) {
            this.selectedId = this.selectedInvoicing.id;
            this.getInvoicingDetailsById(this.selectedInvoicing.id);
            this.getAllInvoiceByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentInvoiceFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        } else if (this.selectedView == "split" && this.selectedChannel?.name == this.soChannel.ESTIMATES) {
            this.estimateTemplates = this.templates.filter((t) => t.typeId == 2)[0];
            this.selectedId = this.selectedEstimate.id;
            this.getEstimatesDetailsById(this.selectedEstimate.id);
        } else if (this.selectedView == "list" && this.selectedChannel?.name == this.soChannel.ESTIMATES) {
            this.getAllEstimatesByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecent.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        } else if (this.selectedView == "split" && this.selectedChannel?.name == this.soChannel.CUSTOMER_RETURNS) {
            this.selectedId = this.selectedReturn?.id;
            this.getCustomerReturnDetailsById(this.selectedReturn?.id);
        } else if (this.selectedView == "list" && this.selectedChannel?.name == this.soChannel.CUSTOMER_RETURNS) {
            this.getAllCustomerReturnsByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentCustomerReturnFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        }
    }
    /** End Invoice add/edit/void dialog show hide */

    RPODetail(event) {
        this.isFullyReceived = true;
        this.invoicingHeader = this.soChannel.INVOICING;
        this.displayInvoicingAdd = true;
        this.invoicingDialogType = "VIEW";
        this.selectedInvoicing = _.cloneDeep(this.selectedRPO);
    }

    getSalesOrderActivityLogs(id) {
        this.salesOrderService.getActivityLogs(id).subscribe(
            (res) => {
                this.salesOrderActivityLogs = res;
            },
            (err) => { },
        );
    }

    get isAccountCreditControlled(): boolean {
        return !this.salesOrderDetails?.account?.accountCreditControlId;
    }

    moveSalesOrderToNextStage({stageId, soId}){
        const stage = this.allStages.find((s) => s.id == stageId);
        if(stage){
            this.appMainService.isShowSpinner("loadSO");
            this.salesOrderService.getSalesOrderDetailsById(soId).subscribe(
                (res) => {
                    this.appMainService.isHideSpinner("loadSO");
                    this.prepareSalesOrderDetailsData(res);
                    this.changeStage(stage);
                },
                (err) => {
                    this.appMainService.isHideSpinner("loadSO");
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Error occurred...",
                    });
                },
            );
        }
    }

    /** Sales Order stage change */
    changeStage(stage) {
        this.shippedStagePickColumn = false;
        this.accHoldMsg = ''
        const stName = this.salesOrderDetails?.salesOrderStatus ?? "";
        this.isAvailableEnoughAccCredit = this.utilityService.checkAvailabilityOfAccountCredit(this.salesOrderDetails?.account?.availableCredit, this.salesOrderDetails?.netAmount, this.isAccountCreditControlled,this.salesOrderDetails?.account?.accountCreditControlId);
        if(this.salesOrderDetails?.account?.accountCreditControlId == CreditControlEnum.Hold){
            this.accHoldMsg = accHoldMsg  ;
        }
        /**
         * Sales Order can not be moved to other stage if account credit is not available enough 
         * and approval status is pending, partially approved or rejected
         */
        if (this.isAvailableEnoughAccCredit) {
            if(this.checkApprovalStatus()){
                /** if serial tracking es enabled */
                if(this.utilityService.checkProductsSerialTracking(this.salesOrderDetails.salesOrderProducts, stage.id, this.salesOrderDetails)){
                    // If status is hold/cancel or so is inactive, user is not allowed to perform stage change
                    if (stName == "Hold" || stName == "Cancel" || this.salesOrderDetails.statusId == Status.InActive) {
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: this.salesOrderDetails.statusId == Status.InActive ? "Stage change is not allowed for inactive sales order" : "Please change status",
                        });
                    } else if (stage.id != this.salesOrderDetails.salesOrderStageId) {
                        this.stageComment = "";
                        this.newStage = stage;
                        if (stage.id == SoStageId.Shipped && this.salesOrderDetails.salesOrderStageId != SoStageId.Shipped) {
                            this.shippedStagePickColumn = true;
                            this.createInvoiceTB();
                        } else if (stage.id == SoStageId.ReadyToShip && this.salesOrderDetails.salesOrderStageId != SoStageId.Shipped) {
                            this.newStageName = stage.name;
                            this.displayChangeStage = true;
                            this.displayBackOrderOptions = false;
                        } else if (stage.id == SoStageId.Labelling && this.salesOrderDetails.salesOrderStageId != SoStageId.ReadyToShip && this.salesOrderDetails.salesOrderStageId != SoStageId.Shipped) {
                            this.newStageName = stage.name;
                            this.displayChangeStage = true;
                            this.displayBackOrderOptions = false;
                            // this.displayBackOrderOptions = this.soStageChangeService.isVisibleBackOrderSelectionDialog(this.salesOrderDetails, this.isEnabledBackOrder, this.isEnabledBackOrderKit, this.isEnabledBackOrderBundle);
                        } else if (stage.id == SoStageId.Verification && this.salesOrderDetails.salesOrderStageId != SoStageId.Labelling && this.salesOrderDetails.salesOrderStageId != SoStageId.ReadyToShip && this.salesOrderDetails.salesOrderStageId != SoStageId.Shipped) {
                            this.newStageName = stage.name;
                            this.displayChangeStage = true;
                            this.displayBackOrderOptions = false;
                            // this.displayBackOrderOptions = this.soStageChangeService.isVisibleBackOrderSelectionDialog(this.salesOrderDetails, this.isEnabledBackOrder, this.isEnabledBackOrderKit, this.isEnabledBackOrderBundle);
                        } else if (stage.id == SoStageId.Pack && this.salesOrderDetails.salesOrderStageId != SoStageId.Verification && this.salesOrderDetails.salesOrderStageId != SoStageId.Labelling && this.salesOrderDetails.salesOrderStageId != SoStageId.ReadyToShip && this.salesOrderDetails.salesOrderStageId != SoStageId.Shipped) {
                            this.newStageName = stage.name;
                            this.displayChangeStage = true;
                            this.displayBackOrderOptions = false;
                        } else if (stage.id == SoStageId.Pick && this.salesOrderDetails.salesOrderStageId != SoStageId.Pack && this.salesOrderDetails.salesOrderStageId != SoStageId.Verification && this.salesOrderDetails.salesOrderStageId != SoStageId.Labelling && this.salesOrderDetails.salesOrderStageId != SoStageId.ReadyToShip && this.salesOrderDetails.salesOrderStageId != SoStageId.Shipped) {
                            this.newStageName = stage.name;
                            this.displayChangeStage = true;
                            this.displayBackOrderOptions = false;
                        }
                    }
                } else {
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Please add serial no",
                    });
                }
            } else {
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Please approve the sales order",
                });
            }
        } else {
            this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: this.salesOrderDetails?.account?.accountCreditControlId == CreditControlEnum.Hold ? this.accHoldMsg : accCreditMsg,
            });
        }
    }
    onHoldUpdateSalesOrder(e = "") {
        const salesChannel = this.orderChannels?.filter((s) => s.name == this.soChannel.SALES_ORDER)[0];
        const allStages = salesChannel?.stages?.filter((s) => Number(s.id) >= Number(this.salesOrderDetails.salesOrderStageId));
        const allStatus = allStages?.filter((s) => s.id == this.salesOrderDetails.salesOrderStageId)[0].status;
        const holdStatus = allStatus?.filter((s) => s.name?.toLowerCase() == "hold")[0];

        const req = _.cloneDeep(this.salesOrderDetails);
        req.backOrderTypeId = 0;
        req.salesOrderStatusId = holdStatus?.id;
        req.salesOrderNote = null;
        req.salesOrderAudit = null;
        req.account = null;
        req.warehouse = null;
        req.user = null;
        req.shippingAddress = null;
        req.discountType = null;
        req.paymentMethod = null;
        req.paymentTerm = null;
        req.shippingMethod = null;
        req.shippingTerm = null;
        req.contact = null;
        req.shipContact = null;

        if (req.salesOrderProducts && req.salesOrderProducts.length) {
            req.salesOrderProducts.forEach((e) => {
                e.product = null;
                if (e?.salesOrderBundleDetail && e?.salesOrderBundleDetail?.length > 0) {
                    e?.salesOrderBundleDetail?.forEach((b) => {
                        b.product = null;
                        b?.childSalesOrderBundleDetail?.forEach((k) => {
                            k.product = null;
                        });
                    });
                }
            });
        }
        this.displayConvertToSalesOrder = false;
        this.appMainService.isShowSpinner("loadSO");
        this.salesOrderService
            .updateSalesOrder(req, this.isBaseCurrency(this.salesOrderDetails?.account?.currencyId))
            .then(() => {
                this.appMainService.isHideSpinner("loadSO");
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Sales Order updated successfully...",
                });
                this.displayChangeStage = false;
                this.selectedId = this.selectedOrder.id;
                this.getSalesOrderDetailsById(this.selectedOrder.id);
            })
            .catch(() => {
                this.appMainService.isHideSpinner("loadSO");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while updating data...",
                });
            });
    }
    saveStageChange(s) {
        if (this.selectedBackOrderOption && this.selectedBackOrderOption == 3) {
            this.onHoldUpdateSalesOrder();
        } else {
            this.selectedId = null;
            let salesOrderData = null;
            if (this.salesOrderDetails?.salesOrderStageId == this.soStage.Entered) {
                if (s == "Pick") {
                    // entred to pick
                    salesOrderData = this.soStageChangeService.prepareEnteredToPickStageChangeData(this.salesOrderDetails, this.app, this.isAutoPick, this.sodetailsDeepCopy);
                } else {
                    // entred to pack/verification/labelling
                    salesOrderData = this.soStageChangeService.prepareEnteredToPackStageChangeData(this.salesOrderDetails, this.app, this.isAutoPick, this.isAutoPack, this.sodetailsDeepCopy);
                }
            } else if (this.salesOrderDetails?.salesOrderStageId == this.soStage.Pick) {
                // pick to pack/verification/labelling
                salesOrderData = this.soStageChangeService.preparePickToPackStageChangeData(this.salesOrderDetails, this.app, this.isAutoPack, this.sodetailsDeepCopy);
            } else {
                // pack to verification/labelling
                salesOrderData = this.soStageChangeService.prepareLabellingOrVerificationStageChangeData(this.salesOrderDetails, this.app, this.sodetailsDeepCopy);
            }
            const req = {
                objectStageAudit: {
                    id: 0,
                    createdSource: this.app.userIP,
                    updatedSource: this.app.userIP,
                    createdBy: this.app.user.userId,
                    updatedBy: this.app.user.userId,
                    createdDate: this.app._saveDateTimeWithZone(new Date()),
                    updatedDate: this.app._saveDateTimeWithZone(new Date()),
                    organizationId: this.app.companyId,
                    objectRecordId: this.selectedOrder.id,
                    objectId: this.salesObjectId,
                    comment: this.stageComment,
                    stageId: this.newStage.id,
                    isPublic: false,
                    statusId: 1,
                    isPublicOption: {
                        label: "Private",
                        value: true,
                    },
                },

                // salesOrder: s == "Pack"
                //     ? this.soStageChangeService.getPickToPackSoObj(this.app, soObj, this.soDetailsTemplates,this.footerTaxEnabled,this.isEnabledBackOrder, this.selectedBackOrderOption)
                //     : this.soStageChangeService.getEnteredToPickSoObj(this.app, soObj, this.soDetailsTemplates,this.footerTaxEnabled,this.isEnabledBackOrder,this.selectedBackOrderOption,this.isEnabledBackOrderKit,this.isEnabledBackOrderBundle),

                // salesOrder: s == "Pick" ? this.soStageChangeService.prepareEnteredToPickStageChangeData(this.salesOrderDetails, this.app)
                //     : s == "Pack" ? this.soStageChangeService.preparePickToPackStageChangeData(this.salesOrderDetails, this.app)
                //         : this.soStageChangeService.prepareLabellingOrVerificationStageChangeData(this.salesOrderDetails, this.app)

                salesOrder: salesOrderData,
            };
            if (req.salesOrder.salesOrderProducts && req.salesOrder.salesOrderProducts.length) {
                req.salesOrder.salesOrderProducts.forEach((e) => {
                    e.product = null;
                });
            }
            this.appMainService.isShowSpinner("loadSO");
            this.salesOrderService
                .updateStage(req, this.selectedBackOrderOption, this.isBaseCurrency(this.salesOrderDetails?.account?.currencyId))
                .then(() => {
                    this.messageService.add({
                        severity: "success",
                        summary: "Success",
                        detail: "Stage updated successfully...",
                    });
                    this.appMainService.isHideSpinner("loadSO");
                    this.displayChangeStage = false;
                    this.selectedId = this.selectedOrder.id;
                    
                    if(this.selectedView == "list") {
                        this.getAllSalesOrderByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentSOFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
                    } else {
                        this.getAllSalesOrderByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentSOFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
                        this.getSalesOrderDetailsById(this.selectedOrder.id);
                        this.getSalesOrderActivityLogs(this.selectedOrder.id);
                    }
                })
                .catch(() => {
                    this.appMainService.isHideSpinner("loadSO");
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Error occurred while updating data...",
                    });
                });
        }
    }
    openUpdateStagePopup(data: { id: number; type: string; comment?: Comment }) {
        this.items = [];
        this.app.objectType = SOObjectNames.SalesOrder;
        this.app.objectId = this.selectedOrder.id;
        this.displayCommentAdd = true;
        this.selectedOrder = this.selectedOrder;
        this.tempComment = data.type == "Add" ? this.commentDefault : data.comment;
        this.currentComment = this.tempComment;
        this.nextStageIdForUpdate = data.id;
        this.commentFormType = data.type;
        this.commentHeaderName = `Sales Order No : ${this.selectedOrder.SONo}`;

        this.items.push({
            label: "View",
            icon: "pi pi-eye",
            disabled: this.commentFormType == "View",
            command: () => {
                this.commentFormType = "View";
            },
        });
        if (this.currentComment && this.currentComment.createdBy == this.app.user.userId) {
            this.items.push({
                label: "Edit",
                icon: "pi pi-pencil",
                disabled: this.commentFormType == "Edit",
                command: () => {
                    this.commentFormType = "Edit";
                    this.currentComment.isPublicOption = this.currentComment.isPublic ? { label: "Public", value: true } : { label: "Private", value: false };
                    this.stageComment = this.currentComment.comment;
                    // this.commentFormType.patchValue(this.currentComment);
                },
            });
            this.items.push({
                label: "Delete",
                icon: "pi pi-trash",
                command: () => {
                    this.confirmationService.confirm({
                        message: "Do you want to delete this Comment?",
                        header: "Delete Confirmation",
                        icon: "pi pi-info-circle",
                        accept: () => {
                            this.salesOrderService.deleteSalesOrderComment(this.currentComment.id).subscribe(
                                (resp) => {
                                    this.messageService.add({
                                        severity: "success",
                                        summary: "Success",
                                        detail: "Deleted Successfully...",
                                    });
                                    this.changeChannel();
                                    this.selectedOrder = null;
                                    this.displayCommentAdd = false;
                                    if (this.selectedView == "split") {
                                        this.selectedView = "list";
                                    }
                                },
                                (err) =>
                                    this.messageService.add({
                                        severity: "error",
                                        summary: "Error",
                                        detail: "Error occurred while deleting data...",
                                    }),
                            );
                        },
                        reject: () => { },
                    });
                },
            });
        }
    }
    checkApprovalStatus(): boolean {
        return [ApprovalStatus.Default, ApprovalStatus.Approved].includes(this.salesOrderDetails?.approvalStatusId);
    }
    /** End Sales Order stage change */

    saveComment() {
        const req = this.currentComment;
        req.comment = this.stageComment;
        req.updatedSource = this.app.userIP;
        req.updatedBy = this.app.user.userId;
        req.updatedDate = new Date().toISOString();
        req.status = null;

        this.salesOrderService
            .updateSalesOrderComment(req)
            .then(() => {
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "updated successfully...",
                });
                this.changeChannel();
                this.selectedOrder = null;
                this.displayCommentAdd = false;
                if (this.selectedView == "split") {
                    this.selectedView = "list";
                }
            })
            .catch(() => {
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while updating data...",
                });
            });
    }

    /** Shipment */

    /*** EasyPost shipment */
    onCreateLabelUpdateInvoice(e) {
        const invoice = this.soShipmentService.onSuccessEasyPostShipmentPrepareInvoiceData(_.cloneDeep(this.invoicingDetails), e, this.freeShippingObj, this.app);
        // show shipping label
        if (this.selectedChannel?.name == this.soChannel.INVOICING) {
            const url = invoice?.invoiceShipment && invoice?.invoiceShipment?.length ? invoice?.invoiceShipment[invoice.invoiceShipment.length - 1].labelLink : "";
            if (url) {
                this.showLabel(url, true);
            }
        }
        
        this.appMainService.isShowSpinner("loadINV");
        this.salesOrderService
            .updateInvoice(invoice, this.isBaseCurrency(this.invoicingDetails?.account?.currencyId))
            .then(() => {
                this.appMainService.isHideSpinner("loadINV");
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Invoice updated successfully...",
                });
                if (this.selectedChannel?.name == this.soChannel.INVOICING) {
                    // this.getInvoicingDetailsById(invoice.id, "SHOW_LABEL");
                    this.getInvoicingDetailsById(invoice.id, "");
                }
            })
            .catch(() => {
                this.appMainService.isHideSpinner("loadINV");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while updating data...",
                });
            });
    }
    onCreateLabelUpdateSO(e) {
        const salesOrder = this.soShipmentService.onSuccessEasyPostShipmentPrepareSalesOrderData(_.cloneDeep(this.salesOrderDetails), e, this.freeShippingObj, this.app);
        // show shipping label
        const url = salesOrder?.shipment && salesOrder?.shipment?.length ? salesOrder?.shipment[salesOrder.shipment.length - 1].labelLink : "";
        if (url) {
            this.showLabel(url, true);
        }

        this.appMainService.isShowSpinner("loadSO");
        this.salesOrderService
            .updateSalesOrder(salesOrder,  this.isBaseCurrency(this.salesOrderDetails?.account?.currencyId))
            .then(() => {
                this.appMainService.isHideSpinner("loadSO");
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Sales Order updated successfully...",
                });
                this.displayStatus = false;
                this.selectedId = this.selectedOrder.id;
                // this.getSalesOrderDetailsById(this.selectedOrder.id, "SHOW_LABEL");
                this.getSalesOrderDetailsById(this.selectedOrder.id, "");
            })
            .catch(() => {
                this.appMainService.isHideSpinner("loadSO");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while updating data...",
                });
            });

        if (this.salesOrderDetails.salesOrderStageId == SoStageId.Shipped) {
            this.onCreateLabelUpdateInvoice(e);
        }
    }
    onSuccessEasypostShipmentUpdateRMA(e) {
        const customerReturn = this.soShipmentService.onSuccessEasyPostShipmentPrepareRMAData(_.cloneDeep(this.customerReturnDetails), e, this.freeShippingObj, this.app);
        // show shipping label
        const url = customerReturn?.rmaReturnShipment && customerReturn?.rmaReturnShipment?.length ? customerReturn?.rmaReturnShipment[customerReturn.rmaReturnShipment.length - 1].labelLink : "";
        if (url) {
            this.showLabel(url, true);
        }
        
        this.appMainService.isShowSpinner("loadINV");
        this.salesOrderService
            .addRMALabelCharges(customerReturn)
            .then(() => {
                this.appMainService.isHideSpinner("loadINV");
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Customer return updated successfully...",
                });
                this.getCustomerReturnDetailsById(this.selectedId);
            })
            .catch(() => {
                this.appMainService.isHideSpinner("loadINV");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while updating data...",
                });
            });
    }
    /*** End EasyPost shipment */

    /*** Fedex shipment */
    onCreateFedexLabelUpdateInvoice(e) {
        let req = _.cloneDeep(this.invoicingDetails);
        req = this.soShipmentService.onSuccessFedexShipmentGetInvoiceObj(req, e, this.freeShippingObj, this.app);
        
        // show shipping label
        if (this.selectedChannel?.name == this.soChannel.INVOICING) {
            const url = req?.invoiceShipment && req?.invoiceShipment?.length ? req?.invoiceShipment[req.invoiceShipment.length - 1].labelLink : "";
            if (url) {
                this.showLabel(url, true);
            }
        }

        this.appMainService.isShowSpinner("loadINV");
        this.salesOrderService
            .updateInvoice(req, this.isBaseCurrency(this.invoicingDetails?.account?.currencyId))
            .then(() => {
                this.appMainService.isHideSpinner("loadINV");
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Invoice updated successfully...",
                });
                if (this.selectedChannel?.name == this.soChannel.INVOICING) {
                    // this.getInvoicingDetailsById(req.id, "SHOW_LABEL");
                    this.getInvoicingDetailsById(req.id, "");
                }
            })
            .catch(() => {
                this.appMainService.isHideSpinner("loadINV");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while updating data...",
                });
            });
    }
    onCreateFedexLabelUpdateSO(e) {
        let req = _.cloneDeep(this.salesOrderDetails);
        req = this.soShipmentService.onSuccessFedexShipmentGetSOObj(req, e, this.freeShippingObj, this.app);
        
        // show shipping label
        const url = req?.shipment && req?.shipment?.length ? req?.shipment[req.shipment.length - 1].labelLink : "";
        if (url) {
            this.showLabel(url, true);
        }
        
        this.appMainService.isShowSpinner("loadSO");
        this.salesOrderService
            .updateSalesOrder(req, this.isBaseCurrency(this.salesOrderDetails?.account?.currencyId))
            .then(() => {
                this.appMainService.isHideSpinner("loadSO");
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Sales Order updated successfully...",
                });
                this.displayStatus = false;
                this.selectedId = this.selectedOrder.id;
                // this.getSalesOrderDetailsById(this.selectedOrder.id, "SHOW_LABEL");
                this.getSalesOrderDetailsById(this.selectedOrder.id, "");
            })
            .catch(() => {
                this.appMainService.isHideSpinner("loadSO");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while updating data...",
                });
            });

        if (this.salesOrderDetails.salesOrderStageId == SoStageId.Shipped) {
            this.onCreateFedexLabelUpdateInvoice(e);
        }
    }
    onSuccessFedexShipmentUpdateRMA(e) {
        const customerReturn = this.soShipmentService.onSuccessFedexShipmentPrepareCustomerReturnData(_.cloneDeep(this.customerReturnDetails), e, this.freeShippingObj, this.app);
        // show shipping label
        const url = customerReturn?.rmaReturnShipment && customerReturn?.rmaReturnShipment?.length ? customerReturn?.rmaReturnShipment[customerReturn.rmaReturnShipment.length - 1].labelLink : "";
        if (url) {
            this.showLabel(url, true);
        }
        
        this.appMainService.isShowSpinner("loadINV");
        this.salesOrderService
            .addRMALabelCharges(customerReturn)
            .then(() => {
                this.appMainService.isHideSpinner("loadINV");
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Customer return updated successfully...",
                });
                this.getCustomerReturnDetailsById(this.selectedId);
            })
            .catch(() => {
                this.appMainService.isHideSpinner("loadINV");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while updating data...",
                });
            });
    }
    /*** End Fedex shipment */

    /*** Ups Shipment */
    onUpsShipmentUpdateSO(e) {
        let soData = _.cloneDeep(this.salesOrderDetails);
        soData = this.soShipmentService.onSuccessUpsShipmentGetSOObj(soData, e, this.freeShippingObj, this.app);
        this.updateSalesOrderWithShipmentData(soData);
        if (e?.label?.ShipmentResponse?.ShipmentResults?.PackageResults?.TrackingNumber) {
            const obj = {
                trackingNo: e?.label?.ShipmentResponse?.ShipmentResults?.PackageResults?.TrackingNumber ?? "",
                shipmentId: e?.label?.ShipmentResponse?.ShipmentResults?.PackageResults?.TrackingNumber ?? "",
            };
            this.onUpsViewLabel(obj);
        }

        if (this.salesOrderDetails.salesOrderStageId == SoStageId.Shipped) {
            let invoiceData = _.cloneDeep(this.invoicingDetails);
            invoiceData = this.soShipmentService.onSuccessUpsShipmentGetInvoiceObj(invoiceData, e, this.freeShippingObj, this.app);
            this.updateInvoiceWithShipmentData(invoiceData);
        }
    }
    async onUpsShipmentUpdateInvoice(e) {
        let invoiceData = _.cloneDeep(this.invoicingDetails);
        invoiceData = this.soShipmentService.onSuccessUpsShipmentGetInvoiceObj(invoiceData, e, this.freeShippingObj, this.app);
        this.updateInvoiceWithShipmentData(invoiceData);
        if (e?.label?.ShipmentResponse?.ShipmentResults?.PackageResults?.TrackingNumber) {
            const obj = {
                trackingNo: e?.label?.ShipmentResponse?.ShipmentResults?.PackageResults?.TrackingNumber ?? "",
                shipmentId: e?.label?.ShipmentResponse?.ShipmentResults?.PackageResults?.TrackingNumber ?? "",
            };
            this.onUpsViewLabel(obj);
        }

        if (invoiceData?.salesOrderId) {
            let soData = await lastValueFrom(this.salesOrderService.getSalesOrderDetailsById(invoiceData?.salesOrderId));
            soData = this.soShipmentService.onSuccessUpsShipmentGetSOObj(_.cloneDeep(soData), e, this.freeShippingObj, this.app);
            this.updateSalesOrderWithShipmentData(soData);
        }
    }
    onSuccessUpsShipmentUpdateRMA(e) {
        const customerReturn = this.soShipmentService.onSuccessUpsShipmentPrepareCustomerReturnData(_.cloneDeep(this.customerReturnDetails), e, this.freeShippingObj, this.app);
        this.appMainService.isShowSpinner("loadINV");
        this.salesOrderService
            .addRMALabelCharges(customerReturn)
            .then(() => {
                this.appMainService.isHideSpinner("loadINV");
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Customer return updated successfully...",
                });
                this.getCustomerReturnDetailsById(this.selectedId);
            })
            .catch(() => {
                this.appMainService.isHideSpinner("loadINV");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while updating data...",
                });
            });
    }
    /*** End Ups Shipment */

    updateInvoiceWithShipmentData(invoiceData) {
        this.appMainService.isShowSpinner("loadINV");
        this.salesOrderService
            .updateInvoice(invoiceData, this.isBaseCurrency(this.invoicingDetails?.account?.currencyId))
            .then(() => {
                this.appMainService.isHideSpinner("loadINV");
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Invoice updated successfully...",
                });
                if (this.selectedChannel?.name == this.soChannel.INVOICING) {
                    this.getInvoicingDetailsById(invoiceData.id);
                }
            })
            .catch(() => {
                this.appMainService.isHideSpinner("loadINV");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while updating data...",
                });
            });
    }

    updateSalesOrderWithShipmentData(salesOrderData) {
        this.appMainService.isShowSpinner("loadSO");
        this.salesOrderService
            .updateSalesOrder(salesOrderData, this.isBaseCurrency(this.salesOrderDetails?.account?.currencyId))
            .then(() => {
                this.appMainService.isHideSpinner("loadSO");
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Sales Order updated successfully...",
                });
                this.displayStatus = false;
                if (this.selectedChannel?.name == this.soChannel.SALES_ORDER) {
                    this.selectedId = this.selectedOrder.id;
                    this.getSalesOrderDetailsById(this.selectedOrder.id, "SHOW_UPS_LABEL");
                }
            })
            .catch(() => {
                this.appMainService.isHideSpinner("loadSO");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while updating data s...",
                });
            });
    }

    /** Show Shipment Label */

    showUpsLabel(data) {
        const byteArray = Uint8Array.from(
            atob(data)
                .split("")
                .map((char) => char.charCodeAt(0)),
        );
        const pdf = new Blob([byteArray], { type: "application/pdf" });
        const blobUrl = URL.createObjectURL(pdf);
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.src = this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl));
        document.body.appendChild(iframe);
        iframe.onload = () => {
            setTimeout(() => {
                iframe.focus();
                iframe.contentWindow.print();
            }, 1000);
        };
    }
    showFedexDownloadedLabel(url) {
        let labelURL = "";
        if(this.selectedChannel?.name == this.soChannel.SALES_ORDER){
            labelURL = this.salesOrderDetails?.shipment?.find((s) => s?.labelLink == url)?.labelDownloadLink ?? "";
        } else if(this.selectedChannel?.name == this.soChannel.INVOICING){
            labelURL = this.invoiceDetails?.invoiceShipment?.find((s) => s?.labelLink == url)?.labelDownloadLink ?? "";
        } else if(this.selectedChannel?.name == this.soChannel.CREDIT_MEMO){
            labelURL = this.customerReturnDetails?.rmaReturnShipment?.find((s) => s?.labelLink == url)?.labelDownloadLink ?? "";
        }

        if(labelURL && labelURL?.length > 0){
            this.appMainService.isShowSpinner("loadPdf");
            this.salesOrderService.downloadFedexLabel(labelURL).subscribe((res) => {
                this.appMainService.isHideSpinner("loadPdf");
                if (res && res?.pdfData) {
                    this.showShipmentLabelAsPdf(res?.pdfData);
                } 
            },
            (error) => {
                this.appMainService.isHideSpinner("loadPdf");
                this.messageService.add({
                    severity: Severity.Error,
                    summary: this.titlecasePipe.transform(Severity.Error),
                    detail:  error?.error?.Message ?? "",
                });
            });
        }
    }
    showLabel(url, showError = false) {
        const type = this.selectedChannel?.name == this.soChannel.SALES_ORDER ? (this.salesOrderDetails.shipment && this.salesOrderDetails.shipment.length ? this.salesOrderDetails.shipment[0].trackingLink : this.selectedChannel?.name == this.soChannel.INVOICING ? (this.invoiceDetails.shipment && this.invoiceDetails.shipment.length ? this.invoiceDetails.shipment[0].trackingLink : "") : "") : ""; // CHECK FEDEX , remove after binding shipping method

        if (type && type == "FEDEX") {
            this.appMainService.isShowSpinner("loadPdf");
            this.salesOrderService.downloadFedexLabel(url).subscribe((res) => {
                this.appMainService.isHideSpinner("loadPdf");
                if (res && res?.pdfData) {
                    this.showShipmentLabelAsPdf(res?.pdfData);
                }
            },
            (error) => {
                this.appMainService.isHideSpinner("loadPdf");
                if(showError){
                    this.messageService.add({
                        severity: Severity.Error,
                        summary: this.titlecasePipe.transform(Severity.Error),
                        detail:  error?.error?.Message ?? "",
                    });
                } else {
                    this.showFedexDownloadedLabel(url);
                }
            });
        } else {
            //download easypost label
            this.appMainService.isShowSpinner("loadPdf");
            this.salesOrderService.getLabelPdf(url).subscribe(
                (res) => {
                    this.appMainService.isHideSpinner("loadPdf");
                    if (res && res?.pdfData) {
                        this.showShipmentLabelAsPdf(res?.pdfData);
                    } else {
                        this.messageService.add({
                            severity: Severity.Error,
                            summary: this.titlecasePipe.transform(Severity.Error),
                            detail: "No Data found...",
                        });
                    }
                },
                (error) => {
                    this.appMainService.isHideSpinner("loadPdf");
                    this.messageService.add({
                        severity: Severity.Error,
                        summary: this.titlecasePipe.transform(Severity.Error),
                        detail: "Error occurred...",
                    });
                },
            );
        }
    }
    onUpsViewLabel(e) {
        const data = {
            LabelRecoveryRequest: {
                Request: {
                    RequestOption: "Non_Validate",
                    SubVersion: "1801",
                    TransactionReference: {
                        CustomerContext: "",
                        TransactionIdentifier: "",
                    },
                },
                LabelSpecification: {
                    HTTPUserAgent: "Mozilla/4.5",
                    LabelImageFormat: {
                        Code: "ZPL",
                    },
                    LabelStockSize: { Height: "6", Width: "4" },
                },
                Translate: {
                    LanguageCode: "eng",
                    DialectCode: "US",
                    Code: "01",
                },
                LabelDelivery: {
                    LabelLinkIndicator: "",
                    ResendEmailIndicator: "",
                },
                TrackingNumber: e?.shipmentId || "",
            },
        };
        this.salesOrderService.getUpsShipmentLabel(data, this.vendorUpsInfo?.id, e?.trackingNo).subscribe(
            (res) => {
                if (res && res?.pdfData) {
                    this.showShipmentLabelAsPdf(res?.pdfData);
                } else {
                    this.messageService.add({
                        severity: Severity.Success,
                        summary: this.titlecasePipe.transform(Severity.Success),
                        detail: res?.hasOwnProperty("message") ? res?.message ?? "" : res?.Message ?? "",
                    });
                }
            },
            (e) => {
                this.messageService.add({
                    severity: "error",
                    summary: this.titlecasePipe.transform("error"),
                    detail: e?.error?.Message ?? "",
                });
            },
        );
    }
    showShipmentLabelAsPdf(pdfData) {
        const byteArray = Uint8Array.from(
            atob(pdfData)
                .split("")
                .map((char) => char.charCodeAt(0)),
        );
        const pdf = new Blob([byteArray], {
            type: "application/pdf",
        });
        const blobUrl = URL.createObjectURL(pdf);
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.src = this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl));
        document.body.appendChild(iframe);
        iframe.onload = () => {
            setTimeout(() => {
                iframe.focus();
                iframe.contentWindow.print();
            }, 1000);
        };
    }
    /** End Show Shipment Label */

    /** Void Shipment */
    onVoidShipment(e) {
        this.salesOrderService.refundByShippingId(e.shipmentId).subscribe(
            (res) => {
                this.messageService.add({
                    severity: "success",
                    summary: this.titlecasePipe.transform("success"),
                    detail: "Void request submitted...",
                });
                if (this.selectedChannel.name == this.soChannel.SALES_ORDER) {
                    this.getSalesOrderDetailsById(this.selectedOrder.id);
                } else if (this.selectedChannel.name == this.soChannel.INVOICING) {
                    this.getInvoicingDetailsById(this.selectedInvoicing.id);
                } else if (this.selectedChannel?.name == this.soChannel.CUSTOMER_RETURNS) {
                    this.getCustomerReturnDetailsById(this.selectedId);
                }
            },
            (e) => {
                this.messageService.add({
                    severity: "error",
                    summary: this.titlecasePipe.transform("error"),
                    detail: e?.error?.Message,
                });
            },
        );
    }
    onFedexVoidShipment(e) {
        const data = {
            accountNumber: {
                value: e?.accountNumber,
            },
            trackingNumber: e.trackingNo,
        };

        let objEncStr = btoa(JSON.stringify(data));
        const obj = {
            vendorID: this.vendorFedexInfo.id,
            shipment: objEncStr,
        };

        this.salesOrderService.cancelFedexShipment(obj).subscribe(
            (res) => {
                this.messageService.add({
                    severity: "success",
                    summary: this.titlecasePipe.transform("success"),
                    detail: "Void request submitted...",
                });
                if (this.selectedChannel.name == this.soChannel.SALES_ORDER) {
                    this.getSalesOrderDetailsById(this.selectedOrder.id);
                } else if (this.selectedChannel.name == this.soChannel.INVOICING) {
                    this.getInvoicingDetailsById(this.selectedInvoicing.id);
                } else if (this.selectedChannel?.name == this.soChannel.CUSTOMER_RETURNS) {
                    this.getCustomerReturnDetailsById(this.selectedId);
                }
            },
            (e) => {
                this.messageService.add({
                    severity: "error",
                    summary: this.titlecasePipe.transform("error"),
                    detail: e?.error?.Message,
                });
            },
        );
    }
    onUpsVoidShipment(e) {
        this.salesOrderService.cancelUpsShipment(e.shipmentId, this.vendorUpsInfo?.id).subscribe(
            (res) => {
                this.messageService.add({
                    severity: "success",
                    summary: this.titlecasePipe.transform("success"),
                    detail: "Void request submitted...",
                });
                if (this.selectedChannel.name == this.soChannel.SALES_ORDER) {
                    this.getSalesOrderDetailsById(this.selectedOrder.id);
                } else if (this.selectedChannel.name == this.soChannel.INVOICING) {
                    this.getInvoicingDetailsById(this.selectedInvoicing.id);
                } else if (this.selectedChannel?.name == this.soChannel.CUSTOMER_RETURNS) {
                    this.getCustomerReturnDetailsById(this.selectedId);
                }
            },
            (e) => {
                this.messageService.add({
                    severity: "error",
                    summary: this.titlecasePipe.transform("error"),
                    detail: e?.error?.Message ?? "",
                });
            },
        );
    }
    /** End Void Shipment */

    /** Track Shipment */
    onFedexTrackShipment(e) {
        const obj = {
            trackingInfo: [
                {
                    trackingNumberInfo: {
                        trackingNumber: e,
                    },
                },
            ],
            includeDetailedScans: true,
        };
        const objEncStr = btoa(JSON.stringify(obj));

        this.salesOrderService.trackFedexShipment(objEncStr, this.vendorFedexInfo?.id).subscribe((res) => {
            this.getSalesOrderDetailsById(this.selectedOrder.id);
        });
    }
    onUpsTrackShipment(e) {
        this.salesOrderService.trackUpsShipment(e, this.vendorUpsInfo?.id).subscribe((res) => {
            // this.getSalesOrderDetailsById(this.selectedOrder.id);
        });
    }

    /** End Track Shipment */
    /** End Shipment */

    cancelComment() {
        this.displayCommentAdd = false;
    }

    saveReceivePO() {
        const invoiceNotes = [
            {
                id: 0,
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                invoiceId: 0,
                userId: this.app.user.userId,
                user: null,
                noteId: 0,
                note: {
                    id: 0,
                    createdSource: this.app.userIP,
                    updatedSource: this.app.userIP,
                    createdBy: this.app.user.userId,
                    updatedBy: this.app.user.userId,
                    createdDate: this.app._saveDateTimeWithZone(new Date()),
                    updatedDate: this.app._saveDateTimeWithZone(new Date()),
                    comment: "test",
                    isImportant: true,
                    organizationId: this.app.companyId,
                    description: "",
                    statusId: 1,
                    status: null,
                    isValid: true,
                    validFromDate: new Date().toISOString(),
                    validToDate: new Date().toISOString(),
                    noteComments: null,
                    noteAttachments: null,
                    createdByName: "",
                },
                invoiceStageId: 0,
                invoiceStage: "",
                invoiceStatusId: 0,
                invoiceStatus: "",
            },
        ];

        const invoiceAudits = [
            {
                id: 0,
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                invoiceId: 0,
                description: "",
                noteId: 0,
                note: {
                    id: 0,
                    createdSource: this.app.userIP,
                    updatedSource: this.app.userIP,
                    createdBy: this.app.user.userId,
                    updatedBy: this.app.user.userId,
                    createdDate: this.app._saveDateTimeWithZone(new Date()),
                    updatedDate: this.app._saveDateTimeWithZone(new Date()),
                    comment: "test 11",
                    isImportant: true,
                    organizationId: this.app.companyId,
                    description: "",
                    statusId: 1,
                    status: null,
                    isValid: true,
                    validFromDate: new Date().toISOString(),
                    validToDate: new Date().toISOString(),
                    noteComments: null,
                    noteAttachments: null,
                    createdByName: "",
                },
            },
        ];

        const products = [];
        this.salesOrderDetails.salesOrderProducts.forEach((element) => {
            const p = {
                id: 0,
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                invoiceId: 0,
                productId: element.productId,
                product: null,
                productUOMId: element.productUOMId,
                availableQuantity: element.availableQuantity,
                quantity: element.quantity,
                pricePerProduct: element.pricePerProduct,
                totalAmount: element.totalAmount,
                discountTypeId: this.salesOrderDetails.discountTypeId,
                discountType: "",
                discountAmount: this.salesOrderDetails.discountAmount,
                taxId: this.salesOrderDetails.taxId,
                taxName: "",
                taxRateTypeId: 0,
                taxAmount: this.salesOrderDetails.taxAmount,
                statusId: 1,
                status: null,
                invoiceSerialNumber: null, // later
            };

            products.push(p);
        });

        const req = {
            id: 0,
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            createdBy: this.app.user.userId,
            updatedBy: this.app.user.userId,
            createdDate: this.app._saveDateTimeWithZone(new Date()),
            updatedDate: this.app._saveDateTimeWithZone(new Date()),
            number: "",
            description: "",
            organizationId: this.app.companyId,
            accountId: this.salesOrderDetails.accountId,
            contactId: 0,
            account: null,
            warehouseId: this.salesOrderDetails.warehouseId,
            warehouse: null,
            userId: this.salesOrderDetails.userId,
            user: null,
            invoiceDueDate: new Date().toISOString(),
            paymentMethodId: this.salesOrderDetails && this.salesOrderDetails.paymentMethodId ? this.salesOrderDetails.paymentMethodId : 0,
            paymentMethod: null,
            paymentTermId: this.salesOrderDetails && this.salesOrderDetails.paymentTermId ? this.salesOrderDetails.paymentTermId : 0,
            paymentTerm: null,
            totalAmount: this.salesOrderDetails.totalAmount,
            currencyUnitId: 0,
            discountTypeId: this.salesOrderDetails.discountTypeId,
            discountType: null,
            discount: this.salesOrderDetails.discountAmount,
            taxId: this.salesOrderDetails.taxId,
            tax: null,
            taxAmount: this.salesOrderDetails.taxAmount,
            shippingCharge: this.salesOrderDetails.shippingChargeAmount,
            netAmount: this.salesOrderDetails.netAmount,
            referenceNumber: this.salesOrderDetails.reference,
            invoiceStageId: 0,
            invoiceStage: "",
            invoiceStatusId: 1,
            invoiceStatus: "",
            invoicePaymentStatusId: 0,
            shippingAddressId: this.salesOrderDetails.shippingAddressId,
            shippingAddress: null,
            sourceId: 0,
            statusId: 1,
            shippingMethodId: this.salesOrderDetails && this.salesOrderDetails.shippingMethodId ? this.salesOrderDetails.shippingMethodId : 0,
            shippingMethod: null,
            shippingTermId: this.salesOrderDetails && this.salesOrderDetails.shippingTermId ? this.salesOrderDetails.shippingTermId : 0,
            shippingTerm: null,
            termsAndCondition: "",
            signatureFileId: 0,
            authorityUserId: 0,
            salesOrderId: this.salesOrderDetails.id,

            invoiceNotes: invoiceNotes,
            invoiceAudits: invoiceAudits,
            invoiceProducts: products,

            invoiceBundleDetails: null,
            customAttributeValues: null,
            businessName: "",
            createdByUser: "",
            SalesOrderNo: this.salesOrderDetails.number,
            estimateId: 0,
            EstimateNo: "",
            dueAmount: 0,
        };

        this.salesOrderService
            .createInvoice(req, this.isBaseCurrency(this.salesOrderDetails?.account?.currencyId))
            .then(() => {
                this.displayReceivedPO = false;
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Invoice created successfully...",
                });
            })
            .catch(() => {
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while saving data...",
                });
            });
    }

    changeInvoice() {
        if (this.selectedInvoicingType?.name === "Invoicing") {
            this.newInvoicing();
        } else if (this.selectedInvoicingType?.name === "Receive Payments") {
            this.selectedId = null;
            this.displayInvoiceReceive = true;
            this.receivePaymentDialogType = ReceivePaymentDialogType.MultiPayment;
        }
    }

    showViewCustomerReturn(c) {
        this.returnDialogHeader = "View Customer Return";
        this.returnDialogType = DialogType.VIEW;
        this.displayReturnAdd = true;
    }

    showEditCustomerReturn(c) {
        this.returnDialogHeader = "Edit Customer Return";
        this.selectedId = null;
        this.minimumDate = new Date();
        //this.orderStage = [...this.allStages.filter((p) => p.id == 1)][0];
        //this.orderStatusDD = this.orderStage.children;
        this.returnDialogType = DialogType.EDIT;
        this.displayReturnAdd = true;
    }

    /** Credit Memo add/edit dialog */
    //credit
    newCredit() {
        this.creditHeader = "Create Credit Memo";
        this.displayCreditAdd = true;
        this.purchaseListTB = [];
        this.subTotal = 0;
        this.orderTotal = 0;
    }

    newCreditMemo() {
        this.creditMemoDialogHeader = "New Credit Memo";
        this.creditMemoDialogType = DialogType.CREATE;
        this.displayCreditMemoAdd = true;
    }
    showEditCreditMemo({ id }) {
        this.creditMemoDialogHeader = "Edit Credit Memo";
        this.creditMemoDialogType = DialogType.EDIT;
        this.displayCreditMemoAdd = true;
    }
    showViewCreditMemo({ id }) {
        this.creditMemoDialogHeader = "View Credit Memo";
        this.creditMemoDialogType = DialogType.VIEW;
        this.displayCreditMemoAdd = true;
    }
    showCopyCreditMemo({ id }) {
        this.creditMemoDialogHeader = "Copy Credit Memo";
        this.creditMemoDialogType = DialogType.COPY;
        this.displayCreditMemoAdd = true;
    }
    deleteCreditMemo({ id }) {
        this.closingDateModuleName = TransactionNames.CreditMemo ;
        if(this.selectedRowData){
            this.closingDate = this.isAllowPostingPeriod ? (this.app._showDateTimeWithZone(this.selectedRowData?.postingDate) ?? null) : this.app._showDateTimeWithZone(this.selectedRowData?.creditMemoDate)
        }
        this.confirmationService.confirm({
            message: "Do you want to delete this Credit Memo?",
            header: "Delete Confirmation",
            icon: "pi pi-info-circle",
            accept: () => {
                if (this.statementMessage) {
                    this.messageService.add({ severity: Severity.Warn, summary: this.titlecasePipe.transform(Severity.Warn), detail: ClosingYearDisplayMessages.voidDeleteMessage });
                  }else{
                this.salesOrderService
                    .deleteCreditMemo(id)
                    .then(() => {
                        this.messageService.add({
                            severity: "success",
                            summary: "Success",
                            detail: "Deleted Successfully...",
                        });
                        this.getAllCreditMemoByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentCreditMemoFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
                        if (this.selectedView == "split") {
                            this.selectedView = "list";
                            this.selectedRowData = null;
                            this.soCols = this.estimatesCols;
                        }
                    })
                    .catch(() => {
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: "Error occurred while deleting data...",
                        });
                    });
            }
         },
            reject: () => { },
        });
    }

    handleCreditMemoTabChange(e) {
        if (e.index == 1) {
            this.getCreditMemoTransactions(this.selectedRowData.id ?? 0);
        }
        if (e.index == 2) {
            this.glApiCall = true;
        }
        else{
            this.glApiCall = false;
        }
    }

    getCreditMemoTransactions(id) {
        this.creditMemoTransactions = [];
        this.appMainService.isShowSpinner("loadInvoice");
        this.salesOrderService.getCreditMemoTransactionsById(id).subscribe((res) => {
            this.creditMemoTransactions = (res || []).map(r => ({
                ...r,
                rowId: r.id,
                id: r.receivedPaymentId,
                invoiceId: r.invoiceId,
                number: r.receivedPaymentNumber,
                txnno: r.invoiceNumber,
                statusName: r.status,
                createdDate: this.app._showDateTimeWithZone(r.createdDate),
                totalAmt: r.totalAmount,
                dueAmt: r.dueAmount,
                Amount: r.creditAmount,
                repname: r.repName,
                txnname: r.transactionTypeName
            }));
            this.netAppliedAmount = this.creditMemoTransactions?.reduce((total, trx) => total + Number(trx.Amount), 0);
            this.appMainService.isHideSpinner("loadInvoice");
        });
    }

    /** End Credit Memo add/edit dialog */

    showReceiveInvoiceTB(c) { }

    getYearRange() {
        return `${new Date().getFullYear() - 100}: ${new Date().getFullYear()} `;
    }

    //return
    newReturn() {
        this.returnDialogHeader = "Create New Customer Return";
        this.returnDialogType = DialogType.CREATE;
        this.displayReturnAdd = true;
        this.returnTemp = {
            id: 0,
            name: "",
            itemNo: "",
            isActive: "yes",
            description: "",
        };
    }

    updateInvoiceStatus({ id }) {
        this.invoicingHeader = "Edit Invoicing";
        this.displayInvoicingAdd = true;
        this.selectedId = null;
        this.invoicingDialogType = "STATUS_UPDATE";
    }

    deleteCustomerReturn(id, action) {
        this.closingDateModuleName = TransactionNames.CustomerRMA ;
        this.closingDate = this.isAllowPostingPeriod ? (this.app._showDateTimeWithZone(this.selectedInvoicing?.postingDate) ?? null) : this.app._showDateTimeWithZone(new Date(this.selectedReturn?.createdDate))
        this.confirmationService.confirm({
            message: `Do you want to ${action} this Customer Return?`,
            header: "Delete Confirmation",
            icon: "pi pi-info-circle",
            accept: () => {
                if (this.statementMessage) {
                    this.messageService.add({ severity: Severity.Warn, summary: this.titlecasePipe.transform(Severity.Warn), detail: ClosingYearDisplayMessages.voidDeleteMessage });
                  }else{
                this.salesOrderService
                    .deleteCustomerReturn(id, action)
                    .then(() => {
                        this.messageService.add({
                            severity: "success",
                            summary: "Success",
                            detail: "RMA Deleted Successfully",
                        });

                        this.getAllCustomerReturnsByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentCustomerReturnFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);

                        if (this.selectedView == "split" && action == "void") {
                            this.selectedReturn.status = "Void";
                        }
                    })
                    .catch(() => {
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: "Error occurred while deleting RMA",
                        });
                    });
            }
         },
            reject: () => { },
        });
    }

    setCheckBoxValue(value) {
        const checkBox = [];
        value.forEach((element) => {
            const val = { name: element };
            checkBox.push(val);
        });
        return checkBox;
    }

    setCustomAttributes(value) {
        const custom = [];
        if (value.length > 0) {
            value.forEach((element) => {
                const customEach = {
                    id: 0,
                    createdSource: this.app.userIP,
                    updatedSource: this.app.userIP,
                    createdBy: this.app.userId,
                    updatedBy: this.app.userId,
                    createdDate: this.app._saveDateTimeWithZone(new Date()),
                    updatedDate: this.app._saveDateTimeWithZone(new Date()),
                    objectId: this.orderObjId,
                    objectValue: 0,
                    customAttributeId: element.id,
                    customAttribute: this.modifyCustumAttributes(element),
                    value: element.formControl?.name == "InputBox" || element.formControl?.name == "DatePicker" ? element.value : null,
                    statusId: Status.Active,
                    status: null,
                    values: element.formControl?.name == "DropDownList" ? element.value : element.formControl?.name == "RadioButton" ? { name: element.value } : null,
                    multipleValues: element.formControl?.name == "MultipleDropDownList" ? element.value : element.formControl?.name == "CheckBox" ? this.setCheckBoxValue(element.value) : null,
                    ratingId: element.formControl?.name == "Rating" ? element.value : 0,
                    toggle: element.formControl?.name == "ToggleButton" ? element.value : false,
                    customeAttachement: element.formControl?.name == "FileUpload" || element.formControl?.name == "Picture" ? element.customUploadedFiles : null,
                };
                custom.push(customEach);
            });
        }
        return custom;
    }

    setExistingCustomAttributes(value) {
        const custom = [];
        if (value.length > 0) {
            value.forEach((element) => {
                const customEach = {
                    id: this.estimatesDetails.customAttributeValues.filter((custom) => custom.customAttributeId == element.id)[0] ? this.estimatesDetails.customAttributeValues.filter((custom) => custom.customAttributeId == element.id)[0]?.id : 0,
                    createdSource: this.app.userIP,
                    updatedSource: this.app.userIP,
                    createdBy: this.app.userId,
                    updatedBy: this.app.userId,
                    createdDate: this.app._saveDateTimeWithZone(new Date()),
                    updatedDate: this.app._saveDateTimeWithZone(new Date()),
                    objectId: this.orderObjId,
                    objectValue: this.estimatesDetails.id,
                    customAttributeId: element.id,
                    customAttribute: this.modifyCustumAttributes(element),
                    value: element.formControl?.name == "InputBox" || element.formControl?.name == "DatePicker" ? element.value : null,
                    statusId: Status.Active,
                    status: null,
                    values: element.formControl?.name == "DropDownList" ? element.value : element.formControl?.name == "RadioButton" ? { name: element.value } : null,
                    multipleValues: element.formControl?.name == "MultipleDropDownList" ? element.value : element.formControl?.name == "CheckBox" ? this.setCheckBoxValue(element.value) : null,
                    ratingId: element.formControl?.name == "Rating" ? element.value : 0,
                    toggle: element.formControl?.name == "ToggleButton" ? element.value : false,
                    customeAttachement: element.formControl?.name == "FileUpload" || element.formControl?.name == "Picture" ? element.customUploadedFiles : null,
                };
                custom.push(customEach);
            });
        }
        return custom;
    }

    modifyCustumAttributes(data) {
        // data.forEach(element => {
        //     if (element['customAttribute'] && element['customAttribute']['pickListValues']) {
        //         element['customAttribute']['pickListValues'] = JSON.stringify(element['customAttribute']['pickListValues']);
        //     }
        // });
        if (data.pickListValues) {
            data.pickListValues = JSON.stringify(data.pickListValues);
        }
        return data;
    }

    createCustomAttributeList() { }

    onCustomUpload(files: File[], field) {
        //this.appMainService.isShowSpinner('upload');
        if (typeof Worker !== undefined) {
            for (let file of files) {
                let errors = validateFiles(file, 4, this.allowedExtensions);
                if (errors.length > 0) {
                    for (let error of errors) {
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: error.fileName + ": " + error.error,
                        });
                    }
                    //this.appMainService.isHideSpinner('upload');
                } else {
                    uploadFiles(file, ({ name, content, size, extension }) => {
                        let attachment = {
                            name: name,
                            content: content,
                            extension: extension,
                            sizeInBytes: size,
                        };
                        field.customUploadedFiles.push(attachment);
                    });
                }
            }
        } else {
            this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "Please update the browser. Web Workers are not supported in the older versions of this browser.",
            });
        }
    }

    deleteFile(field, index) {
        field.customUploadedFiles.splice(index, 1);
    }

    getAllGroup() {
        this.salesOrderService.getAllGroups().subscribe((res) => {
            const disGroupId = res.filter((r) => r?.name?.toLowerCase() == "discount type")[0].id;
            this.getAllDiscountByGroupId(disGroupId);
        });
    }

    getAllDiscountByGroupId(groupId) {
        this.salesOrderService.getGroupById(groupId).subscribe((res) => {
            this.discounts = res;
        });
    }

    onSaveComplete(event) {
        this.displayConvertToSalesOrder = event;
        this.salesOrderDialogType = "";
        this.selectedId = null;

        if (this.selectedView == "split" && this.selectedChannel?.name == this.soChannel.SALES_ORDER) {
            this.selectedId = this.selectedOrder.id;
            this.isOrderToBeShipped = false;
            this.getSalesOrderDetailsById(this.selectedOrder.id);
            this.getAllSalesOrderByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentSOFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        } else if (this.selectedView == "list" && this.selectedChannel?.name == this.soChannel.SALES_ORDER) {
            this.isOrderToBeShipped = false;
            this.getAllSalesOrderByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentSOFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        } else if (this.selectedView == "split" && this.selectedChannel?.name == this.soChannel.ESTIMATES) {
            this.estimateTemplates = this.templates.filter((t) => t.typeId == this.selectedChannel?.id)[0];
            this.selectedId = this.selectedEstimate.id;
            this.getEstimatesDetailsById(this.selectedEstimate.id);
        } else if (this.selectedView == "list" && this.selectedChannel?.name == this.soChannel.ESTIMATES) {
            this.getAllEstimatesByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecent.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        } else if (this.selectedView == "split" && this.selectedChannel?.name == this.soChannel.CUSTOMER_RETURNS) {
            this.selectedId = this.selectedReturn?.id;
            this.getCustomerReturnDetailsById(this.selectedReturn?.id);
        } else if (this.selectedView == "list" && this.selectedChannel?.name == this.soChannel.CUSTOMER_RETURNS) {
            this.getAllCustomerReturnsByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentCustomerReturnFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        }
    }

    onConvertToSOModalClose() {
        this.displayConvertToSalesOrder = false;
    }

    onRmaSaveComplete(event) {
        this.displayReturnAdd = false;
        this.returnDialogType = "";
        if (this.selectedView == "split") {
            this.selectedId = this.selectedCustomerReturn.id;
            this.getCustomerReturnDetailsById(this.selectedCustomerReturn.id);
            this.getAllCustomerReturnsByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentCustomerReturnFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        } else {
            this.getAllCustomerReturnsByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentCustomerReturnFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        }
    }

    onCreditMemoDialogClose(event) {
        this.onBodyAuto();
        this.displayCreditMemoAdd = false;
        this.creditMemoDialogType = "";
        if (this.selectedView == "split" && this.selectedChannel?.name == this.soChannel.CREDIT_MEMO) {
            this.getCreditMemoDetailsById(this.selectedRowData.id);
        } else if (this.selectedView == "list" && this.selectedChannel?.name == this.soChannel.CREDIT_MEMO) {
            this.getAllCreditMemoByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentCreditMemoFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        } else if (this.selectedView == "split" && this.selectedChannel?.name == this.soChannel.CUSTOMER_RETURNS) {
            this.selectedId = this.selectedReturn?.id;
            this.getCustomerReturnDetailsById(this.selectedReturn?.id);
        } else if (this.selectedView == "list" && this.selectedChannel?.name == this.soChannel.CUSTOMER_RETURNS) {
            this.getAllCustomerReturnsByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentCustomerReturnFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        }
    }


    onBodyAuto(){
        let body = document.getElementsByTagName('body')[0];
        body.classList.remove('overflow-hidden');
        body.classList.add('overflow-auto');
    }

    onEstimateDialogClose(event) {
        this.displayEstimateAdd = false;
        this.estimateDialogType = "";
        if (this.selectedView == "split") {
            this.getEstimatesDetailsById(this.selectedEstimate.id);
        } else {
            this.getAllEstimatesByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecent.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        }
    }

    onSalesOrderCancel(event) {
        this.displayConvertToSalesOrder = false;
        this.salesOrderDialogType = "";
        this.isOrderVoid = false;
        this.isOrderToBeShipped = false;
    }

    onReturnCancel(event) {
        this.displayReturnAdd = false;
        this.returnDialogType = "";
    }

    onCreditMemoDialogCancel(event) {
        if (event.type === 'cancel') {
            event.stopPropagation(); 
            return;
          }
        this.displayCreditMemoAdd = false;
        this.creditMemoDialogType = "";
        this.isCreditVoid = false;
    }
    onCreditMemoConfirmVoid(event: { status: boolean; message: string }) {
        this.closingDateModuleName = TransactionNames.CreditMemo ;
        if(this.selectedRowData){
            this.closingDate = this.isAllowPostingPeriod ? (this.app._showDateTimeWithZone(this.selectedRowData?.postingDate) ?? null) : this.app._showDateTimeWithZone(this.selectedRowData?.creditMemoDate)
        }
        this.confirmationService.confirm({
            message: "Are you sure that you want to proceed?",
            header: "Confirmation",
            icon: "pi pi-exclamation-triangle",
            accept: () => {
                if (this.statementMessage) {
                    this.messageService.add({ severity: Severity.Warn, summary: this.titlecasePipe.transform(Severity.Warn), detail: ClosingYearDisplayMessages.voidDeleteMessage });
                  }else{
                this.showCreditVoidMsg = !this.showCreditVoidMsg;
                if (this.showCreditVoidMsg) {
                    this.messageService.add({
                        severity: "info",
                        summary: "Confirmed",
                        detail: "You have voided",
                    });
                } else if (!this.showCreditVoidMsg) {
                    this.messageService.add({
                        severity: "info",
                        summary: "Confirmed",
                        detail: "You have unvoided",
                    });
                }
                this.onCreditMemoDialogCancel(false);
            }
        },
            reject: () => { },
        });
    }

    onReceivePaymentsDialogClose(event) {
        this.displayInvoiceReceive = event;
        this.receivePaymentDialogType = "";
        if (this.selectedView == "split" && this.selectedChannel?.name == this.soChannel.INVOICING) {
            this.selectedId = this.selectedInvoicing.id;
            this.getInvoicingDetailsById(this.selectedInvoicing.id);
            this.getInvoiceRecievedPaymentsById(this.selectedInvoicing.id);
        }else if (this.selectedChannel?.name == this.soChannel.SALES_RECEIPT) {
            if(this.selectedView == "split"){
                this.getAllSalesReceiptsPagination(this.pageNumber, this.pageSize,this.selectedRowData?.id);
            }else{
                this.getAllSalesReceiptsPagination(this.pageNumber, this.pageSize,'');
            }
        } else {
            this.getAllInvoiceByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentInvoiceFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
        }
    }

    getAllDiscounts() {
        this.salesOrderService.getAllDiscount().subscribe((res) => {
            this.footerDiscountEnabled = res.item1;
            if (res.item1) {
                const discountsData = _.cloneDeep(res.item2);
                this.allDiscounts = discountsData.filter((d) => d.name == "Manual");
            }

            // free shipping
            if (res.item2 && res.item2.length) {
                this.freeShippingObj = res.item2.filter((d) => d?.name?.toLowerCase() == "free shipping")[0];
            }
        });
    }

    // getAllTax() {
    //     this.salesOrderService.getAllTax().subscribe((res) => {
    //         this.footerTaxEnabled = res.item1;
    //         if (res.item1) {
    //             this.allTax = res.item2;
    //         }
    //     });
    // }

    // activity logs
    displayActivityTaskAddModal() {
        this.displayActivityTaskAdd = true;
    }

    displayActivityEventAddModal() {
        this.displayActivityEventAdd = true;
    }

    displayActivityEmailAddModal() {
        this.displayActivityEmailAdd = true;
    }

    displayActivityLogAddModal() {
        this.displayActivityLogAdd = true;
    }

    displayActivityNoteAddModal() {
        this.displayActivityNoteAdd = true;
    }

    cancelTask(event) {
        this.displayActivityTaskAdd = event.cancelTask;
    }

    cancelNote(event) {
        this.displayActivityNoteAdd = event.cancelTask;
    }

    cancelLog(event) {
        this.displayActivityLogAdd = event.cancelLog;
    }

    cancelEvent(event) {
        this.displayActivityEventAdd = event.cancelEvent;
    }

    cancelEmail(event) {
        this.displayActivityEmailAdd = event.cancelEmail;
    }

    onCancelClicked(e) {
        this.displayProductSelectionModal = false;
    }

    checkTask(event) {
        if (event.taskAdded) {
            this.app.getAllObjects();
            let objectTypeId = this.app.allObjects.filter((elem) => elem.name === this.app.objectType)[0].type;
            this.objectTaskService.lionO36020APIObjectTaskGet(this.app.objectId, objectTypeId).subscribe((tasks: Task[]) => {
                this.displayActivityTaskAdd = false;
            });
        } else {
            this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "Error occurred while saving data...",
            });
        }
    }

    isNumberKey(evt) {
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
        return true;
    }

    getFormattedData(field) {
        if (field && field?.value && field?.value.length > 0) {
            let d = "";
            field.value.forEach((f) => {
                d += f.name + ",";
            });
            return d.substring(0, d.length - 1);
        } else {
            return "";
        }
    }

    getFormattedDiscount(details) {
        if (details?.discountType?.description == "$") {
            return "$" + details.discountAmount.toString();
        } else if (details?.discountType?.description == "%") {
            const val = Number(details.discountAmount * 100) / Number(details.totalAmount);
            return val.toString() + "%";
        } else {
            return "";
        }
    }

    createInvoiceTB() {
        // this.showEditOrder({ id: this.selectedOrder.id });
        this.showShipOrder({ id: this.selectedOrder.id });
    }

    onInvoiceCreate(e) {
        this.newStage = { id: this.salesOrderDetails.salesOrderStageId };
        if (this.salesOrderDetails?.salesOrderStageId == SoStageId.Shipped) {
            this.showViewOrder({ id: this.selectedOrder.id });
        } else if (this.salesOrderDetails?.salesOrderStageId == SoStageId.Verification || this.salesOrderDetails?.salesOrderStageId == SoStageId.Labelling || this.salesOrderDetails?.salesOrderStageId == SoStageId.ReadyToShip) {
            this.showShipOrder({ id: this.selectedOrder.id });
        } else {
            this.showEditOrder({ id: this.selectedOrder.id });
        }
    }

    showBackOrderOption() {
        this.displayBackOrderOption = true;
    }

    showReceivePayment({ id }) {
        this.selectedId = null;
        this.displayInvoiceReceive = true;
        this.receivePaymentDialogType = ReceivePaymentDialogType.SinglePayment;
    }

    updateRmaContextMenu(event) {
        if (event) {
            if (this.selectedView == "split" && this.selectedChannel?.name == this.soChannel.CUSTOMER_RETURNS) {
                this.selectedId = this.selectedReturn?.id;
                this.getCustomerReturnDetailsById(this.selectedReturn?.id);
            } else if (this.selectedView == "list" && this.selectedChannel?.name == this.soChannel.CUSTOMER_RETURNS) {
                this.getAllCustomerReturnsByPagination(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.selectedRecentCustomerReturnFilter.code, this.searchValue, this.searchColumns, this.sortBy, this.isAscending, this.isActive);
            }
        }
    }

    //Customer return context menu
    buildCustomerReturnContextMenu() {
        this.configMenuItemsReturns = [
            {
                label: "View",
                icon: "pi pi-list",
                command: () => {
                    this.showViewCustomerReturn({ id: this.selectedReturn?.id });
                },
            },
             {
                label: "Edit",
                icon: "pi pi-pencil",
                visible: this.selectedReturn?.statusId != RmaStatus.Approved,
                command: () => {
                    this.showEditCustomerReturn({ id: this.selectedReturn?.id });
                },
            },
            {
                label: "Delete",
                icon: "pi pi-trash",
                visible: true,
                command: () => {
                    this.deleteCustomerReturn(this.selectedReturn?.id, "delete");
                },
            },
            {
                label: "Void",
                icon: "pi pi-ban",
                visible: this.selectedReturn?.statusId == RmaStatus.Approved,
                command: () => {
                    this.deleteCustomerReturn(this.selectedReturn?.id, "void");
                },
            },
            {
                label: "Convert to Sales Order",
                icon: "pi pi-pencil",
                visible: !this.selectedReturn?.isConverted && this.selectedReturn?.statusId == RmaStatus.Approved && this.selectedReturn?.requestType == "Exchange",
                command: () => {
                    this.convertRMAToSalesOrder({ id: this.selectedReturn?.id });
                },
            },
            {
                label: "Convert to Invoice",
                icon: "pi pi-pencil",
                visible: !this.selectedReturn?.isConverted && this.selectedReturn?.statusId == RmaStatus.Approved && this.selectedReturn?.requestType == "Exchange",
                command: () => {
                    this.convertRMAToInvoice({
                        id: this.selectedReturn?.id,
                    });
                },
            },
            {
                label: "Convert to Credit Memo",
                icon: "pi pi-pencil",
                visible: !this.selectedReturn?.isConverted && this.selectedReturn?.statusId == RmaStatus.Approved && this.selectedReturn?.requestType == "Credit",
                command: () => {
                    this.convertRMAToCreditMemo({
                        id: this.selectedReturn?.id,
                    });
                },
            },
            {
                label: "Print",
                icon: "pi pi-print",
                items: [
                    {
                        label: "Print",
                        icon: "pi pi-print",
                        command: () => {
                            this.printPreview({
                                id: this.selectedReturn?.id,
                            });
                        },
                    },
                ],
            },
            {
                label: "Email",
                icon: "pi pi-envelope",
                command: () => {
                    this.sendEmail({
                        id: this.selectedReturn?.id,
                    });
                },
            },
        ];
    }
    voidCustomerReturn(arg0: { id: any }) {
        throw new Error("Method not implemented.");
    }

    loadShippingMethod() {
        this.allShippingMethodDropdown = [];
        // const array = [];
        this.shippingMethodService.getShippingMethodList().subscribe((shipping) => {
            this.allShippingMethods = shipping;
            this.allShippingMethodDropdown = shipping?.filter(m => m.statusId == Status.Active);
            
            
            // this.allShippingMethods.forEach((element) => {
            //     if (element.statusId == Status.Active) {
            //         array.push(element);
            //     }
            // });
            // this.allShippingMethodDropdown = array;
        });
    }

    onEnterDownStopPropagation(event) {
        event.stopPropagation();
    }

    getBackOrderConfig() {
        this.appMainService.isShowSpinner("loadBOConfig");
        this.ordersService.getAllTypes().subscribe(
            (types) => {
                this.appMainService.isHideSpinner("loadBOConfig");
                const id = types.filter((type) => type.name == "Back Order Status")[0].id;
                const configs = this.configuration.filter((s) => s.name == "Back Order Status" && s.typeId == id)[0];
                const configJson = configs?.configurationDetails[0]?.configJSONValue != "" ? JSON.parse(configs.configurationDetails[0].configJSONValue) : [];
                const backOrderEnable = (this.isEnabledBackOrder = configJson.filter((c) => c.name == "Enabling back order")[0]);
                this.isEnabledBackOrder = backOrderEnable?.isDefault;
                this.isEnabledBackOrderKit = backOrderEnable?.EnableBackOrderForKit;
                this.isEnabledBackOrderBundle = backOrderEnable?.EnableBackOrderForBundle;
            },
            (err) => {
                this.appMainService.isHideSpinner("loadBOConfig");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred...",
                });
            },
        );
    }

    /** Print preview */

    printInvoice({ id }) {
        if (this.selectedView == "list") {
            this.getInvoicingDetailsById(id, "PRINT");
        } else {
            this.invoicePrint.print();
        }
    }
    printPreview({ id }) {
        if (this.selectedView == "list") {
            switch (this.selectedChannel?.name) {
                case this.soChannel.ESTIMATES:
                    this.getEstimatesDetailsById(id, "PRINT");
                    break;
                case this.soChannel.SALES_ORDER:
                    this.getSalesOrderDetailsById(id, "PRINT");
                    break;
                case this.soChannel.INVOICING:
                    this.getInvoicingDetailsById(id, "PRINT");
                    break;
                case this.soChannel.CUSTOMER_RETURNS:
                    this.getCustomerReturnDetailsById(id, "PRINT");
                    break;
                case this.soChannel.CREDIT_MEMO:
                    this.getCreditMemoDetailsById(id, "PRINT");
                    break;
            }
        } else {
            this.soPdf.print();
        }
    }
    downloadAsPdf() {
        this.soPdf.downloadAsPdf();
    }
    getSalesOrderPdf(type: string, emailType: string) {
        this.soPdf.getPdf(type).subscribe((res) => {
            this.setSOEmailContent(res, emailType);
            this.displayNewEmail = true;
        });
    }
    getInvoicePdf(type: string) {
        this.invoicePrint.getPdf(type).subscribe((res) => {
            this.setInvoiceEmailContent(res);
            this.displayNewEmail = true;
        });
    }
    packSlipPrint({ id }) {
        if (this.selectedView == "list") {
            this.getSalesOrderDetailsById(id, PrintType.PACKSLIPPRINT);
        } else {
            // this.soPrint.print(PrintType.PACKSLIPPRINT);
            this.soPdf.print(PrintType.PACKSLIPPRINT);
        }
    }
    pickSlipPrint({ id }) {
        if (this.selectedView == "list") {
            this.getSalesOrderDetailsById(id, PrintType.PICKSLIPPRINT);
        } else {
            // this.soPrint.print(PrintType.PICKSLIPPRINT);
            this.soPdf.print(PrintType.PICKSLIPPRINT);
        }
    }

    /** End Print preview */

    /** Send Email */

    sendEmail({ id }) {
        if (this.selectedView == "list") {
            switch (this.selectedChannel?.name) {
                case this.soChannel.ESTIMATES:
                    this.getEstimatesDetailsById(id, "EMAIL");
                    break;
                case this.soChannel.SALES_ORDER:
                    this.getSalesOrderDetailsById(id, "EMAIL");
                    break;
                case this.soChannel.INVOICING:
                    this.getInvoicingDetailsById(id, "EMAIL");
                    break;
                case this.soChannel.CUSTOMER_RETURNS:
                    this.getCustomerReturnDetailsById(id, "EMAIL");
                    break;
                case this.soChannel.CREDIT_MEMO:
                    this.getCreditMemoDetailsById(id, "EMAIL");
                    break;
            }
        } else {
            this.openEmailDialog();
        }
    }
    setEmailContext(customerName, moduleName) {
        this.emailContent = `<p>Dear ${customerName} ,</p><br/><p>Please review the attached ${moduleName}. Feel free to contact us if you have any questions.</p><br/><p>We look forward to working with you.</p><br/><br/><p>Sincerely,</p><br/><p>${this.app?.user?.organizationName}</p><br/><p>${""}</p>`;
    }
    setEstimatesEmailContent(attachment) {
        let fullName = this.getFullName(this.estimatesDetails?.contact);
        let data = {
            attachment: attachment,
            number: this.selectedEstimate?.estimateno,
            emailTo: this.estimatesDetails?.contact?.contactEmails?.length && this.estimatesDetails?.contact?.contactEmails[0]?.email?.emailAddress ? this.estimatesDetails?.contact?.contactEmails[0]?.email?.emailAddress : "",
            type: SOEmailType.Estimate,
            organizationName: this.app?.user?.organizationName,
            customerName: fullName,
        };
        this.emailData = this.soEmailContentBuilderService.getEmailContent(data);
    }
    setSOEmailContent(attachment, type) {
        let fullName = this.getFullName(this.salesOrderDetails?.contact);
        let data = {
            attachment: attachment,
            number: this.selectedOrder?.SONo,
            emailTo: this.salesOrderDetails?.contact?.contactEmails?.length && this.salesOrderDetails?.contact?.contactEmails[0]?.email?.emailAddress ? this.salesOrderDetails?.contact?.contactEmails[0]?.email?.emailAddress : "",
            type: type,
            organizationName: this.app?.user?.organizationName,
            customerName: fullName,
        };
        this.emailData = this.soEmailContentBuilderService.getEmailContent(data);
    }
    setInvoiceEmailContent(attachment) {
        let fullName = this.getFullName(this.invoicingDetails?.contact);
        let data = {
            attachment: attachment,
            number: this.selectedChannel.name == this.soChannel.SALES_ORDER ? this.invoicingDetails?.number : this.selectedInvoicing?.number,
            emailTo: this.invoicingDetails?.contact?.contactEmails?.length && this.invoicingDetails?.contact?.contactEmails[0]?.email?.emailAddress ? this.invoicingDetails?.contact?.contactEmails[0]?.email?.emailAddress : "",
            type: SOEmailType.Invoice,
            organizationName: this.app?.user?.organizationName,
            customerName: fullName,
        };
        this.emailData = this.soEmailContentBuilderService.getEmailContent(data);
    }
    setCreditMemoEmailContent(attachment) {
        let fullName = this.getFullName(this.creditMemoDetails?.contact);
        let data = {
            attachment: attachment,
            number: this.selectedRowData?.number,
            emailTo: this.creditMemoDetails?.contact?.contactEmails?.length && this.creditMemoDetails?.contact?.contactEmails[0]?.email?.emailAddress ? this.creditMemoDetails?.contact?.contactEmails[0]?.email?.emailAddress : "",
            type: SOEmailType.CreditMemo,
            organizationName: this.app?.user?.organizationName,
            customerName: fullName,
        };
        this.emailData = this.soEmailContentBuilderService.getEmailContent(data);
    }
    
    setCustomerReturnEmailContent(attachment) {
        this.displayNewEmail = true;
        let fullName = this.getFullName(this.customerReturnDetails?.contact);
        let data = {
            attachment: attachment,
            number: this.selectedReturn?.rmaNumber,
            emailTo: this.customerReturnDetails?.contact?.contactEmails?.length && this.customerReturnDetails?.contact?.contactEmails[0]?.email?.emailAddress ? this.customerReturnDetails?.contact?.contactEmails[0]?.email?.emailAddress : "",
            type: SOEmailType?.CustomerReturn,
            organizationName: this.app?.user?.organizationName,
            customerName: fullName,
        };
        this.emailData = this.soEmailContentBuilderService?.getEmailContent(data);
    }

    getFullName(contact) {
        let fullName = "";
        if (contact?.firstName) {
            fullName += contact?.firstName + " ";
        }
        if (contact?.lastName) {
            fullName += contact?.lastName;
        }
        return fullName;
    }
    sendEmailFromSO({ id, type }) {
        if (this.selectedView == "list") {
            if (type == SOEmailAttachmentType.EMAILINVOICE) {
                this.getInvoicingDetailsById(id, type);
            } else {
                this.getSalesOrderDetailsById(id, type);
            }
        } else {
            this.openEmailDialog(type);
        }
    }

    getCustomerReturnEmail(attachment){
             this.setCustomerReturnEmailContent(attachment)
      }

    openEmailDialog(type = "") {
        this.emailAttachments = [];
        this.emailSubject = "";
        this.emailTo = "";
               
        switch (this.selectedChannel?.name) {
            case this.soChannel.ESTIMATES:
                this.soPdf.getPdf().subscribe((res) => {
                    this.setEstimatesEmailContent(res);
                    this.displayNewEmail = true;
                });
                break;
            case this.soChannel.INVOICING:
                this.getInvoicePdf(PrintType.PRINT);
                break;
            case this.soChannel.CREDIT_MEMO:
                this.soPdf.getPdf().subscribe((res) => {
                    this.setCreditMemoEmailContent(res);
                    this.displayNewEmail = true;
                });
                break;
            case this.soChannel.SALES_ORDER:
                switch (type) {
                    case SOEmailAttachmentType.EMAILPICKSLIP:
                        this.getSalesOrderPdf(PrintType.PICKSLIPPRINT, SOEmailType.PickSlip);
                        break;
                    case SOEmailAttachmentType.EMAILPACKSLIP:
                        this.getSalesOrderPdf(PrintType.PACKSLIPPRINT, SOEmailType.PackSlip);
                        break;
                    case SOEmailAttachmentType.EMAILSO:
                        this.getSalesOrderPdf(PrintType.PRINT, SOEmailType.SalesOrder);
                        break;
                    case SOEmailAttachmentType.EMAILINVOICE:
                        this.getInvoicePdf(PrintType.PRINT);
                        break;
                }
        }
    }
    onEmailCancel(e) {
        this.displayNewEmail = false;
    }
    onEmailSendComplete(e) {
        this.displayNewEmail = false;
    }

    /** End Send Email */

    getAllVendors() {
        this.shippingService.getAllCategory().subscribe((res) => {
            if (res && res.length) {
                const shipCategory = res.filter((r) => r?.name?.toLowerCase() == "shipping")[0];
                this.shippingService.getAllVendorsByCategoryId(shipCategory?.id).subscribe((res) => {
                    this.allVendors = res.filter((r) => r.isInstalled == true);
                    this.vendorFedexInfo = res.filter((r) => r.name.toLowerCase() == "fedex")[0];
                    this.vendorUpsInfo = res.filter((r) => r.name.toLowerCase() == "ups")[0];
                    this.getFedexAccounts();
                    this.getUpsAccounts();
                });
            }
        });
    }

    getFedexAccounts() {
        this.allFedexAccounts = [];
        const loggedinUser = this.accountUserService.userValue;
        const organizationId = loggedinUser.organizationId;
        const vendorId = this.vendorFedexInfo?.id;

        this.shippingService.getFedexIsProdAddressVerify(vendorId).subscribe(
            (result) => {
                const isProd = result?.isProduction ? result?.isProduction : false;
                this.salesOrderService.getFedexAccounts(organizationId, vendorId).subscribe((res) => {
                    const accounts = [];
                    if (res && res.length) {
                        res.forEach((r) => {
                            const obj = r;
                            if (obj.accountDetails) {
                                const textarray = obj.accountDetails.split(";");
                                let addValue = "";
                                let accValue = "";
                                if (textarray && textarray.length > 0) {
                                    addValue = textarray[0].substring(13, textarray[0].length);
                                }
                                if (textarray && textarray.length > 0) {
                                    accValue = textarray[1].substring(13, textarray[1].length);
                                }
                                obj["addressValue"] = JSON.parse(atob(addValue));
                                obj["accountValue"] = JSON.parse(atob(accValue));
                            }
                            obj.isDefault = obj.isDefault == "true" ? true : false;
                            obj.name = obj.accountValue?.accountName && obj.accountValue?.accountNumber ? obj.accountValue?.accountNumber + " - " + obj.accountValue?.accountName : "";
                            if (obj.isDefault) {
                                this.fedexAccountInfo = obj;
                            }
                            accounts.push(obj);
                        });
                    }
                    if (isProd) {
                        this.allFedexAccounts = accounts.filter((a) => a.isProduction == true); // prod accounts
                    } else {
                        this.allFedexAccounts = accounts.filter((a) => a.isProduction == false); // test accounts
                    }
                });
            },
            (error) => {
                this.messageService.add({
                    severity: "error",
                    summary: this.titlecasePipe.transform("error"),
                    detail: "Error occurred...",
                });
            },
        );
    }

    getUpsAccounts() {
        this.allFedexAccounts = [];
        const loggedinUser = this.accountUserService.userValue;
        const organizationId = loggedinUser.organizationId;
        const vendorId = this.vendorUpsInfo?.id;

        this.shippingService.getFedexIsProdAddressVerify(vendorId).subscribe(
            (result) => {
                const isProd = result?.isProduction ? result?.isProduction : false;
                this.salesOrderService.getFedexAccounts(organizationId, vendorId).subscribe((res) => {
                    const accounts = [];
                    if (res && res.length) {
                        res.forEach((r) => {
                            const obj = r;
                            if (obj.accountDetails) {
                                const textarray = obj.accountDetails.split(";");
                                let addValue = "";
                                let accValue = "";
                                if (textarray && textarray.length > 0) {
                                    addValue = textarray[0].substring(13, textarray[0].length);
                                }
                                if (textarray && textarray.length > 0) {
                                    accValue = textarray[1].substring(13, textarray[1].length);
                                }
                                obj["addressValue"] = JSON.parse(atob(addValue));
                                obj["accountValue"] = JSON.parse(atob(accValue));
                            }
                            obj.isDefault = obj.isDefault == "true" ? true : false;
                            obj.name = obj.accountValue?.accountName && obj.accountValue?.accountNumber ? obj.accountValue?.accountNumber + " - " + obj.accountValue?.accountName : "";
                            if (obj.isDefault) {
                                this.fedexAccountInfo = obj;
                            }
                            accounts.push(obj);
                        });
                    }
                    if (isProd) {
                        this.allUpsAccounts = accounts.filter((a) => a.isProduction == true); // prod accounts
                    } else {
                        this.allUpsAccounts = accounts.filter((a) => a.isProduction == false); // test accounts
                    }
                });
            },
            (error) => {
                this.messageService.add({
                    severity: "error",
                    summary: this.titlecasePipe.transform("error"),
                    detail: "Error occurred...",
                });
            },
        );
    }

    getAllAddressTypes() {
        this.salesOrderService.getAddressTypes().subscribe((types) => {
            if (types && types.length) {
                this.billingAddressType = types.filter((t) => t.name?.toLowerCase() == "billing")[0];
                this.shippingAddressType = types.filter((t) => t.name?.toLowerCase() == "shipping")[0];
            }
        });
    }

    //tracking
    openImport() {
        this.importCount = 0;
        this.productList = [];
        const productList = this.selectedChannel?.name == "Credit Memo" ? this.creditMemoDetailsPurchaseList : this.selectedChannel?.name == "Sales Order" ? this.saleOrdersDetailsPurchaseList : this.invoicingDetailsPurchaseList;
        for (let prd of productList) {
            for (let bundle of this.selectedChannel?.name == "Credit Memo" ? prd.creditMemoBundleDetail : this.selectedChannel?.name == "Invoicing" ? prd.invoiceBundleDetail : prd?.salesOrderBundleDetail) {
                if (bundle.trackingEnabled) {
                    const serialCount = this.selectedChannel?.name == "Invoicing" ? bundle.invoiceBundleProductSerialDetail?.length : this.selectedChannel?.name == "Sales Order" ? bundle.salesOrderBundleProductSerialDetail?.length : bundle.creditMemoBundleProductSerialDetail?.length;
                    this.importCount = this.importCount + (bundle.totalQty - serialCount);
                    this.productList.push(bundle);
                    /**kit under kit items**/
                    for (let kp of this.selectedChannel?.name == "Credit Memo" ? bundle.creditMemoBundleDetail : this.selectedChannel?.name == "Invoicing" ? bundle.invoiceBundleDetail : bundle?.salesOrderBundleDetail) {
                        if (kp.trackingEnabled) {
                            const serialCount = this.selectedChannel?.name == "Invoicing" ? kp.invoiceBundleProductSerialDetail?.length : this.selectedChannel?.name == "Sales Order" ? kp.salesOrderBundleProductSerialDetail?.length : kp.creditMemoBundleProductSerialDetail?.length;
                            this.importCount = this.importCount + (kp.totalQty - serialCount);
                            this.productList.push(kp);
                        }
                    }
                }
            }
            if (prd.trackingEnabled) {
                const serialCount = this.selectedChannel?.name == "Invoicing" ? prd.invoiceProductSerialDetail?.length : this.selectedChannel?.name == "Sales Order" ? prd.salesOrderSerialDetail?.length : prd.creditMemoProductSerialDetail?.length;
                this.importCount = this.importCount + (prd.totalQty - serialCount);
                this.productList.push(prd);
            }

        }
        const unMatchedCount = this.selectedChannel?.name == "Credit Memo" ? Number(this.creditMemoDetails?.notMatchedSerialNumbers?.length) : this.selectedChannel?.name == "Sales Order" ? Number(this.salesOrderDetails?.notMatchedSerialNumbers?.length) : Number(this.invoicingDetails?.notMatchedSerialNumbers?.length);
        this.importCount = this.importCount - unMatchedCount;
        this.displayImport = true;
        const productsIds = [];
        this.productList?.forEach((element) => {
            productsIds.push(element.product?.id);
        });
        const ids = productsIds.join(",");
        this.warehouseId = this.selectedChannel?.name == "Credit Memo" ? this.creditMemoDetails?.warehouseId : this.selectedChannel?.name == "Sales Order" ? this.salesOrderDetails?.warehouseId : this.invoicingDetails?.warehouseId;
        this.checkSerialNoInSystem(ids, this.warehouseId, 0);
    }

    hideImport() {
        this.displayImport = false;
    }

    checkExtraSerialNOProductWise(data) {
        for (let prd of this.productList) {
            const itemCount = data?.filter(rcd => rcd.itemNo == prd.itemNo);
            const samePrd = this.productList?.filter(dup => dup.itemNo == prd.itemNo);
            let samePrdCount = 0;
            for (let prd of samePrd) {
                samePrdCount = (samePrdCount + prd.totalQty);
            }
            if (itemCount?.length > samePrdCount) {
              return true;
            }
          }
      }

    saveImport(data) {
        if(this.checkExtraSerialNOProductWise(data)){
            this.alertDialog(data);
         }else{
           this.importSerialDataforAllPrd(data);
         }
    }

    alertDialog(data){
        this.confirmationService.confirm({
          message: "You cannot import serial numbers more than ordered qty,Do you still want to proceed?",
          header: "Alert Confirmation",
          icon: "pi pi-info-circle",
          accept: () => {
              const products = [];
              for (let prd of this.productList) {
                const itemCount = data?.filter(data => data.itemNo == prd.itemNo);
                if ((itemCount?.length - prd.serialCount) > (prd.totalQty - prd.serialCount)) {
                  const actualCount = itemCount.splice(0,(prd.totalQty));
                  for (let product of actualCount) {
                    products.push(product)
                  }
                } else {
                  products.push(itemCount);
                }
              }
              this.importSerialDataforAllPrd(products)
          },
          reject: () => { },
        });
      }

    importSerialDataforAllPrd(data){
        this.appMainService.isShowSpinner("bulkimport");
        let passedData = [];
        for (let dt of data) {
            const present = this.systemTrackingData?.find((depOb) => depOb.serialNo == dt.serialNo);
            if (!present && this.serialConfig?.enabled && !this.serialConfig?.childInventorySettings[0]?.enabled) {
                this.appMainService.isHideSpinner("bulkimport");
                this.messageService.add({
                    severity: Severity.Error,
                    summary: this.titlecasePipe.transform(Severity.Error),
                    detail: "Uploaded file has serialNo which is not associated with any product under order, please check and update.",
                });
                return;
            } else{
                passedData.push(dt);
            }
        }
       
        const invoiceId = this.selectedChannel?.name == this.soChannel.INVOICING ? this.invoicingDetails.id : 0;
        const creditId = this.selectedChannel?.name == this.soChannel.CREDIT_MEMO ? this.selectedRowData.id : 0;
        const orderId = this.selectedChannel?.name == this.soChannel.SALES_ORDER ? this.salesOrderDetails.id : 0;
        const warehouseId = this.selectedChannel?.name == this.soChannel.CREDIT_MEMO ? this.creditMemoDetails?.warehouseId : this.selectedChannel?.name == this.soChannel.SALES_ORDER ? this.salesOrderDetails?.warehouseId : this.invoicingDetails?.warehouseId;
       
        this.salesOrderService.bulkImportSerials(orderId, invoiceId, creditId, warehouseId, passedData).subscribe((res) => {  
            this.appMainService.isHideSpinner("bulkimport");
            this.disabledSave = false;
            this.displayImport = false;
            this.messageService.add({
                severity: Severity.Success,
                summary: this.titlecasePipe.transform(Severity.Success),
                detail: "Bulk serialNo import completed, removed duplicate Serial No.",
            });
        });
    }

    checkSerialNoInSystem(productId, warehouseId, orderId) {
        this.salesOrderService.checkSerialNoInSystem(orderId, warehouseId, productId).subscribe((data) => {
            this.systemTrackingData = data;
        });
    }

    saveScannedSerials(data) {
        this.appMainService.isShowSpinner("bulkscan");
        const invoiceId = this.selectedChannel?.name == this.soChannel.INVOICING ? this.invoicingDetails.id : 0;
        const creditId = this.selectedChannel?.name == this.soChannel.CREDIT_MEMO ? this.selectedRowData.id : 0;
        const orderId = this.selectedChannel?.name == this.soChannel.SALES_ORDER ? this.salesOrderDetails.id : 0;
        const warehouseId = this.selectedChannel?.name == this.soChannel.CREDIT_MEMO ? this.creditMemoDetails?.warehouseId : this.selectedChannel?.name == this.soChannel.SALES_ORDER ? this.salesOrderDetails?.warehouseId : this.invoicingDetails?.warehouseId;
        this.salesOrderService.bulkScannederials(orderId, invoiceId, creditId, warehouseId, data).subscribe((res) => {
            this.appMainService.isHideSpinner("bulkscan");
            this.displayImport = false;
            this.messageService.add({
                severity: Severity.Success,
                summary: this.titlecasePipe.transform(Severity.Success),
                detail: "Bulk scanned serialNo import completed.",
            });
        });
    }

    //#region Convert RMA

    convertRMAToSalesOrder({ id }) {
        this.orderHeader = "Convert To Sales Order";
        this.selectedId = null;
        this.estimateTemplates = this.templates.filter((t) => t.typeId == 3)[0];
        this.estimatesSections = this.allSections.filter((s) => s.typeId == 3 && s.isActive == true);
        this.displayConvertToSalesOrder = true;
        this.salesOrderDialogType = DialogType.CONVERT_FROM_RMA;
    }

    convertRMAToInvoice({ id }) {
        this.invoicingHeader = "Convert To Invoice";
        this.selectedId = null;
        this.estimateTemplates = this.templates.filter((t) => t.typeId == 4)[0];
        this.estimatesSections = this.allSections.filter((s) => s.typeId == 4 && s.isActive == true);
        this.displayInvoicingAdd = true;
        this.invoicingDialogType = DialogType.CONVERT_FROM_RMA;
    }

    convertRMAToCreditMemo({ id }) {
        this.creditMemoDialogHeader = "Convert To Credit Memo";
        this.selectedId = null;
        this.estimateTemplates = this.templates.filter((t) => t.typeId == 6)[0];
        this.estimatesSections = this.allSections.filter((s) => s.typeId == 6 && s.isActive == true);
        this.displayCreditMemoAdd = true;
        this.creditMemoDialogType = DialogType.CONVERT_FROM_RMA;
    }

    //#endregion Convert RMA

    //Customers
    newCustomer() {
        this.customerHeader = "Create New Customer";
        this.displayCustomerAdd = true;
        this.showAccountInfoMore = false;
    }
    newAddress() {
        this.addressHeader = "Add New Address";
        this.addressTemp = {
            id: 0,
            name: "",
            address1: "",
            address2: "",
            countryId: 0,
            country: {
                id: 0,
                name: "",
            },
            stateId: 0,
            state: {
                id: 0,
                name: "",
            },
            cityId: 0,
            city: {
                id: 0,
                name: "",
            },
            zipcode: "",
            attnId: 0,
            attn: {
                id: 0,
                name: "",
            },
            isActive: true,
            isDefault: false,
        };
        this.displayAddressAdd = true;
    }
    editAddress(c) {
        this.addressHeader = "Edit Address";
        this.addressTemp = JSON.parse(JSON.stringify(c));
        this.selectedaddrType = this.addrTypeDD.filter((ele) => ele.name == this.addressTemp.name)[0];
        this.displayAddressAdd = true;
    }
    saveAddressAdd() {
        this.addressTemp.id = this.customerTemp.address.length + 1;
        this.addressTemp.name = this.selectedaddrType.name;
        this.customerTemp.address.push(this.addressTemp);
        this.displayAddressAdd = false;
    }
    setDefaultAddr(c) {
        if (c.isDefault) {
            this.customerTemp.address.forEach((element) => {
                if (element.id != c.id && element.name == c.name) {
                    element.isDefault = false;
                }
            });
        }
    }

    /** MenuBar */
    buildMenuBar(view, i) {
        this.selectedView = view;
        if (this.selectedView == "list") {
            this.estimatesCols = this.estimatesColsAll;
            this.ordersCols = this.ordersColsAll;
        }
        this.globalFilterInput = "";
        if (this.selectedChannel?.name == "Customers") {
            this.menuItems = [
                {
                    label: "New",
                    icon: "pi pi-plus",
                    command: (event) => this.newCustomer(),
                },
                {
                    label: "Settings",
                    icon: "pi pi-cog ",
                    command: (event) => this.settings(),
                },
            ];
        } else if (this.selectedChannel?.name == this.soChannel.ESTIMATES) {
            this.menuItems = [
                {
                    label: "New",
                    icon: "pi pi-plus",
                    command: (event) => this.newEstimate(),
                },
                {
                    label: "Settings",
                    icon: "pi pi-cog ",
                    command: (event) => this.settings(),
                },
            ];
        } else if (this.selectedChannel?.name == this.soChannel.SALES_RECEIPT) {
            this.menuItems = [
                {
                    label: "New",
                    icon: "pi pi-plus",
                    command: (event) => this.newReceivePayment(),
                },
                {
                    label: "Settings",
                    icon: "pi pi-cog ",
                    command: (event) => this.settings(),
                },
            ];
        } else if (this.selectedChannel?.name == this.soChannel.SALES_ORDER) {
            this.menuItems = [
                {
                    label: "New",
                    icon: "pi pi-plus",
                    command: (event) => this.newOrder(),
                },
                {
                    label: "Settings",
                    icon: "pi pi-cog ",
                    command: (event) => this.settings(),
                },
            ];
        } else if (this.selectedChannel?.name == this.soChannel.INVOICING) {
            this.menuItems = [
                {
                    label: "Settings",
                    icon: "pi pi-cog ",
                    command: (event) => this.settings(),
                },
            ];
        } else if (this.selectedChannel?.name == this.soChannel.CUSTOMER_RETURNS) {
            this.menuItems = [
                {
                    label: "New",
                    icon: "pi pi-plus",
                    command: (event) => this.newReturn(),
                },
                {
                    label: "Settings",
                    icon: "pi pi-cog ",
                    command: (event) => this.settings(),
                },
            ];
        } else if (this.selectedChannel?.name == this.soChannel.CREDIT_MEMO) {
            this.menuItems = [
                {
                    label: "New",
                    icon: "pi pi-plus",
                    // command: (event) => this.newCredit(),
                    command: (event) => this.newCreditMemo(),
                },
                {
                    label: "Settings",
                    icon: "pi pi-cog ",
                    command: (event) => this.settings(),
                },
            ];
        }
    }
    newReceivePayment() {
        this.selectedId = null;
        this.displayInvoiceReceive = true;
        this.receivePaymentDialogType = ReceivePaymentDialogType.MultiPayment;
    }
    /** Cols */
    buildStaticCols() {
        this.customersCols2 = [
            {
                field: "id",
                header: "ID",
                show: false,
                value: "",
                checked: false,
                order: false,
                showIcon: false,
            },
            {
                field: "vendorId",
                header: "Customer Id",
                show: true,
                value: "",
                checked: true,
                order: false,
                showIcon: true,
            },
            {
                field: "name",
                header: "Customer Name",
                show: true,
                value: "",
                checked: true,
                order: false,
                showIcon: true,
            },
            {
                field: "status",
                header: "Status",
                show: true,
                value: "",
                checked: true,
                order: false,
                showIcon: true,
            },
            {
                field: "contact",
                header: "Customer Contact",
                show: true,
                value: "",
                checked: true,
                order: false,
                showIcon: true,
            },
            {
                field: "phone",
                header: "Customer Phone No.",
                show: true,
                value: "",
                checked: true,
                order: false,
                showIcon: true,
            },
            {
                field: "email",
                header: "Customer Email",
                show: true,
                value: "",
                checked: true,
                order: false,
                showIcon: true,
            },
            {
                field: "amount",
                header: "Open PO Amount",
                show: true,
                value: "",
                checked: true,
                order: false,
                showIcon: true,
            },
        ];
        this.customersCols = [
            {
                field: "id",
                header: "ID",
                show: false,
                value: "",
                checked: false,
                order: false,
                showIcon: false,
            },
            {
                field: "vendorId",
                header: "Customer Id",
                show: true,
                value: "",
                checked: true,
                order: false,
                showIcon: true,
            },
            {
                field: "name",
                header: "Customer Name",
                show: true,
                value: "",
                checked: true,
                order: false,
                showIcon: true,
            },
            {
                field: "status",
                header: "Status",
                show: true,
                value: "",
                checked: true,
                order: false,
                showIcon: true,
            },
            {
                field: "contact",
                header: "Customer Contact",
                show: true,
                value: "",
                checked: true,
                order: false,
                showIcon: true,
            },
            {
                field: "phone",
                header: "Customer Phone No.",
                show: true,
                value: "",
                checked: true,
                order: false,
                showIcon: true,
            },
            {
                field: "email",
                header: "Customer Email",
                show: true,
                value: "",
                checked: true,
                order: false,
                showIcon: true,
            },
            {
                field: "amount",
                header: "Open PO Amount",
                show: true,
                value: "",
                checked: true,
                order: false,
                showIcon: true,
            },
        ];
        this.customersColsAll = JSON.parse(JSON.stringify(this.customersCols));
    }
    isClosingStatementDate(event : string) {
        this.statementMessage = event ;
    }
    /** Menus */
    buildMenu() {
        this.configMenuItemsCustomer = [
            {
                label: "View",
                icon: "pi pi-list",
                command: () => { },
            },
            {
                label: "Edit",
                icon: "pi pi-pencil",
                command: () => { },
            },
            {
                label: "Delete",
                icon: "pi pi-trash",
                command: () => { },
            },
        ];
        this.configMenuItemsReturns = [
            {
                label: "View",
                icon: "pi pi-list",
                command: () => {
                    this.showViewCustomerReturn({ id: this.selectedReturn?.id });
                },
            },
            {
                label: "Edit",
                icon: "pi pi-pencil",
                command: () => {
                    this.showEditCustomerReturn({ id: this.selectedReturn?.id });
                },
            },
            {
                label: "Delete",
                icon: "pi pi-trash",
                command: () => {
                    this.deleteCustomerReturn(this.selectedReturn?.id, "delete");
                },
            },
        ];
        this.configMenuItemsCredit = [
            {
                label: "Edit",
                icon: "pi pi-pencil",
                command: () => {
                    this.showEditCreditMemo({ id: this.selectedRowData.id });
                },
            },
            {
                label: "View",
                icon: "pi pi-list",
                command: () => {
                    this.showViewCreditMemo({
                        id: this.selectedRowData.id,
                    });
                },
            },
            {
                label: "Copy",
                icon: "pi pi-list",
                command: () => {
                    this.showCopyCreditMemo({
                        id: this.selectedRowData.id,
                    });
                },
            },
            {
                label: "Delete",
                icon: "pi pi-trash",
                command: () => {
                    this.deleteCreditMemo({ id: this.selectedRowData.id });
                },
            },
            {
                label: "Void",
                icon: "pi pi-ban",
                command: () => {
                    this.isCreditVoid = true;
                    this.showEditCreditMemo({ id: this.selectedRowData.id });
                },
            },
            {
                label: "Print",
                icon: "pi pi-print",
                items: [
                    {
                        label: "Print",
                        icon: "pi pi-print",
                        command: () => {
                            this.printPreview({ id: this.selectedRowData.id });
                        },
                    },
                ],
            },
            {
                label: "Email",
                icon: "pi pi-envelope",
                command: () => {
                    this.sendEmail({ id: this.selectedRowData.id });
                },
            },
        ];
        this.configMenuItemsSalesReceipt = [
            {
                label: "Edit",
                icon: "pi pi-pencil",
                command: () => {
                    this.showEditCreditMemo({ id: this.selectedRowData.id });
                },
            },
            {
                label: "View",
                icon: "pi pi-list",
                command: () => {
                    this.showViewCreditMemo({
                        id: this.selectedRowData.id,
                    });
                },
            },
            {
                label: "Copy",
                icon: "pi pi-list",
                command: () => {
                    this.showCopyCreditMemo({
                        id: this.selectedRowData.id,
                    });
                },
            },
            {
                label: "Delete",
                icon: "pi pi-trash",
                command: () => {
                    this.deleteCreditMemo({ id: this.selectedRowData.id });
                },
            },
            {
                label: "Void",
                icon: "pi pi-ban",
                command: () => {
                    this.isCreditVoid = true;
                    this.showEditCreditMemo({ id: this.selectedRowData.id });
                },
            },
            {
                label: "Print",
                icon: "pi pi-print",
                items: [
                    {
                        label: "Print",
                        icon: "pi pi-print",
                        command: () => {
                            this.printPreview({ id: this.selectedRowData.id });
                        },
                    },
                ],
            },
            {
                label: "Email",
                icon: "pi pi-envelope",
                command: () => {
                    this.sendEmail({ id: this.selectedRowData.id });
                },
            },
        ];
    }

    /** Estimate Context Menu */
    buildEstimatesContextMenu() {
        this.configMenuItemsCM = [
            {
                label: "Copy",
                icon: "pi pi-copy",
                visible:  this.selectedEstimate?.estimateStatusId != EstimateNewStatus.Void,
                command: () => {
                    this.showCopyEstimate({ id: this.selectedEstimate.id });
                },
            },
            {
                label: "View",
                icon: "pi pi-list",
                command: () => {
                    this.showViewEstimate({
                        id: this.selectedEstimate.id,
                    });
                },
            },
            {
                label: "Edit",
                icon: "pi pi-pencil",
                visible: this.selectedEstimate?.estimateStatusId != EstimateNewStatus.Void 
                            && [ApprovalStatus.Default, ApprovalStatus.Pending, ApprovalStatus.Approved].includes(this.selectedEstimate?.approvalStatusId),
                command: () => {
                    this.showEditEstimate({ id: this.selectedEstimate.id });
                },
            },
            {
                label: "Delete",
                icon: "pi pi-trash",
                visible: this.selectedEstimate?.estimateStatusId != EstimateNewStatus.Void,
                command: () => {
                    this.deleteEstimate({ id: this.selectedEstimate.id });
                },
            },
            {
                label: "Void",
                icon: "pi pi-ban",
                visible: !this.selectedEstimate?.isEstimateApproved && this.selectedEstimate?.estimateStatusId != EstimateNewStatus.Void,
                command: () => {
                    this.isEstimateVoid = true;
                    this.voidEstimate({ id: this.selectedEstimate.id });
                },
            },
            {
                label: "Convert to Sales Order",
                icon: "pi pi-pencil",
                visible: !this.selectedEstimate?.isEstimateApproved && this.selectedEstimate?.statusId != Status.InActive && this.selectedEstimate?.estimateStatusId != EstimateNewStatus.Void 
                            && ([ApprovalStatus.Default, ApprovalStatus.Approved].includes(this.selectedEstimate?.approvalStatusId) && this.selectedEstimate?.estimateStatusId != EstimateNewStatus.Rejected && this.selectedEstimate?.estimateStatusId != EstimateNewStatus.Denied),
                command: () => {
                    this.convertToSalesOrder({
                        id: this.selectedEstimate.id,
                    });
                },
            },
            {
                label: "Convert to Invoice",
                icon: "pi pi-pencil",
                visible: !this.selectedEstimate?.isEstimateApproved && this.selectedEstimate?.statusId != Status.InActive && this.selectedEstimate?.estimateStatusId != EstimateNewStatus.Void 
                            && ([ApprovalStatus.Default, ApprovalStatus.Approved].includes(this.selectedEstimate?.approvalStatusId) && this.selectedEstimate?.estimateStatusId != EstimateNewStatus.Rejected && this.selectedEstimate?.estimateStatusId != EstimateNewStatus.Denied),
                command: () => {
                    this.convertToInvoice({ id: this.selectedEstimate.id });
                },
            },
            {
                label: "Print",
                icon: "pi pi-print",
                command: () => {
                    this.printPreview({
                        id: this.selectedEstimate.id,
                    });
                },
            },
            {
                label: "Email",
                icon: "pi pi-envelope",
                command: () => {
                    this.sendEmail({
                        id: this.selectedEstimate.id,
                    });
                },
            },
        ];
    }
    onUpdateEstimateBuildContextMenu(estimateStatusId = 1, approved = false, statusId = 1, approvalStatusId) {
        this.configMenuItemsCM = [
            {
                label: "Copy",
                icon: "pi pi-copy",
                visible:  estimateStatusId != EstimateNewStatus.Void,
                command: () => {
                    this.showCopyEstimate({ id: this.selectedEstimate.id });
                },
            },
            {
                label: "View",
                icon: "pi pi-list",
                command: () => {
                    this.showViewEstimate({
                        id: this.selectedEstimate.id,
                    });
                },
            },
            {
                label: "Edit",
                icon: "pi pi-pencil",
                visible: estimateStatusId != EstimateNewStatus.Void 
                            && [ApprovalStatus.Default, ApprovalStatus.Pending, ApprovalStatus.Approved].includes(approvalStatusId),
                command: () => {
                    this.showEditEstimate({ id: this.selectedEstimate.id });
                },
            },
            {
                label: "Delete",
                icon: "pi pi-trash",
                visible: estimateStatusId != EstimateNewStatus.Void,
                command: () => {
                    this.deleteEstimate({ id: this.selectedEstimate.id });
                },
            },
            {
                label: "Void",
                icon: "pi pi-ban",
                visible: !approved && estimateStatusId != EstimateNewStatus.Void,
                command: () => {
                    this.isEstimateVoid = true;
                    this.voidEstimate({ id: this.selectedEstimate.id });
                },
            },
            {
                label: "Convert to Sales Order",
                icon: "pi pi-pencil",
                visible: !approved && statusId != Status.InActive && estimateStatusId != EstimateNewStatus.Void 
                            && [ApprovalStatus.Default, ApprovalStatus.Approved].includes(approvalStatusId) && estimateStatusId != EstimateNewStatus.Rejected && estimateStatusId != EstimateNewStatus.Denied,
                command: () => {
                    this.convertToSalesOrder({
                        id: this.selectedEstimate.id,
                    });
                },
            },
            {
                label: "Convert to Invoice",
                icon: "pi pi-pencil",
                visible: !approved && statusId != Status.InActive && estimateStatusId != EstimateNewStatus.Void 
                            && [ApprovalStatus.Default, ApprovalStatus.Approved].includes(approvalStatusId) && estimateStatusId != EstimateNewStatus.Rejected && estimateStatusId != EstimateNewStatus.Denied,
                command: () => {
                    this.convertToInvoice({ id: this.selectedEstimate.id });
                },
            },
            {
                label: "Print",
                icon: "pi pi-print",
                command: () => {
                    this.printPreview({
                        id: this.selectedEstimate.id,
                    });
                },
            },
            {
                label: "Email",
                icon: "pi pi-envelope",
                command: () => {
                    this.sendEmail({
                        id: this.selectedEstimate.id,
                    });
                },
            },
        ];
    }
    /** End Estimate Context Menu */

    /** Sales Order Context Menu */
    buildSOContextMenu(stageId, salesOrderStatusId, approvalStatusId) {
        this.configMenuItemsOrders = [
            {
                label: "View",
                icon: "pi pi-list",
                command: () => {
                    this.showViewOrder({ id: this.selectedOrder.id });
                },
            },
            {
                label: "Copy",
                icon: "pi pi-copy",
                visible: salesOrderStatusId != SalesOrderStatus.Void,
                command: () => {
                    this.showCopyOrder({ id: this.selectedOrder.id });
                },
            },
            {
                label: "Edit",
                icon: "pi pi-pencil",
                visible: stageId != SoStageId.Shipped && [ApprovalStatus.Default, ApprovalStatus.Approved].includes(approvalStatusId),
                command: () => {
                    this.showEditOrder({ id: this.selectedOrder.id });
                },
            },
            {
                label: "Delete",
                icon: "pi pi-trash",
                visible: stageId != SoStageId.Shipped,
                command: () => {
                    this.deleteOrder({ id: this.selectedOrder.id });
                },
            },
            {
                label: "Void",
                icon: "pi pi-ban",
                visible: stageId == SoStageId.Shipped && salesOrderStatusId != SalesOrderStatus.Void,
                command: () => {
                    this.isOrderVoid = true;
                    this.voidSalesOrder({ id: this.selectedOrder.id });
                },
            },
            {
                label: "Pick",
                icon: "pi pi-list",
                visible: stageId == SoStageId.Entered && salesOrderStatusId != SalesOrderStatus.Void,
                command: () => {
                    this.moveSalesOrderToNextStage({ stageId: SoStageId.Pick, soId: this.selectedOrder.id });
                },
            },
            {
                label: "Pack",
                icon: "pi pi-list",
                visible: stageId == SoStageId.Pick && salesOrderStatusId != SalesOrderStatus.Void,
                command: () => {
                    this.moveSalesOrderToNextStage({ stageId: SoStageId.Pack, soId: this.selectedOrder.id });
                },
            },
            {
                label: "Verification",
                icon: "pi pi-list",
                visible: stageId == SoStageId.Pack && salesOrderStatusId != SalesOrderStatus.Void,
                command: () => {
                    this.moveSalesOrderToNextStage({ stageId: SoStageId.Verification, soId: this.selectedOrder.id });
                },
            },
            {
                label: "Labelling",
                icon: "pi pi-list",
                visible: stageId == SoStageId.Verification && salesOrderStatusId != SalesOrderStatus.Void,
                command: () => {
                    this.moveSalesOrderToNextStage({ stageId: SoStageId.Labelling, soId: this.selectedOrder.id });
                },
            },
            {
                label: "ReadyToShip",
                icon: "pi pi-list",
                visible: stageId == SoStageId.Labelling && salesOrderStatusId != SalesOrderStatus.Void,
                command: () => {
                    this.moveSalesOrderToNextStage({ stageId: SoStageId.ReadyToShip, soId: this.selectedOrder.id });
                },
            },
            {
                label: "Ship",
                icon: "pi pi-list",
                visible: stageId == SoStageId.ReadyToShip && salesOrderStatusId != SalesOrderStatus.Void,
                command: () => {
                    this.moveSalesOrderToNextStage({ stageId: SoStageId.Shipped, soId: this.selectedOrder.id });
                },
            },
            {
                label: "Print",
                icon: "pi pi-print",
                // visible: stageId != SoStageId.Entered,
                items: [
                    {
                        label: "Print Pick Slip",
                        icon: "pi pi-file",
                        visible: stageId != SoStageId.Entered,
                        command: () => {
                            this.pickSlipPrint({
                                id: this.selectedOrder.id,
                            });
                        },
                    },
                    {
                        label: "Print Pack Slip",
                        icon: "pi pi-file",
                        visible: stageId != SoStageId.Entered && stageId != SoStageId.Pick,
                        command: () => {
                            this.packSlipPrint({
                                id: this.selectedOrder.id,
                            });
                        },
                    },
                    {
                        label: "Print SO",
                        icon: "pi pi-print",
                        // visible: stageId == SoStageId.Shipped,
                        command: () => {
                            this.printPreview({
                                id: this.selectedOrder.id,
                            });
                        },
                    },
                    {
                        label: "Print Invoice",
                        icon: "pi pi-print",
                        visible: stageId == SoStageId.Shipped,
                        command: () => {
                            this.printInvoice({
                                id: this.selectedOrder?.invoiceId,
                            });
                        },
                    },
                ],
            },
            {
                label: "Email",
                icon: "pi pi-envelope",
                // visible: stageId != SoStageId.Entered,
                items: [
                    {
                        label: "Email Pick Slip",
                        icon: "pi pi-envelope",
                        visible: stageId != SoStageId.Entered,
                        command: () => {
                            this.sendEmailFromSO({
                                id: this.selectedOrder.id,
                                type: SOEmailAttachmentType.EMAILPICKSLIP,
                            });
                        },
                    },
                    {
                        label: "Email Pack Slip",
                        icon: "pi pi-envelope",
                        visible: stageId != SoStageId.Entered && stageId != SoStageId.Pick,
                        command: () => {
                            this.sendEmailFromSO({
                                id: this.selectedOrder.id,
                                type: SOEmailAttachmentType.EMAILPACKSLIP,
                            });
                        },
                    },
                    {
                        label: "Email SO",
                        icon: "pi pi-envelope",
                        // visible: stageId == SoStageId.Shipped,
                        command: () => {
                            this.sendEmailFromSO({
                                id: this.selectedOrder.id,
                                type: SOEmailAttachmentType.EMAILSO,
                            });
                        },
                    },
                    {
                        label: "Email Invoice",
                        icon: "pi pi-envelope",
                        visible: stageId == SoStageId.Shipped,
                        command: () => {
                            this.sendEmailFromSO({
                                id: this.selectedOrder.invoiceId,
                                type: SOEmailAttachmentType.EMAILINVOICE,
                            });
                        },
                    },
                ],
            },
        ];
    }
    /** End Sales Order Context Menu */

    /** Invoice Context Menu */
    buildInvoiceContextMenu() {
        this.configMenuItemsInvoicing = [
            {
                label: "View",
                icon: "pi pi-list",
                command: () => {
                    this.showViewInvoicing({
                        id: this.selectedInvoicing.id,
                    });
                },
            },
            {
                label: "Copy",
                icon: "pi pi-copy",
                visible: this.selectedInvoicing.statusId != InvoiceStatus.Void,
                command: () => {
                    this.showCopyInvoicing({
                        id: this.selectedInvoicing.id,
                    });
                },
            },
            {
                label: "Edit",
                icon: "pi pi-pencil",
                visible: this.selectedInvoicing.statusId != InvoiceStatus.Void && [ApprovalStatus.Default, ApprovalStatus.Approved].includes(this.selectedInvoicing.approvalStatusId),
                command: () => {
                    this.showEditInvoicing({
                        id: this.selectedInvoicing.id,
                    });
                },
            },
            {
                label: "Delete",
                icon: "pi pi-trash",
                // visible: this.selectedInvoicing.statusId != InvoiceStatus.Void,
                command: () => {
                    this.deleteInvoicing({ id: this.selectedInvoicing.id });
                },
            },
            {
                label: "Void",
                icon: "pi pi-ban",
                visible: this.selectedInvoicing.statusId != InvoiceStatus.Void,
                command: () => {
                    this.isInvoicingVoid = true;
                    this.voidInvoice({
                        id: this.selectedInvoicing.id,
                    });
                },
            },
            {
                label: "Move to Completed",
                icon: "pi pi-list",
                visible: this.selectedInvoicing.statusId == 1 && this.selectedInvoicing.isActive == Status.Active && [ApprovalStatus.Default, ApprovalStatus.Approved].includes(this.selectedInvoicing.approvalStatusId),
                command: () => {
                    this.updateInvoiceStatus({
                        id: this.selectedInvoicing.id,
                    });
                },
            },
            {
                label: "Receive Payments",
                icon: "pi pi-list",
                visible: this.selectedInvoicing.statusId == 2 && this.selectedInvoicing.dueAmt > 0 && [ApprovalStatus.Default, ApprovalStatus.Approved].includes(this.selectedInvoicing.approvalStatusId),
                command: () => {
                    this.showReceivePayment({
                        id: this.selectedInvoicing.id,
                    });
                },
            },
            {
                label: "Print",
                icon: "pi pi-print",
                command: () => {
                    this.printInvoice({
                        id: this.selectedInvoicing.id,
                    });
                },
            },
            {
                label: "Email",
                icon: "pi pi-envelope",
                command: () => {
                    this.sendEmail({
                        id: this.selectedInvoicing.id,
                    });
                },
            },
        ];
    }
    onUpdateInvoiceBuildContextMenu(invStatusId = 1, amount = 0, statusId = 1, approvalStatusId) {
        this.configMenuItemsInvoicing = [
            {
                label: "View",
                icon: "pi pi-list",
                command: () => {
                    this.showViewInvoicing({
                        id: this.selectedInvoicing.id,
                    });
                },
            },
            {
                label: "Copy",
                icon: "pi pi-copy",
                visible: invStatusId != InvoiceStatus.Void,
                command: () => {
                    this.showCopyInvoicing({
                        id: this.selectedInvoicing.id,
                    });
                },
            },
            {
                label: "Edit",
                icon: "pi pi-pencil",
                visible: invStatusId != InvoiceStatus.Void && [ApprovalStatus.Default, ApprovalStatus.Approved].includes(approvalStatusId),
                command: () => {
                    this.showEditInvoicing({
                        id: this.selectedInvoicing.id,
                    });
                },
            },
            {
                label: "Delete",
                icon: "pi pi-trash",
                // visible: invStatusId != InvoiceStatus.Void,
                command: () => {
                    this.deleteInvoicing({ id: this.selectedInvoicing.id });
                },
            },
            {
                label: "Void",
                icon: "pi pi-ban",
                visible: invStatusId != InvoiceStatus.Void,
                command: () => {
                    this.isInvoicingVoid = true;
                    this.voidInvoice({
                        id: this.selectedInvoicing.id,
                    });
                },
            },
            {
                label: "Move to Completed",
                icon: "pi pi-list",
                visible: invStatusId == 1 && statusId == Status.Active && [ApprovalStatus.Default, ApprovalStatus.Approved].includes(approvalStatusId),
                command: () => {
                    this.updateInvoiceStatus({
                        id: this.selectedInvoicing.id,
                    });
                },
            },
            {
                label: "Receive Payments",
                icon: "pi pi-list",
                visible: invStatusId == 2 && amount > 0 && [ApprovalStatus.Default, ApprovalStatus.Approved].includes(approvalStatusId),
                command: () => {
                    this.showReceivePayment({
                        id: this.selectedInvoicing.id,
                    });
                },
            },
            {
                label: "Print",
                icon: "pi pi-print",
                command: () => {
                    this.printInvoice({
                        id: this.selectedInvoicing.id,
                    });
                },
            },
            {
                label: "Email",
                icon: "pi pi-envelope",
                command: () => {
                    this.sendEmail({
                        id: this.selectedInvoicing.id,
                    });
                },
            },
        ];
    }

    loadPermissionForGLTab(){
        const userPermissions = this.permissionService.getPermissionData();
        const financeUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.FINANCE);
        this.glTabPermission = financeUserPermission ? (financeUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false
    }
    
    //floatheader
    changeFloatHeader(){
        this.showFloatHeader = false;
        setTimeout(()=>{
            this.showFloatHeader = true;
          }, 300);
    }

    isBaseCurrency(currencyId): boolean {
        return this.baseCurrency?.currencyId == currencyId;
    }

    handleEstimateTabChange(event){
        if(event.index == 1){
            this.glApiCall = true;
        }else{
            this.glApiCall = false;
        }
    }

    handleInvoiceTabChange(event){
        if(event.index == 2){
            this.glApiCall = true;
        }else{
            this.glApiCall = false;
        }
    }
}
